var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g2, _g3, _g4, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _g5, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _g6, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _g7, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _g8, _path133, _g9, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _g0, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _g1, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackendImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 830,
    height: 650,
    viewBox: "0 0 830 650",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M552.494 464.475C548.776 464.547 545.105 463.638 541.85 461.839L511.254 443.318C509.928 442.788 508.794 441.871 507.999 440.685C507.205 439.499 506.787 438.101 506.801 436.674C506.815 435.247 507.26 433.857 508.078 432.687C508.896 431.518 510.048 430.622 511.384 430.119L547.758 408.962C550.999 407.32 554.581 406.465 558.215 406.465C561.848 406.465 565.43 407.32 568.671 408.962L600.277 427.222C603.207 428.85 604.834 431.226 604.834 433.732C604.834 436.238 603.207 438.615 600.277 440.242L562.666 462.034C559.539 463.703 556.038 464.544 552.494 464.475ZM558.207 408.115C554.852 408.05 551.537 408.84 548.572 410.41L512.197 431.568C511.104 431.923 510.15 432.612 509.47 433.539C508.79 434.466 508.419 435.583 508.408 436.732C508.397 437.882 508.748 439.005 509.41 439.945C510.073 440.884 511.013 441.592 512.1 441.967L542.697 460.423C545.64 461.988 548.917 462.823 552.251 462.857C555.584 462.891 558.877 462.123 561.852 460.618L599.463 438.826C601.872 437.443 603.207 435.571 603.207 433.732C603.207 431.893 601.872 430.038 599.463 428.638L567.858 410.394C564.891 408.81 561.569 408.009 558.207 408.067V408.115Z",
    fill: "#EDF0F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M486.287 503.535C482.573 503.604 478.906 502.689 475.66 500.883L445.063 482.378C442.166 480.62 440.587 478.26 440.604 475.738C440.62 473.215 442.231 470.855 445.193 469.228L481.551 448.071C484.794 446.425 488.379 445.567 492.016 445.567C495.653 445.567 499.238 446.425 502.481 448.071L534.087 466.315C537.016 467.942 538.644 470.318 538.644 472.825C538.644 475.331 537.016 477.707 534.07 479.335L496.475 501.127C493.34 502.786 489.833 503.615 486.287 503.535ZM491.967 447.11C488.613 447.045 485.297 447.834 482.332 449.405L445.958 470.562C444.865 470.918 443.911 471.607 443.231 472.534C442.551 473.461 442.179 474.578 442.169 475.727C442.158 476.877 442.508 478 443.171 478.94C443.833 479.879 444.774 480.586 445.86 480.962L476.441 499.418C479.387 500.983 482.667 501.818 486.003 501.852C489.339 501.886 492.635 501.118 495.613 499.613L533.208 477.837C535.633 476.438 536.951 474.582 536.967 472.743C536.984 470.904 535.633 469.033 533.224 467.649L501.732 449.405C498.728 447.815 495.365 447.025 491.967 447.11Z",
    fill: "#EDF0F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M294.649 609.224C290.93 609.291 287.258 608.376 284.005 606.571L253.425 588.116C250.528 586.374 248.933 584.014 248.965 581.475C248.998 578.937 250.593 576.593 253.555 574.965L289.913 553.808C293.157 552.168 296.742 551.313 300.378 551.313C304.013 551.313 307.598 552.168 310.842 553.808L342.448 572.052C345.378 573.761 346.989 576.056 346.989 578.562C346.989 581.069 345.362 583.445 342.432 585.072L304.837 606.864C301.697 608.504 298.19 609.317 294.649 609.224ZM300.378 552.848C297.016 552.78 293.693 553.575 290.727 555.159L254.369 576.316C253.275 576.671 252.321 577.361 251.641 578.288C250.961 579.215 250.59 580.332 250.579 581.481C250.568 582.63 250.919 583.754 251.581 584.693C252.244 585.633 253.185 586.34 254.271 586.716L284.851 605.172C287.799 606.733 291.078 607.566 294.414 607.6C297.749 607.634 301.044 606.868 304.023 605.367L341.618 583.575C344.043 582.175 345.362 580.32 345.362 578.481C345.362 576.642 344.043 574.77 341.635 573.387L310.029 555.143C307.061 553.565 303.738 552.775 300.378 552.848Z",
    fill: "#EDF0F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M226.626 649.993C222.908 650.064 219.237 649.155 215.982 647.356L185.385 628.9C182.488 627.143 180.91 624.783 180.926 622.244C181.053 620.852 181.544 619.518 182.35 618.375C183.155 617.232 184.247 616.322 185.515 615.734L221.89 594.577C225.13 592.931 228.713 592.074 232.346 592.074C235.98 592.074 239.563 592.931 242.803 594.577L274.409 612.821C277.355 614.448 278.966 616.824 278.966 619.331C278.966 621.837 277.338 624.213 274.409 625.841L236.798 647.633C233.664 649.274 230.162 650.086 226.626 649.993ZM232.355 593.633C228.995 593.565 225.673 594.355 222.704 595.927L186.329 617.085C185.236 617.44 184.282 618.13 183.602 619.056C182.922 619.983 182.55 621.1 182.54 622.25C182.529 623.399 182.879 624.523 183.542 625.462C184.204 626.401 185.145 627.109 186.232 627.485L216.828 645.94C219.76 647.508 223.026 648.349 226.35 648.394C229.674 648.44 232.961 647.687 235.935 646.201L273.546 624.409C275.955 623.025 277.29 621.154 277.29 619.315C277.29 617.475 275.955 615.62 273.546 614.22L241.94 595.976C238.995 594.397 235.697 593.591 232.355 593.633Z",
    fill: "#EDF0F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M774.242 366.159C770.301 366.239 766.409 365.28 762.968 363.38L730.512 344.046C729.169 343.405 728.024 342.423 727.193 341.201C726.362 339.979 725.874 338.56 725.781 337.091C725.781 334.431 727.508 331.976 730.65 330.271L769.218 308.108C772.661 306.393 776.463 305.5 780.319 305.5C784.175 305.5 787.977 306.393 791.42 308.108L824.947 327.236C828.055 328.941 829.781 331.43 829.781 334.056C829.781 336.681 828.055 339.171 824.93 340.875L785.049 363.687C781.719 365.407 777.999 366.258 774.242 366.159ZM780.405 307.102C776.846 307.038 773.328 307.872 770.185 309.523L731.599 331.686C730.44 332.058 729.428 332.781 728.706 333.751C727.985 334.722 727.591 335.892 727.579 337.096C727.568 338.3 727.94 339.478 728.643 340.462C729.345 341.446 730.343 342.187 731.496 342.58L763.935 361.914C767.061 363.554 770.54 364.428 774.079 364.464C777.618 364.499 781.114 363.695 784.273 362.118L824.153 339.29C826.725 337.841 828.124 335.88 828.141 333.954C828.158 332.027 826.725 330.083 824.17 328.617L790.643 309.506C787.492 307.86 783.969 307.033 780.405 307.102Z",
    fill: "#EDF0F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_1591_524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L283.81 405.755L483.926 290.219L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint0_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L282.833 405.201L482.965 289.65L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint1_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L281.857 404.632L482.005 289.064L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint2_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L280.88 404.078L481.061 288.494L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint3_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L279.887 403.509L480.101 287.908L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint4_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L278.911 402.939L479.157 287.339L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint5_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L277.934 402.386L478.197 286.753L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint6_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L276.958 401.816L477.253 286.183L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint7_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L275.981 401.247L476.293 285.597L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint8_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L275.005 400.693L475.333 285.028L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint9_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L274.028 400.124L474.389 284.442L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint10_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L273.052 399.554L473.428 283.872L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint11_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L272.075 399.001L472.484 283.286L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint12_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L271.099 398.431L471.524 282.716L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint13_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L270.122 397.861L470.58 282.131L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint14_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L269.146 397.308L469.62 281.561L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint15_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L268.169 396.738L468.66 280.975L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint16_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L267.193 396.169L467.716 280.405L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint17_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L266.2 395.615L466.756 279.82L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint18_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L265.224 395.046L465.812 279.25L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint19_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L264.247 394.476L464.852 278.664L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint20_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L263.271 393.923L463.891 278.094L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint21_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L262.294 393.353L462.947 277.509L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint22_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L261.318 392.8L461.987 276.939L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint23_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L260.341 392.23L461.043 276.353L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint24_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L259.365 391.661L460.083 275.783L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint25_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L258.388 391.107L459.123 275.197L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint26_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L257.412 390.538L458.179 274.628L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint27_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L256.435 389.968L457.219 274.042L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint28_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L255.459 389.415L456.275 273.472L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint29_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L254.482 388.845L455.314 272.886L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint30_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L253.506 388.275L454.354 272.317L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint31_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L252.513 387.722L453.41 271.731L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint32_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L251.536 387.153L452.45 271.161L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint33_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L250.56 386.583L451.506 270.575L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint34_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L249.583 386.03L450.546 270.006L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint35_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L248.607 385.46L449.602 269.42L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint36_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L247.63 384.89L448.642 268.85L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint37_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L246.654 384.337L447.698 268.264L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint38_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L245.677 383.767L446.738 267.695L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint39_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L244.701 383.198L445.777 267.109L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint40_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.283 381.261L243.724 382.644L444.833 266.539L442.294 265.026L241.283 381.261Z",
    fill: "url(#paint41_linear_1591_524)",
    fillOpacity: 0.15
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M241.287 118.161C241.389 116.532 241.869 114.948 242.688 113.536C243.507 112.124 244.643 110.921 246.007 110.024L434.796 0.44488C435.338 0.152859 435.945 0 436.561 0C437.178 0 437.784 0.152859 438.327 0.44488L441.273 1.95845L439.939 258.858C439.845 260.5 439.37 262.099 438.551 263.525C437.731 264.952 436.59 266.168 435.219 267.077L244.217 380.594L241.287 382.303V118.161Z",
    fill: "url(#paint42_linear_1591_524)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M244.227 120.309C244.329 118.68 244.808 117.097 245.627 115.684C246.446 114.272 247.583 113.07 248.946 112.172L438.158 2.23493C440.746 0.721368 442.878 1.95826 442.878 4.96912V265.237L244.227 380.594V120.309Z",
    fill: "#110B2B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M248.963 112.107L438.158 2.23493C440.746 0.721368 442.878 1.95826 442.878 4.96912V17.3055L244.227 132.662V120.309C244.32 118.667 244.798 117.07 245.62 115.646C246.443 114.221 247.587 113.009 248.963 112.107Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M271.999 106.639C272.846 106.15 273.627 106.541 273.627 107.534C273.586 108.076 273.417 108.6 273.134 109.064C272.851 109.528 272.462 109.918 271.999 110.203C271.153 110.691 270.453 110.203 270.453 109.308C270.485 108.773 270.641 108.253 270.91 107.79C271.178 107.326 271.551 106.932 271.999 106.639Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M265.226 110.61C266.072 110.121 266.772 110.61 266.772 111.505C266.743 112.042 266.588 112.565 266.319 113.032C266.05 113.498 265.676 113.895 265.226 114.19C264.38 114.678 263.68 114.19 263.68 113.295C263.709 112.758 263.864 112.234 264.133 111.768C264.401 111.302 264.776 110.905 265.226 110.61Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M258.565 114.597C259.411 114.109 260.111 114.597 260.111 115.492C260.079 116.027 259.923 116.547 259.655 117.01C259.386 117.473 259.013 117.868 258.565 118.161C257.719 118.649 256.938 118.259 256.938 117.266C256.978 116.724 257.147 116.2 257.43 115.736C257.713 115.272 258.102 114.881 258.565 114.597Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M427.264 47.3005V122.474L261.406 217.91V143.225L427.264 47.3005Z",
    fill: "#5A3CFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M427.492 218.04V223.802L261.406 320.296V314.567L427.492 218.04Z",
    fill: "#EDF0F8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M427.492 233.664V239.426L261.406 335.92V330.191L427.492 233.664Z",
    fill: "#EDF0F8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M427.492 250.053V255.831L261.406 352.325V346.596L427.492 250.053Z",
    fill: "#EDF0F8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M427.267 133.948V193.905L379.582 222.012V162.429L427.267 133.948Z",
    fill: "#5A3CFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M309.092 202.107V262.064L261.406 290.17V230.604L309.092 202.107Z",
    fill: "#5A3CFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M368.173 168.223V228.18L320.504 256.27V196.704L368.173 168.223Z",
    fill: "#5A3CFF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1591_524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L517.972 244.818L532.765 236.274L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint43_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L517.613 244.607L532.391 236.063L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint44_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L517.239 244.395L532.033 235.851L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint45_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L516.865 244.184L531.659 235.639L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint46_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L516.507 243.972L531.301 235.428L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint47_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L516.132 243.761L530.926 235.216L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint48_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L515.758 243.549L530.568 235.005L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint49_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L515.4 243.337L530.194 234.793L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint50_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L515.026 243.142L529.82 234.582L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint51_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L514.668 242.931L529.462 234.37L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint52_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L514.293 242.719L529.087 234.158L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint53_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L513.919 242.507L528.729 233.947L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint54_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L513.561 242.296L528.355 233.735L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint55_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L513.187 242.084L527.997 233.524L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint56_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L512.829 241.873L527.623 233.312L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint57_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L512.454 241.661L527.264 233.101L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint58_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L512.08 241.45L526.89 232.889L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint59_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L511.722 241.238L526.516 232.677L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint60_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L511.348 241.026L526.158 232.466L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint61_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L510.973 240.815L525.783 232.254L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint62_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L510.615 240.603L525.425 232.043L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint63_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L510.241 240.392L525.051 231.815L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint64_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L509.883 240.196L524.693 231.603L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint65_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L509.509 239.985L524.319 231.392L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint66_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L509.134 239.773L523.944 231.18L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint67_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L508.776 239.562L523.586 230.969L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint68_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L508.402 239.35L523.212 230.757L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint69_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L508.044 239.139L522.854 230.545L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint70_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L507.669 238.927L522.48 230.334L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint71_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L507.295 238.715L522.122 230.122L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint72_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L506.937 238.504L521.747 229.911L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint73_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L506.563 238.292L521.373 229.699L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint74_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L506.189 238.081L521.015 229.488L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint75_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L505.83 237.869L520.641 229.276L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint76_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L505.456 237.658L520.283 229.064L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint77_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L505.098 237.446L519.908 228.853L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint78_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L504.724 237.251L519.55 228.641L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint79_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L504.349 237.039L519.176 228.43L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint80_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L503.991 236.828L518.802 228.218L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint81_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L503.617 236.616L518.444 228.007L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint82_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L503.243 236.404L518.069 227.795L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint83_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.055 235.721L502.885 236.193L517.711 227.583L516.914 227.128L502.055 235.721Z",
    fill: "url(#paint84_linear_1591_524)",
    fillOpacity: 0.15
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1591_524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L542.048 230.838L556.842 222.294L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint85_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L541.69 230.627L556.484 222.082L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint86_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L541.315 230.415L556.109 221.871L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint87_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L540.941 230.203L555.751 221.659L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint88_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L540.583 229.992L555.377 221.448L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint89_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L540.209 229.78L555.003 221.236L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint90_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L539.851 229.569L554.644 221.024L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint91_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L539.476 229.357L554.27 220.813L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint92_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L539.102 229.146L553.912 220.601L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint93_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L538.744 228.934L553.538 220.39L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint94_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L538.37 228.722L553.18 220.178L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint95_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L537.995 228.511L552.805 219.967L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint96_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L537.637 228.299L552.431 219.755L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint97_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L537.263 228.104L552.073 219.543L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint98_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L536.905 227.892L551.699 219.332L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint99_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L536.53 227.681L551.341 219.104L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint100_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L536.156 227.469L550.966 218.892L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint101_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L535.798 227.258L550.608 218.681L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint102_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L535.424 227.046L550.234 218.469L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint103_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L535.049 226.835L549.86 218.258L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint104_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L534.691 226.623L549.502 218.046L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint105_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L534.317 226.411L549.127 217.835L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint106_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L533.959 226.2L548.769 217.623L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint107_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L533.585 225.988L548.395 217.411L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint108_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L533.21 225.777L548.037 217.2L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint109_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L532.852 225.581L547.663 216.988L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint110_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L532.478 225.354L547.288 216.777L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint111_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L532.12 225.158L546.93 216.565L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint112_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L531.746 224.947L546.556 216.354L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint113_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L531.371 224.735L546.198 216.142L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint114_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L531.013 224.524L545.823 215.93L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint115_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L530.639 224.312L545.465 215.719L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint116_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L530.265 224.1L545.091 215.507L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint117_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L529.907 223.889L544.717 215.296L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint118_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L529.532 223.677L544.359 215.084L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint119_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L529.174 223.466L543.984 214.873L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint120_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L528.8 223.254L543.626 214.661L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint121_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L528.426 223.043L543.252 214.449L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint122_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L528.068 222.831L542.894 214.238L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint123_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L527.693 222.636L542.52 214.026L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint124_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L527.335 222.408L542.145 213.815L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint125_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.131 221.724L526.961 222.212L541.787 213.603L540.99 213.131L526.131 221.724Z",
    fill: "url(#paint126_linear_1591_524)",
    fillOpacity: 0.15
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1591_524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L566.462 217.216L581.256 208.671L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint127_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L566.088 217.004L580.882 208.46L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint128_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L565.714 216.793L580.508 208.248L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint129_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L565.356 216.581L580.15 208.037L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint130_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L564.981 216.369L579.775 207.825L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint131_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L564.607 216.158L579.417 207.614L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint132_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L564.249 215.946L579.043 207.402L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint133_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L563.875 215.751L578.685 207.19L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint134_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L563.517 215.539L578.311 206.979L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint135_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L563.142 215.328L577.936 206.767L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint136_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L562.768 215.116L577.578 206.556L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint137_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L562.41 214.905L577.204 206.344L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint138_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L562.036 214.693L576.846 206.133L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint139_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L561.678 214.482L576.471 205.921L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint140_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L561.303 214.27L576.113 205.709L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint141_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L560.929 214.058L575.739 205.498L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint142_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L560.571 213.847L575.381 205.286L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint143_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L560.197 213.635L575.007 205.075L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint144_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L559.839 213.424L574.632 204.863L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint145_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L559.464 213.212L574.274 204.652L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint146_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L559.09 213.017L573.9 204.44L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint147_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L558.732 212.805L573.542 204.228L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint148_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L558.358 212.594L573.168 204.017L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint149_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L557.983 212.382L572.81 203.805L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint150_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L557.625 212.171L572.435 203.577L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint151_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L557.251 211.959L572.061 203.366L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint152_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L556.893 211.747L571.703 203.17L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint153_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L556.518 211.536L571.329 202.959L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint154_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L556.144 211.324L570.971 202.731L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint155_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L555.786 211.113L570.596 202.519L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint156_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L555.412 210.901L570.222 202.308L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint157_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L555.054 210.689L569.864 202.096L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint158_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L554.679 210.478L569.49 201.885L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint159_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L554.305 210.266L569.131 201.673L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint160_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L553.947 210.071L568.757 201.462L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint161_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L553.573 209.859L568.399 201.25L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint162_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L553.198 209.648L568.025 201.038L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint163_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L552.84 209.436L567.667 200.827L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint164_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L552.466 209.225L567.292 200.615L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint165_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L552.108 209.013L566.918 200.404L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint166_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L551.734 208.802L566.56 200.192L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint167_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.529 208.118L551.359 208.59L566.186 199.981L565.405 199.525L550.529 208.118Z",
    fill: "url(#paint168_linear_1591_524)",
    fillOpacity: 0.15
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M535.424 78.6683L550.527 69.9449L565.272 78.6683L550.527 87.3916L535.424 78.6683Z",
    fill: "#F8F9FC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M535.424 78.668V199.9L550.527 208.151V87.3913L535.424 78.668Z",
    fill: "#E5E9F4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M565.274 78.668V199.428L550.529 208.151V87.3913L565.274 78.668Z",
    fill: "#EDF0F8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M511.271 134.068L526.375 125.361L541.12 134.068L526.375 142.807L511.271 134.068Z",
    fill: "#5A3CFF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      mixBlendMode: "overlay"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M511.271 134.068L526.375 125.361L541.12 134.068L526.375 142.807L511.271 134.068Z",
    fill: "white"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M511.271 134.068V213.734L526.375 221.985V142.807L511.271 134.068Z",
    fill: "#5A3CFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M541.12 134.068V213.262L526.375 221.985V142.807L541.12 134.068Z",
    fill: "#5A3CFF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12,
    style: {
      mixBlendMode: "overlay"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M541.12 134.068V213.262L526.375 221.985V142.807L541.12 134.068Z",
    fill: "black"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M487.098 119.713L502.217 110.99L516.962 119.713L502.217 128.436L487.098 119.713Z",
    fill: "#EFF1F9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M487.098 119.713V227.567L502.217 235.818V128.436L487.098 119.713Z",
    fill: "#C2CAE8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M516.968 119.713V227.095L502.223 235.818V128.436L516.968 119.713Z",
    fill: "#D6DCEF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M604.5 167.963C618.064 167.963 629.059 161.616 629.059 153.787C629.059 145.959 618.064 139.612 604.5 139.612C590.937 139.612 579.941 145.959 579.941 153.787C579.941 161.616 590.937 167.963 604.5 167.963Z",
    fill: "url(#paint169_radial_1591_524)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M629.899 145.438C629.899 144.868 629.102 144.429 628.142 144.429H624.398C623.78 144.429 622.771 145.08 622.592 144.884C622.413 144.689 622.429 144.185 622.868 143.924L625.521 142.394C626.205 142.004 621.859 142.199 621.16 141.792V138.537C620.774 138.34 620.347 138.237 619.915 138.237C619.482 138.237 619.055 138.34 618.67 138.537L616.017 140.067C615.515 140.325 614.935 140.389 614.389 140.246L613.234 139.969C612.68 139.856 612.322 139.546 612.322 139.205V137.024C612.322 136.47 611.541 136.015 610.565 136.015H604.559C603.583 136.015 602.802 136.47 602.802 137.024V139.172C602.802 139.53 602.395 139.839 601.825 139.969L600.735 140.23C600.191 140.377 599.611 140.319 599.107 140.067L596.454 138.554C596.067 138.361 595.641 138.261 595.209 138.261C594.777 138.261 594.351 138.361 593.964 138.554L593.655 142.15C592.971 142.541 588.984 142.15 589.684 142.476L592.353 144.006C592.776 144.233 592.89 144.608 592.662 144.917C592.434 145.226 591.458 144.494 590.856 144.494H587.08C586.103 144.494 585.322 144.95 585.322 145.503V150.63C585.322 151.183 586.12 151.639 587.08 151.639H589.277V155.87C589.261 155.94 589.261 156.012 589.277 156.082C589.307 156.215 589.366 156.339 589.451 156.446C589.535 156.553 589.643 156.64 589.765 156.7L594.094 159.174C594.567 159.41 595.1 159.501 595.624 159.434C595.941 159.402 596.25 159.314 596.536 159.174L599.205 157.628C599.706 157.368 600.286 157.305 600.832 157.449L601.972 157.725C602.525 157.839 602.883 158.149 602.899 158.49V160.671C602.899 161.224 603.68 161.68 604.657 161.68H610.744C611.72 161.68 612.501 161.224 612.501 160.655V158.507C612.501 158.149 612.892 157.839 613.478 157.725L614.503 157.465C615.048 157.325 615.624 157.383 616.131 157.628L618.783 159.158C619.068 159.299 619.378 159.382 619.695 159.402C620.221 159.463 620.753 159.367 621.225 159.125L625.521 156.651C625.64 156.595 625.745 156.513 625.83 156.412C625.914 156.311 625.975 156.192 626.01 156.065V155.919V151.606H628.158C629.134 151.606 629.915 151.167 629.915 150.597L629.899 145.438ZM616.098 149.702C615.089 152.81 609.588 154.584 604.478 153.445C600.67 152.599 598.342 150.19 599.107 147.912C600.116 144.819 605.698 143.029 610.727 144.168C614.536 145.015 616.863 147.391 616.098 149.702Z",
    fill: "#DCD2F4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M626.046 139.596V136.796H622.107L621.228 136.292C620.841 136.1 620.415 136 619.983 136C619.551 136 619.125 136.1 618.738 136.292L617.876 136.796H612.423V134.843C612.423 134.274 611.642 133.834 610.666 133.834H604.563C603.586 133.834 602.805 134.274 602.805 134.843V136.796H597.239L596.393 136.308C596.007 136.111 595.581 136.008 595.148 136.008C594.715 136.008 594.288 136.111 593.903 136.308L593.089 136.78H589.102V139.482C589.109 139.641 589.162 139.795 589.254 139.925C589.347 140.054 589.474 140.155 589.622 140.214L592.291 141.744H622.839L625.492 140.214C625.621 140.153 625.735 140.062 625.822 139.949C625.91 139.836 625.97 139.704 625.997 139.563L626.046 139.596Z",
    fill: "#DCE1F1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M623.374 146.724H628.158C629.135 146.724 629.916 146.268 629.916 145.715V142.2C629.916 141.646 629.119 141.19 628.158 141.19H624.415C624.16 141.212 623.903 141.174 623.665 141.078C623.428 140.981 623.216 140.83 623.048 140.637C622.916 140.426 622.769 140.225 622.609 140.035C622.365 139.709 622.446 139.335 622.885 139.075L625.538 137.561C625.692 137.514 625.826 137.42 625.921 137.291C626.017 137.162 626.068 137.005 626.068 136.845C626.068 136.685 626.017 136.528 625.921 136.4C625.826 136.271 625.692 136.176 625.538 136.129L621.225 133.655C620.838 133.463 620.412 133.363 619.98 133.363C619.548 133.363 619.122 133.463 618.735 133.655L616.082 135.185C615.58 135.443 615.001 135.507 614.455 135.364L613.299 135.087C612.746 134.973 612.388 134.664 612.388 134.322V132.142C612.388 131.588 611.607 131.133 610.63 131.133H604.56C603.583 131.133 602.802 131.588 602.802 132.142V134.306C602.802 134.648 602.395 134.957 601.826 135.087L600.735 135.348C600.191 135.495 599.612 135.437 599.108 135.185L596.455 133.671C596.068 133.479 595.642 133.379 595.21 133.379C594.778 133.379 594.352 133.479 593.965 133.671L589.668 136.162C589.515 136.208 589.38 136.303 589.285 136.432C589.19 136.561 589.138 136.717 589.138 136.878C589.138 137.038 589.19 137.194 589.285 137.323C589.38 137.452 589.515 137.547 589.668 137.594L592.337 139.124C592.761 139.368 592.874 139.726 592.647 140.035C592.419 140.344 592.321 140.491 592.191 140.702C592.021 140.887 591.811 141.031 591.577 141.121C591.342 141.211 591.09 141.246 590.84 141.223H587.064C586.088 141.223 585.307 141.679 585.307 142.232V145.731C585.307 146.301 586.104 146.74 587.064 146.74H590.808C591.063 146.718 591.32 146.757 591.557 146.853C591.795 146.949 592.006 147.1 592.175 147.294C592.321 147.505 592.451 147.7 592.614 147.896C592.777 148.091 592.777 148.596 592.337 148.856L589.701 150.386C589.553 150.436 589.425 150.532 589.335 150.659C589.244 150.786 589.196 150.938 589.196 151.094C589.196 151.25 589.244 151.402 589.335 151.529C589.425 151.656 589.553 151.751 589.701 151.802L594.03 154.275C594.414 154.469 594.837 154.569 595.267 154.569C595.696 154.569 596.12 154.469 596.504 154.275L599.173 152.746C599.672 152.479 600.255 152.414 600.8 152.567L601.94 152.827C602.493 152.957 602.851 153.266 602.867 153.608V155.773C602.867 156.342 603.648 156.782 604.625 156.782H610.712C611.688 156.782 612.469 156.326 612.469 155.773V153.608C612.469 153.266 612.86 152.957 613.446 152.827L614.471 152.583C615.014 152.438 615.591 152.49 616.099 152.729L618.752 154.259C619.138 154.451 619.565 154.551 619.997 154.551C620.429 154.551 620.855 154.451 621.242 154.259L625.538 151.769C626.222 151.379 626.222 150.744 625.538 150.337L622.869 148.807C622.446 148.563 622.332 148.205 622.56 147.896C622.788 147.587 623.276 146.756 623.374 146.724ZM599.108 143.078C600.117 139.97 605.699 138.196 610.728 139.335C614.536 140.181 616.864 142.59 616.099 144.869C615.09 147.961 609.589 149.751 604.478 148.596C600.67 147.766 598.343 145.389 599.108 143.078Z",
    fill: "#EDF0F8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.0836 540.323C61.5737 536.596 61.5737 530.477 68.0836 526.75C71.7288 524.905 75.7569 523.944 79.8422 523.944C83.9276 523.944 87.9557 524.905 91.6009 526.75C98.1108 530.477 98.1108 536.596 91.6009 540.323C87.9535 542.16 83.9263 543.117 79.8422 543.117C75.7582 543.117 71.731 542.16 68.0836 540.323Z",
    fill: "url(#paint170_radial_1591_524)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2907 530.347C81.3901 526.359 81.3901 519.849 88.2907 515.862C92.1811 513.895 96.4793 512.871 100.839 512.871C105.198 512.871 109.496 513.895 113.387 515.862C120.287 519.849 120.287 526.359 113.387 530.347C109.493 532.305 105.196 533.324 100.839 533.324C96.4809 533.324 92.1837 532.305 88.2907 530.347Z",
    fill: "url(#paint171_radial_1591_524)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.298 518.01C103.789 514.267 103.789 508.245 110.298 504.421C113.946 502.583 117.973 501.626 122.057 501.626C126.141 501.626 130.168 502.583 133.816 504.421C140.326 508.164 140.326 514.267 133.816 518.01C130.168 519.847 126.141 520.804 122.057 520.804C117.973 520.804 113.946 519.847 110.298 518.01Z",
    fill: "url(#paint172_radial_1591_524)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2752 526.75C89.1088 524.341 89.1088 520.403 93.2752 518.01C95.6209 516.822 98.2135 516.203 100.843 516.203C103.473 516.203 106.065 516.822 108.411 518.01C112.577 520.403 112.577 524.341 108.411 526.75C106.062 527.93 103.471 528.544 100.843 528.544C98.2151 528.544 95.6235 527.93 93.2752 526.75Z",
    fill: "#C2CAE8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M111.176 440.347H132.561V510.019C132.478 510.961 132.144 511.864 131.595 512.634C131.045 513.403 130.3 514.012 129.436 514.397C127.09 515.586 124.498 516.205 121.868 516.205C119.239 516.205 116.646 515.586 114.301 514.397C111.566 512.77 110.671 510.573 111.534 508.555L111.176 440.347Z",
    fill: "#5A3CFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5084 521.64H111.536V468.99H90.1504L90.5084 521.64Z",
    fill: "#C2CAE8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M114.301 444.724C110.134 442.316 110.134 438.393 114.301 435.985C116.646 434.796 119.239 434.177 121.868 434.177C124.498 434.177 127.09 434.796 129.436 435.985C133.603 438.393 133.603 442.316 129.436 444.724C127.09 445.912 124.498 446.532 121.868 446.532C119.239 446.532 116.646 445.912 114.301 444.724Z",
    fill: "#6C48FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2752 473.352C89.1088 470.959 89.1088 467.021 93.2752 464.612C95.6209 463.424 98.2135 462.805 100.843 462.805C103.473 462.805 106.065 463.424 108.411 464.612C112.577 467.021 112.577 470.959 108.411 473.352C106.065 474.54 103.473 475.159 100.843 475.159C98.2135 475.159 95.6209 474.54 93.2752 473.352Z",
    fill: "#D6DCEF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4612 537.898C68.3437 535.506 68.3437 531.567 72.4612 529.159C74.7777 527.98 77.3402 527.365 79.9395 527.365C82.5388 527.365 85.1013 527.98 87.4178 529.159C91.5354 531.567 91.5354 535.506 87.4178 537.898C85.1037 539.085 82.5403 539.704 79.9395 539.704C77.3388 539.704 74.7754 539.085 72.4612 537.898Z",
    fill: "#E5E9F4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3795 533.26H90.5044V499.034H69.1191L69.3795 533.26Z",
    fill: "#E5E9F4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2439 503.412C68.0775 501.003 68.0775 497.081 72.2439 494.672C74.5896 493.484 77.1822 492.865 79.8118 492.865C82.4413 492.865 85.0339 493.484 87.3796 494.672C91.546 497.081 91.546 501.003 87.3796 503.412C85.0339 504.6 82.4413 505.219 79.8118 505.219C77.1822 505.219 74.5896 504.6 72.2439 503.412Z",
    fill: "#EDF0F8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M235.251 505.179L0 641.385L0.815466 642.793L236.067 506.587L235.251 505.179Z",
    fill: "#F6F8FB"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M686.836 488.945L480.746 608.027L481.56 609.436L687.65 490.354L686.836 488.945Z",
    fill: "#F6F8FB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M579.006 525.62L373.02 644.882L373.835 646.29L579.821 527.028L579.006 525.62Z",
    fill: "#F6F8FB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M286.952 442.608L59.9121 574.059L60.7276 575.468L287.767 444.016L286.952 442.608Z",
    fill: "#F6F8FB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M657.373 192.5L474.492 298.172L475.306 299.581L658.188 193.909L657.373 192.5Z",
    fill: "#F6F8FB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M703.489 148.607L561.516 230.641L562.33 232.051L704.303 150.016L703.489 148.607Z",
    fill: "#F6F8FB"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1591_524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.778 29.528L405.427 51.0922C404.178 51.9121 403.139 53.0136 402.393 54.3081C401.646 55.6027 401.214 57.0542 401.131 58.5461V142.98L442.778 118.893V29.528Z",
    fill: "url(#paint173_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 29.7558L405.623 51.2061C404.369 52.0237 403.327 53.1271 402.583 54.4258C401.839 55.7245 401.414 57.1813 401.342 58.6763V142.915L442.778 118.893V29.7558Z",
    fill: "url(#paint174_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 29.9674L405.818 51.3201C404.581 52.1272 403.551 53.2133 402.811 54.4909C402.07 55.7685 401.64 57.2021 401.554 58.6763V142.72L442.778 118.893V29.9674Z",
    fill: "url(#paint175_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 30.1952L405.997 51.3526C404.768 52.1608 403.745 53.2456 403.01 54.5202C402.275 55.7948 401.849 57.2237 401.766 58.6926V142.557L442.778 118.893V30.1952Z",
    fill: "url(#paint176_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 30.4068L406.192 51.5642C404.965 52.3603 403.941 53.4332 403.204 54.6966C402.466 55.96 402.035 57.3788 401.945 58.8391V142.508L442.778 118.893V30.4068Z",
    fill: "url(#paint177_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 30.6346L406.388 51.6455C405.167 52.4407 404.151 53.5123 403.421 54.7733C402.692 56.0344 402.269 57.4495 402.189 58.9042V142.378L442.778 118.893V30.6346Z",
    fill: "url(#paint178_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 30.8462L406.567 51.7595C405.354 52.5522 404.344 53.6195 403.62 54.8749C402.897 56.1303 402.479 57.5385 402.4 58.9855V142.264L442.778 118.893V30.8462Z",
    fill: "url(#paint179_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 31.009L406.827 51.8571C405.621 52.6484 404.618 53.7114 403.897 54.9606C403.176 56.2099 402.758 57.6107 402.677 59.0506V142.15L442.778 118.893V31.009Z",
    fill: "url(#paint180_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 31.2856L406.974 51.971C405.773 52.7546 404.773 53.8095 404.055 55.0505C403.337 56.2916 402.921 57.6842 402.84 59.1157V142.02L442.778 118.893V31.2856Z",
    fill: "url(#paint181_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 31.5135L407.136 52.1663C405.946 52.9503 404.955 54.0016 404.243 55.2364C403.531 56.4712 403.117 57.8554 403.035 59.2785V141.988L442.778 118.893V31.5135Z",
    fill: "url(#paint182_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 31.7251L407.332 52.1663C406.144 52.9406 405.156 53.9834 404.446 55.2105C403.736 56.4375 403.325 57.8144 403.247 59.2296V141.76L442.778 118.975V31.7251Z",
    fill: "url(#paint183_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 31.9529L407.527 52.2965C406.344 53.07 405.359 54.1108 404.652 55.335C403.946 56.5591 403.536 57.9322 403.458 59.3436V141.678L442.778 118.991V31.9529Z",
    fill: "url(#paint184_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 32.1645L407.706 52.4105C406.533 53.1808 405.558 54.215 404.857 55.4303C404.156 56.6455 403.749 58.008 403.67 59.4087V141.548L442.729 118.975L442.778 32.1645Z",
    fill: "url(#paint185_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 32.3923L407.901 52.5244C406.732 53.2886 405.758 54.3173 405.06 55.5274C404.362 56.7375 403.958 58.095 403.881 59.4901V141.434L442.778 118.975V32.3923Z",
    fill: "url(#paint186_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 32.6365L408.097 52.6546C406.934 53.4174 405.967 54.4417 405.271 55.6457C404.576 56.8497 404.173 58.1997 404.093 59.5877V141.337L442.778 119.007V32.6365Z",
    fill: "url(#paint187_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 32.8318L408.276 52.736C407.122 53.4937 406.162 54.511 405.472 55.7065C404.783 56.902 404.383 58.2424 404.304 59.6203V141.19L442.778 118.975V32.8318Z",
    fill: "url(#paint188_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 33.0433L408.455 52.8499C407.305 53.6024 406.348 54.6145 405.661 55.8046C404.974 56.9947 404.576 58.3296 404.5 59.7016V141.076L442.762 118.991L442.778 33.0433Z",
    fill: "url(#paint189_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 33.2712L408.601 52.9638C407.457 53.7095 406.505 54.7138 405.82 55.8955C405.136 57.0773 404.74 58.4034 404.663 59.7667V140.962L442.713 118.991L442.778 33.2712Z",
    fill: "url(#paint190_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 33.4828L408.845 53.0126C407.709 53.7603 406.765 54.7636 406.086 55.9421C405.408 57.1206 405.015 58.4416 404.939 59.7993V140.783L442.778 118.942V33.4828Z",
    fill: "url(#paint191_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 33.7106L409.04 53.2405C407.928 53.9802 407.002 54.9677 406.336 56.1255C405.669 57.2833 405.281 58.5798 405.2 59.9132V140.718L442.827 118.991L442.778 33.7106Z",
    fill: "url(#paint192_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 33.9222L409.236 53.2893C408.11 54.0249 407.172 55.0151 406.499 56.1799C405.826 57.3447 405.437 58.6515 405.362 59.9946V140.604L442.795 118.991L442.778 33.9222Z",
    fill: "url(#paint193_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 34.15L409.415 53.4032C408.297 54.1338 407.368 55.117 406.7 56.2733C406.033 57.4296 405.647 58.7267 405.574 60.0597V140.474L442.778 119.007V34.15Z",
    fill: "url(#paint194_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 34.3616L409.61 53.5009C408.5 54.23 407.576 55.2089 406.912 56.359C406.248 57.5092 405.862 58.7988 405.785 60.1248V140.36L442.778 119.007V34.3616Z",
    fill: "url(#paint195_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 34.5732L409.805 53.6148C408.708 54.3288 407.792 55.2891 407.131 56.4192C406.47 57.5493 406.082 58.8182 405.997 60.1248V140.165L442.778 118.926V34.5732Z",
    fill: "url(#paint196_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 34.801L409.984 53.7938C408.894 54.5123 407.985 55.4744 407.33 56.6041C406.675 57.7339 406.291 59.0004 406.209 60.3038V140.051L442.778 118.893V34.801Z",
    fill: "url(#paint197_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 35.0126L410.18 53.7938C409.086 54.5075 408.176 55.4688 407.522 56.5998C406.869 57.7308 406.492 58.9997 406.42 60.3038V140.051L442.778 119.056V35.0126Z",
    fill: "url(#paint198_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 35.2404L410.375 53.9403C409.281 54.6529 408.372 55.6143 407.722 56.7458C407.071 57.8773 406.698 59.1467 406.632 60.4503V139.888L442.778 119.024V35.2404Z",
    fill: "url(#paint199_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 35.452L410.554 54.0542C409.467 54.7714 408.565 55.7346 407.921 56.8657C407.276 57.9967 406.907 59.2638 406.843 60.5642V139.839L442.778 119.105V35.452Z",
    fill: "url(#paint200_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 35.6799L410.749 54.1682C409.673 54.8673 408.777 55.8112 408.135 56.9229C407.493 58.0345 407.123 59.2823 407.055 60.5642V139.644L442.778 119.024V35.6799Z",
    fill: "url(#paint201_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 35.8914L410.945 54.2821C409.877 54.9782 408.989 55.9152 408.35 57.0177C407.711 58.1202 407.34 59.3572 407.266 60.6293V139.53L442.778 119.024V35.8914Z",
    fill: "url(#paint202_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 36.1193L411.124 54.3797C410.065 55.0779 409.183 56.0139 408.55 57.1131C407.917 58.2123 407.55 59.4443 407.478 60.7107V139.4L442.778 119.024V36.1193Z",
    fill: "url(#paint203_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 36.3309L411.319 54.4937C410.269 55.1887 409.395 56.1178 408.765 57.2079C408.136 58.2979 407.767 59.5193 407.69 60.7758V139.286L442.778 119.04V36.3309Z",
    fill: "url(#paint204_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 36.5587L411.514 54.6076C410.464 55.2927 409.589 56.2154 408.962 57.3011C408.334 58.3868 407.971 59.605 407.901 60.8571V139.172L442.778 119.04V36.5587Z",
    fill: "url(#paint205_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 36.7703L411.693 54.6727C410.653 55.3537 409.786 56.2697 409.165 57.3467C408.543 58.4237 408.182 59.6317 408.113 60.8734V138.993L442.778 118.991V36.7703Z",
    fill: "url(#paint206_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 36.9981L411.856 54.8192C410.822 55.4978 409.961 56.4092 409.342 57.4802C408.723 58.5513 408.363 59.7524 408.292 60.9873V138.928L442.746 119.04L442.778 36.9981Z",
    fill: "url(#paint207_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 37.2097L412.084 54.9331C411.053 55.6065 410.195 56.5126 409.579 57.5783C408.963 58.6441 408.606 59.8396 408.536 61.0687V138.814L442.713 119.04L442.778 37.2097Z",
    fill: "url(#paint208_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 37.5189L412.263 55.047C411.241 55.7154 410.391 56.6145 409.78 57.6717C409.17 58.729 408.816 59.9148 408.747 61.1338V138.684L442.778 119.056V37.5189Z",
    fill: "url(#paint209_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 37.6491L412.458 55.1609C411.441 55.8251 410.595 56.7191 409.987 57.7708C409.379 58.8225 409.027 60.0024 408.959 61.2152V138.57L442.778 119.04V37.6491Z",
    fill: "url(#paint210_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 37.877L412.653 55.2586C411.642 55.9194 410.8 56.8086 410.195 57.8546C409.59 58.9005 409.239 60.0739 409.171 61.2803V138.423L442.778 119.024V37.877Z",
    fill: "url(#paint211_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 38.0886L412.833 55.4213C411.833 56.0809 411.001 56.964 410.403 58.0007C409.804 59.0373 409.454 60.1992 409.382 61.3942V138.423L442.778 119.138V38.0886Z",
    fill: "url(#paint212_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 38.3164L413.028 55.4213C412.03 56.0729 411.199 56.95 410.602 57.9819C410.006 59.0138 409.66 60.1716 409.594 61.3617V138.147L442.778 118.991V38.3164Z",
    fill: "url(#paint213_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.778 38.528L413.223 55.6004C412.232 56.246 411.406 57.1155 410.812 58.1389C410.219 59.1622 409.874 60.3108 409.805 61.4919V138.098L442.778 119.056V38.528Z",
    fill: "url(#paint214_linear_1591_524)",
    fillOpacity: 0.15
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M488.015 17.0945V15.467C488.017 15.2257 487.957 14.9881 487.84 14.7771C487.723 14.5661 487.553 14.3889 487.348 14.2626L485.623 13.1071C485.162 12.8269 484.632 12.6787 484.093 12.6787C483.553 12.6787 483.024 12.8269 482.563 13.1071L411.36 54.2826C410.245 55.0116 409.317 55.9922 408.65 57.1455C407.982 58.2988 407.595 59.5926 407.52 60.9228V135.608C407.527 135.947 407.627 136.277 407.807 136.564C407.988 136.85 408.243 137.083 408.545 137.236L410.075 138.001L487.234 93.5051L488.015 17.0945Z",
    fill: "url(#paint215_linear_1591_524)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M488.989 17.1917C488.989 14.7505 487.264 13.7577 485.148 14.9783L414.011 56.0562C412.895 56.7842 411.965 57.7646 411.298 58.9181C410.631 60.0716 410.244 61.3659 410.17 62.6964V137.984L488.989 92.4143V17.1917Z",
    fill: "#110B2B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M414.011 56.0562L485.148 14.9783C487.264 13.7577 488.989 14.7505 488.989 17.1917V27.9332L410.17 73.5029V62.7614C410.234 61.4197 410.616 60.1124 411.284 58.9468C411.952 57.7813 412.886 56.7906 414.011 56.0562Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M431.835 51.7273C432.632 51.2716 433.283 51.7273 433.283 52.5736C433.249 53.0719 433.1 53.5558 432.849 53.9876C432.598 54.4194 432.251 54.7876 431.835 55.0636C431.053 55.5356 430.402 55.1613 430.402 54.2336C430.432 53.7338 430.577 53.2477 430.825 52.813C431.074 52.3783 431.419 52.0068 431.835 51.7273Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M424.728 55.8937C425.525 55.438 426.176 55.8123 426.176 56.7237C426.145 57.2249 425.997 57.7119 425.746 58.1467C425.495 58.5815 425.146 58.9523 424.728 59.23C423.93 59.6857 423.279 59.23 423.279 58.4C423.311 57.8988 423.458 57.4117 423.71 56.9769C423.961 56.5421 424.309 56.1714 424.728 55.8937Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M417.677 60.06C418.474 59.588 419.125 60.06 419.125 60.89C419.094 61.3912 418.946 61.8782 418.695 62.313C418.444 62.7478 418.095 63.1186 417.677 63.3963C416.88 63.852 416.229 63.3963 416.229 62.55C416.263 62.0517 416.411 61.5678 416.662 61.136C416.913 60.7042 417.261 60.336 417.677 60.06Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M449.91 56.5768L413.828 77.4087V79.7685L449.91 58.9367V56.5768Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M464.462 48.1957L452.061 55.3892V57.7653L464.462 50.5718V48.1957Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M458.267 58.5464L447.965 64.503V66.8791L458.267 60.9225V58.5464Z",
    fill: "#5A3CFF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M446.208 65.447L432.195 73.6007V75.9606L446.208 67.8069V65.447Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M444.49 73.4381L413.828 91.1452V93.5051L444.49 75.798V73.4381Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M455.909 66.8627L447.771 71.5499V73.9097L455.909 69.2225V66.8627Z",
    fill: "#5A3CFF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M485.363 49.9048L459.6 64.78V67.1399L485.363 52.2646V49.9048Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M444.224 80.0945L423.311 92.3332V94.6931L444.224 82.4543V80.0945Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M451.393 75.8788L445.762 79.1663V81.5262L451.393 78.2549V75.8788Z",
    fill: "#5A3CFF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M463.373 76.2208L419.268 101.626V103.986L463.373 78.5807V76.2208Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M481.835 65.6914L465.527 75.0495V77.4093L481.835 68.0513V65.6914Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M454.613 88.2319L413.828 111.668V114.028L454.613 90.6081V88.2319Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M473.682 77.2627L456.756 87.0602V89.42L473.682 79.6388V77.2627Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M485.371 70.4269L475.297 76.2207V78.5806L485.371 72.7867V70.4269Z",
    fill: "#5A3CFF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M426.86 110.577L421.066 113.897V116.273L426.86 112.953V110.577Z",
    fill: "#5A3CFF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M434.212 106.232L428.613 109.406V111.766L434.212 108.592V106.232Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M452.774 102.798L413.828 125.355V127.715L452.774 105.158V102.798Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M470.242 92.7723L457.824 99.9496V102.309L470.242 95.1322V92.7723Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M485.363 84.1138L478.854 87.8245V90.1843L485.363 86.4736V84.1138Z",
    fill: "#5A3CFF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M189.918 336.538L190.227 337.026C190.634 337.303 190.781 339.109 190.781 339.598V402.679C190.708 404.348 190.248 405.976 189.437 407.437C188.626 408.897 187.487 410.149 186.11 411.093L162.528 424.699C161.846 425.036 161.091 425.198 160.33 425.171L157.255 424.097C156.772 423.911 156.357 423.583 156.067 423.155C155.776 422.728 155.622 422.222 155.627 421.705V356.605C155.721 354.952 156.201 353.345 157.03 351.912C157.858 350.479 159.011 349.26 160.396 348.354L181.911 335.952C183.157 335.255 184.579 334.939 186.003 335.044C187.426 335.148 188.787 335.667 189.918 336.538Z",
    fill: "url(#paint216_linear_1591_524)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M186.173 336.587C188.793 335.073 190.942 336.31 190.942 339.337V403.004C190.85 404.658 190.371 406.266 189.543 407.7C188.714 409.133 187.56 410.351 186.173 411.256L163.079 424.601C160.459 426.115 158.311 424.878 158.311 421.851V358.232C158.403 356.577 158.883 354.967 159.711 353.531C160.539 352.095 161.693 350.874 163.079 349.965L186.173 336.587Z",
    fill: "#F9F7F9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M188.272 346.986V398.448L160.979 414.202V362.74L188.272 346.986Z",
    fill: "#D3DAED"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M171.02 351.478C171.111 351.499 171.206 351.499 171.297 351.478L178.523 347.296C178.647 347.221 178.736 347.101 178.773 346.961C178.809 346.821 178.79 346.673 178.718 346.547C178.683 346.484 178.635 346.429 178.578 346.385C178.521 346.341 178.455 346.308 178.385 346.29C178.315 346.272 178.242 346.268 178.171 346.279C178.1 346.289 178.031 346.314 177.969 346.352L170.743 350.518C170.617 350.59 170.523 350.709 170.484 350.849C170.444 350.989 170.461 351.139 170.532 351.267C170.59 351.339 170.665 351.396 170.75 351.433C170.835 351.47 170.928 351.486 171.02 351.478Z",
    fill: "#99A7D8"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M174.636 408.44C176.264 407.512 177.501 408.261 177.501 410.068C177.451 411.072 177.166 412.05 176.668 412.924C176.171 413.797 175.475 414.542 174.636 415.097C173.009 416.008 171.756 415.259 171.756 413.469C171.815 412.465 172.106 411.489 172.606 410.616C173.105 409.744 173.801 408.999 174.636 408.44Z",
    fill: "#E6E7E8"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M175.2 372.652C179.692 370.048 183.337 372.18 183.337 377.372C183.182 380.208 182.365 382.969 180.952 385.433C179.539 387.897 177.569 389.997 175.2 391.564C170.692 394.168 167.062 392.036 167.062 386.828C167.216 383.993 168.032 381.234 169.445 378.772C170.858 376.31 172.829 374.214 175.2 372.652Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M177.987 387.12V379.194L179.614 378.25L175.903 375.891L172.209 382.482L173.967 381.505L173.983 389.431L177.987 387.12Z",
    fill: "#5A3CFF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M693.121 354.174C689.694 352.444 685.909 351.543 682.07 351.543C678.231 351.543 674.446 352.444 671.019 354.174L598.542 396.029C592.459 399.485 592.408 405.378 598.421 408.99L632.05 429.295C635.429 431.089 639.188 432.045 643.013 432.084C646.838 432.123 650.617 431.244 654.031 429.519L727.873 387.008C733.956 383.552 733.956 377.763 727.873 374.255L693.121 354.174Z",
    fill: "black"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_1591_524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M687.782 357.648C684.966 356.225 681.856 355.484 678.701 355.484C675.546 355.484 672.435 356.225 669.62 357.648L610.087 392.02C605.093 394.906 605.041 399.71 609.983 402.682L637.633 419.358C640.41 420.829 643.499 421.612 646.641 421.642C649.783 421.673 652.887 420.949 655.691 419.531L716.365 384.676C721.376 381.807 721.376 377.089 716.365 374.203L687.782 357.648Z",
    fill: "url(#paint217_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 418.805L716.365 383.881C721.376 381.012 721.376 376.294 716.365 373.408L687.817 356.922C685.001 355.499 681.89 354.758 678.735 354.758C675.581 354.758 672.47 355.499 669.654 356.922L610.087 391.294C605.093 394.18 605.041 398.967 609.983 401.957L637.633 418.633C640.407 420.1 643.493 420.882 646.632 420.912C649.771 420.942 652.872 420.22 655.674 418.805Z",
    fill: "url(#paint218_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 418.08L716.365 383.155C721.376 380.269 721.376 375.569 716.365 372.683L687.817 356.197C685.001 354.773 681.89 354.032 678.735 354.032C675.581 354.032 672.47 354.773 669.654 356.197L610.087 390.568C605.093 393.454 605.041 398.241 609.983 401.231L637.633 417.89C640.405 419.364 643.49 420.151 646.63 420.184C649.77 420.217 652.872 419.496 655.674 418.08Z",
    fill: "url(#paint219_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 417.354L716.365 382.429C721.376 379.543 721.376 374.825 716.365 371.957L687.817 355.471C685.001 354.048 681.89 353.306 678.735 353.306C675.581 353.306 672.47 354.048 669.654 355.471L610.087 389.86C605.093 392.728 605.041 397.533 609.983 400.505L637.633 417.181C640.407 418.649 643.493 419.431 646.632 419.461C649.771 419.491 652.872 418.768 655.674 417.354Z",
    fill: "url(#paint220_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 416.628L716.365 381.686C721.376 378.817 721.376 374.1 716.365 371.214L687.817 354.728C684.999 353.313 681.889 352.576 678.735 352.576C675.582 352.576 672.472 353.313 669.654 354.728L610.087 389.099C605.093 391.985 605.041 396.79 609.983 399.762L637.633 416.438C640.407 417.904 643.492 418.687 646.63 418.72C649.768 418.753 652.869 418.036 655.674 416.628Z",
    fill: "url(#paint221_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 415.902L716.365 380.96C721.376 378.092 721.376 373.374 716.365 370.488L687.817 354.002C685.001 352.579 681.89 351.837 678.735 351.837C675.581 351.837 672.47 352.579 669.654 354.002L610.087 388.374C605.093 391.26 605.041 396.064 609.983 399.036L637.633 415.712C640.407 417.179 643.492 417.961 646.63 417.994C649.768 418.027 652.869 417.31 655.674 415.902Z",
    fill: "url(#paint222_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 415.159L716.365 380.234C721.376 377.366 721.376 372.648 716.365 369.762L687.817 353.276C685.001 351.853 681.89 351.112 678.735 351.112C675.581 351.112 672.47 351.853 669.654 353.276L610.087 387.648C605.093 390.534 605.041 395.321 609.983 398.31L637.633 414.986C640.407 416.454 643.493 417.236 646.632 417.266C649.771 417.296 652.872 416.574 655.674 415.159Z",
    fill: "url(#paint223_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 414.433L716.365 379.491C721.376 376.605 721.376 371.905 716.365 369.019L687.817 352.533C685.001 351.11 681.89 350.368 678.735 350.368C675.581 350.368 672.47 351.11 669.654 352.533L610.087 386.922C605.093 389.808 605.041 394.595 609.983 397.584L637.633 414.243C640.405 415.718 643.49 416.505 646.63 416.538C649.77 416.571 652.872 415.849 655.674 414.433Z",
    fill: "url(#paint224_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 413.708L716.365 378.783C721.376 375.897 721.376 371.179 716.365 368.311L687.782 351.842C684.978 350.433 681.883 349.699 678.744 349.699C675.606 349.699 672.511 350.433 669.706 351.842L610.087 386.196C605.093 389.065 605.041 393.869 609.983 396.841L637.633 413.517C640.406 414.988 643.491 415.773 646.63 415.806C649.769 415.839 652.87 415.119 655.674 413.708Z",
    fill: "url(#paint225_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 412.982L716.365 378.057C721.376 375.171 721.376 370.453 716.365 367.567L687.817 351.081C684.999 349.666 681.889 348.929 678.735 348.929C675.582 348.929 672.472 349.666 669.654 351.081L610.087 385.453C605.093 388.339 605.041 393.143 609.983 396.116L637.633 412.792C640.407 414.258 643.492 415.04 646.63 415.073C649.768 415.107 652.869 414.389 655.674 412.982Z",
    fill: "url(#paint226_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 412.325L716.365 377.314C721.376 374.445 721.376 369.728 716.365 366.842L687.817 350.356C685.001 348.933 681.89 348.191 678.735 348.191C675.581 348.191 672.47 348.933 669.654 350.356L610.087 384.676C605.093 387.561 605.041 392.366 609.983 395.338L637.633 412.014C640.398 413.499 643.477 414.302 646.616 414.357C649.754 414.411 652.859 413.714 655.674 412.325Z",
    fill: "url(#paint227_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 411.513L716.365 376.588C721.376 373.719 721.376 369.002 716.365 366.116L687.817 349.63C685.001 348.207 681.89 347.465 678.735 347.465C675.581 347.465 672.47 348.207 669.654 349.63L610.087 384.002C605.093 386.888 605.041 391.674 609.983 394.664L637.633 411.34C640.407 412.808 643.493 413.59 646.632 413.62C649.771 413.65 652.872 412.927 655.674 411.513Z",
    fill: "url(#paint228_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 410.787L716.365 375.862C721.376 372.976 721.376 368.276 716.365 365.39L687.817 348.904C685.001 347.481 681.89 346.74 678.735 346.74C675.581 346.74 672.47 347.481 669.654 348.904L610.087 383.276C605.093 386.162 605.041 390.949 609.983 393.938L637.633 410.597C640.405 412.072 643.49 412.859 646.63 412.892C649.77 412.925 652.872 412.203 655.674 410.787Z",
    fill: "url(#paint229_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 410.061L716.365 375.137C721.376 372.251 721.376 367.533 716.365 364.664L687.817 348.178C685.001 346.755 681.89 346.014 678.735 346.014C675.581 346.014 672.47 346.755 669.654 348.178L610.087 382.55C605.093 385.419 605.041 390.223 609.983 393.195L637.633 409.871C640.406 411.342 643.491 412.126 646.63 412.159C649.769 412.193 652.87 411.473 655.674 410.061Z",
    fill: "url(#paint230_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 409.335L716.365 374.411C721.376 371.525 721.376 366.807 716.365 363.921L687.817 347.435C684.999 346.02 681.889 345.283 678.735 345.283C675.582 345.283 672.472 346.02 669.654 347.435L610.087 381.807C605.093 384.693 605.041 389.497 609.983 392.469L637.633 409.145C640.407 410.612 643.492 411.394 646.63 411.427C649.768 411.46 652.869 410.743 655.674 409.335Z",
    fill: "url(#paint231_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 408.61L716.365 373.668C721.376 370.799 721.376 366.081 716.365 363.195L687.782 346.657C684.978 345.249 681.883 344.515 678.744 344.515C675.606 344.515 672.511 345.249 669.706 346.657L610.087 381.081C605.093 383.967 605.041 388.771 609.983 391.743L637.633 408.42C640.407 409.886 643.492 410.668 646.63 410.701C649.768 410.734 652.869 410.017 655.674 408.61Z",
    fill: "url(#paint232_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 407.867L716.365 372.942C721.376 370.073 721.376 365.355 716.365 362.47L687.817 345.984C685.001 344.56 681.89 343.819 678.735 343.819C675.581 343.819 672.47 344.56 669.654 345.984L610.087 380.355C605.093 383.241 605.041 388.028 609.983 391.018L637.633 407.694C640.407 409.162 643.493 409.943 646.632 409.973C649.771 410.003 652.872 409.281 655.674 407.867Z",
    fill: "url(#paint233_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 407.141L716.365 372.216C721.376 369.33 721.376 364.63 716.365 361.744L687.817 345.258C685.001 343.835 681.89 343.093 678.735 343.093C675.581 343.093 672.47 343.835 669.654 345.258L610.087 379.63C605.093 382.515 605.041 387.302 609.983 390.292L637.633 406.951C640.405 408.425 643.49 409.212 646.63 409.246C649.77 409.279 652.872 408.557 655.674 407.141Z",
    fill: "url(#paint234_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 406.415L716.365 371.49C721.376 368.604 721.376 363.887 716.365 361.018L687.817 344.532C685.001 343.109 681.89 342.367 678.735 342.367C675.581 342.367 672.47 343.109 669.654 344.532L610.087 378.904C605.093 381.772 605.041 386.576 609.983 389.549L637.633 406.225C640.406 407.695 643.491 408.48 646.63 408.513C649.769 408.546 652.87 407.827 655.674 406.415Z",
    fill: "url(#paint235_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 405.689L716.365 370.851C721.376 367.965 721.376 363.247 716.365 360.361L687.817 343.875C684.999 342.46 681.889 341.723 678.735 341.723C675.582 341.723 672.472 342.46 669.654 343.875L610.087 378.161C605.093 381.047 605.041 385.851 609.983 388.823L637.633 405.499C640.407 406.966 643.492 407.748 646.63 407.781C649.768 407.814 652.869 407.097 655.674 405.689Z",
    fill: "url(#paint236_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 404.963L716.365 370.021C721.376 367.153 721.376 362.435 716.365 359.549L687.817 343.063C685.001 341.64 681.89 340.899 678.735 340.899C675.581 340.899 672.47 341.64 669.654 343.063L610.087 377.435C605.093 380.321 605.041 385.125 609.983 388.097L637.633 404.773C640.407 406.24 643.492 407.022 646.63 407.055C649.768 407.088 652.869 406.371 655.674 404.963Z",
    fill: "url(#paint237_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 404.22L716.365 369.296C721.376 366.427 721.376 361.709 716.365 358.823L687.817 342.337C685.001 340.914 681.89 340.173 678.735 340.173C675.581 340.173 672.47 340.914 669.654 342.337L610.087 376.709C605.093 379.595 605.041 384.382 609.983 387.371L637.633 404.047C640.407 405.515 643.493 406.297 646.632 406.327C649.771 406.357 652.872 405.635 655.674 404.22Z",
    fill: "url(#paint238_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 403.495L716.365 368.57C721.376 365.684 721.376 360.983 716.365 358.097L687.817 341.611C685.001 340.188 681.89 339.447 678.735 339.447C675.581 339.447 672.47 340.188 669.654 341.611L610.087 376.035C605.093 378.921 605.041 383.708 609.983 386.697L637.633 403.356C640.409 404.823 643.497 405.601 646.636 405.625C649.776 405.649 652.876 404.918 655.674 403.495Z",
    fill: "url(#paint239_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 402.769L716.365 367.844C721.376 364.958 721.376 360.24 716.365 357.372L687.817 340.886C685.001 339.463 681.89 338.721 678.735 338.721C675.581 338.721 672.47 339.463 669.654 340.886L610.087 375.257C605.093 378.126 605.041 382.93 609.983 385.903L637.633 402.579C640.405 404.053 643.49 404.84 646.63 404.873C649.77 404.907 652.872 404.185 655.674 402.769Z",
    fill: "url(#paint240_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 402.043L716.365 367.118C721.376 364.232 721.376 359.514 716.365 356.629L687.817 340.16C685.001 338.737 681.89 337.995 678.735 337.995C675.581 337.995 672.47 338.737 669.654 340.16L610.087 374.514C605.093 377.4 605.041 382.204 609.983 385.177L637.633 401.853C640.406 403.323 643.491 404.108 646.63 404.141C649.769 404.174 652.87 403.455 655.674 402.043Z",
    fill: "url(#paint241_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 401.317L716.365 366.375C721.376 363.506 721.376 358.789 716.365 355.903L687.817 339.417C685.001 337.994 681.89 337.252 678.735 337.252C675.581 337.252 672.47 337.994 669.654 339.417L610.087 373.789C605.093 376.675 605.041 381.479 609.983 384.451L637.633 401.127C640.407 402.593 643.492 403.376 646.63 403.409C649.768 403.442 652.869 402.725 655.674 401.317Z",
    fill: "url(#paint242_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 400.574L716.365 365.667C721.376 362.798 721.376 358.08 716.365 355.194L687.817 338.708C685.001 337.285 681.89 336.544 678.735 336.544C675.581 336.544 672.47 337.285 669.654 338.708L610.087 373.063C605.093 375.949 605.041 380.736 609.983 383.725L637.633 400.401C640.407 401.869 643.493 402.651 646.632 402.681C649.771 402.711 652.872 401.989 655.674 400.574Z",
    fill: "url(#paint243_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 399.848L716.365 364.923C721.376 362.038 721.376 357.337 716.365 354.451L687.782 338.017C684.978 336.608 681.883 335.874 678.744 335.874C675.606 335.874 672.511 336.608 669.706 338.017L610.087 372.337C605.093 375.223 605.041 380.01 609.983 382.999L637.633 399.675C640.407 401.143 643.493 401.925 646.632 401.955C649.771 401.985 652.872 401.263 655.674 399.848Z",
    fill: "url(#paint244_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 399.122L716.365 364.198C721.376 361.312 721.376 356.611 716.365 353.725L687.817 337.239C685.001 335.816 681.89 335.075 678.735 335.075C675.581 335.075 672.47 335.816 669.654 337.239L610.087 371.611C605.093 374.48 605.041 379.284 609.983 382.256L637.633 398.932C640.405 400.407 643.49 401.194 646.63 401.227C649.77 401.26 652.872 400.538 655.674 399.122Z",
    fill: "url(#paint245_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 398.397L716.365 363.472C721.376 360.586 721.376 355.868 716.365 352.982L687.817 336.514C685.001 335.091 681.89 334.349 678.735 334.349C675.581 334.349 672.47 335.091 669.654 336.514L610.087 370.851C605.093 373.737 605.041 378.541 609.983 381.513L637.633 398.189C640.405 399.663 643.489 400.45 646.628 400.486C649.767 400.522 652.869 399.806 655.674 398.397Z",
    fill: "url(#paint246_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 397.671L716.365 362.729C721.376 359.86 721.376 355.142 716.365 352.256L687.817 335.77C685.001 334.347 681.89 333.606 678.735 333.606C675.581 333.606 672.47 334.347 669.654 335.77L610.087 370.142C605.093 373.028 605.041 377.832 609.983 380.805L637.633 397.481C640.407 398.947 643.492 399.729 646.63 399.763C649.768 399.796 652.869 399.078 655.674 397.671Z",
    fill: "url(#paint247_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 396.928L716.365 362.003C721.376 359.134 721.376 354.417 716.365 351.531L687.817 335.045C685.001 333.622 681.89 332.88 678.735 332.88C675.581 332.88 672.47 333.622 669.654 335.045L610.087 369.417C605.093 372.302 605.041 377.089 609.983 380.079L637.633 396.755C640.407 398.223 643.493 399.004 646.632 399.035C649.771 399.065 652.872 398.342 655.674 396.928Z",
    fill: "url(#paint248_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 396.202L716.365 361.277C721.376 358.391 721.376 353.691 716.365 350.805L687.817 334.319C685.001 332.896 681.89 332.154 678.735 332.154C675.581 332.154 672.47 332.896 669.654 334.319L610.087 368.691C605.093 371.577 605.041 376.363 609.983 379.353L637.633 396.029C640.407 397.497 643.493 398.279 646.632 398.309C649.771 398.339 652.872 397.616 655.674 396.202Z",
    fill: "url(#paint249_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 395.476L716.365 360.482C721.376 357.596 721.376 352.896 716.365 350.01L687.817 333.524C685.001 332.101 681.89 331.359 678.735 331.359C675.581 331.359 672.47 332.101 669.654 333.524L610.087 367.965C605.093 370.851 605.041 375.638 609.983 378.61L637.633 395.286C640.405 396.761 643.49 397.548 646.63 397.581C649.77 397.614 652.872 396.892 655.674 395.476Z",
    fill: "url(#paint250_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 394.75L716.365 359.826C721.376 356.94 721.376 352.222 716.365 349.353L687.782 332.833C684.978 331.424 681.883 330.69 678.744 330.69C675.606 330.69 672.511 331.424 669.706 332.833L610.087 367.222C605.093 370.108 605.041 374.912 609.983 377.884L637.633 394.56C640.406 396.031 643.491 396.815 646.63 396.849C649.769 396.882 652.87 396.162 655.674 394.75Z",
    fill: "url(#paint251_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 394.025L716.365 359.082C721.376 356.214 721.376 351.496 716.365 348.61L687.817 332.124C684.999 330.709 681.889 329.972 678.735 329.972C675.582 329.972 672.472 330.709 669.654 332.124L610.087 366.496C605.093 369.382 605.041 374.186 609.983 377.158L637.633 393.834C640.407 395.301 643.492 396.083 646.63 396.116C649.768 396.149 652.869 395.432 655.674 394.025Z",
    fill: "url(#paint252_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 393.316L716.365 358.357C721.376 355.488 721.376 350.77 716.365 347.884L687.817 331.398C685.001 329.975 681.89 329.234 678.735 329.234C675.581 329.234 672.47 329.975 669.654 331.398L610.087 365.77C605.093 368.656 605.041 373.443 609.983 376.433L637.633 393.109C640.405 394.582 643.489 395.37 646.628 395.406C649.767 395.442 652.869 394.725 655.674 393.316Z",
    fill: "url(#paint253_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 392.556L716.365 357.631C721.376 354.762 721.376 350.045 716.365 347.159L687.817 330.673C685.001 329.25 681.89 328.508 678.735 328.508C675.581 328.508 672.47 329.25 669.654 330.673L610.087 365.044C605.093 367.93 605.041 372.717 609.983 375.707L637.633 392.383C640.407 393.851 643.493 394.632 646.632 394.662C649.771 394.693 652.872 393.97 655.674 392.556Z",
    fill: "url(#paint254_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 391.83L716.365 356.905C721.376 354.019 721.376 349.319 716.365 346.433L687.817 329.947C685.001 328.524 681.89 327.782 678.735 327.782C675.581 327.782 672.47 328.524 669.654 329.947L610.087 364.319C605.093 367.205 605.041 371.991 609.983 374.981L637.633 391.64C640.405 393.114 643.49 393.902 646.63 393.935C649.77 393.968 652.872 393.246 655.674 391.83Z",
    fill: "url(#paint255_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 391.104L716.365 356.179C721.376 353.293 721.376 348.576 716.365 345.707L687.817 329.221C685.001 327.798 681.89 327.057 678.735 327.057C675.581 327.057 672.47 327.798 669.654 329.221L610.087 363.593C605.093 366.461 605.041 371.266 609.983 374.238L637.633 390.914C640.406 392.385 643.491 393.169 646.63 393.202C649.769 393.235 652.87 392.516 655.674 391.104Z",
    fill: "url(#paint256_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.674 390.378L716.365 355.436C721.376 352.568 721.376 347.85 716.365 344.964L687.817 328.478C684.999 327.063 681.889 326.326 678.735 326.326C675.582 326.326 672.472 327.063 669.654 328.478L610.087 362.85C605.093 365.736 605.041 370.54 609.983 373.512L637.633 390.188C640.407 391.655 643.492 392.437 646.63 392.47C649.768 392.503 652.869 391.786 655.674 390.378Z",
    fill: "url(#paint257_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.782 327.752C684.966 326.329 681.856 325.588 678.701 325.588C675.546 325.588 672.435 326.329 669.62 327.752L610.087 362.21C605.093 365.096 605.041 369.9 609.983 372.873L637.633 389.549C640.41 391.02 643.499 391.803 646.641 391.833C649.783 391.863 652.887 391.139 655.691 389.722L716.365 354.71C721.376 351.842 721.376 347.124 716.365 344.238L687.782 327.752Z",
    fill: "url(#paint258_linear_1591_524)",
    fillOpacity: 0.15
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M693.121 312.096C689.694 310.366 685.909 309.464 682.07 309.464C678.231 309.464 674.446 310.366 671.019 312.096L593.98 355.989V362.21C593.982 362.779 594.129 363.338 594.407 363.834C594.685 364.33 595.086 364.747 595.57 365.044L632.05 387.13C635.43 388.919 639.19 389.873 643.014 389.913C646.838 389.952 650.616 389.074 654.032 387.354L729.515 343.893C730.393 343.388 731.122 342.66 731.629 341.783C732.135 340.906 732.402 339.911 732.401 338.898V334.25L693.121 312.096Z",
    fill: "url(#paint259_linear_1591_524)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M693.121 308.242C689.694 306.512 685.909 305.611 682.07 305.611C678.231 305.611 674.446 306.512 671.019 308.242L598.542 350.114C592.459 353.57 592.408 359.463 598.421 363.092L632.05 383.38C635.429 385.173 639.188 386.13 643.013 386.169C646.838 386.208 650.617 385.329 654.031 383.604L727.873 341.093C733.956 337.637 733.956 331.848 727.873 328.34L693.121 308.242Z",
    fill: "#4B30BA"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M691.169 323.363C689.662 322.596 687.995 322.197 686.304 322.197C684.614 322.197 682.947 322.596 681.44 323.363L628.508 353.656C625.83 355.194 625.795 357.769 628.508 359.376L643.335 368.31C644.824 369.096 646.478 369.516 648.161 369.534C649.845 369.552 651.508 369.168 653.013 368.414L706.584 337.809C709.262 336.271 709.262 333.748 706.584 332.193L691.169 323.363Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M655.277 350.113C655.055 350.324 654.761 350.441 654.456 350.441C654.15 350.441 653.857 350.324 653.635 350.113L651.337 347.901C651.123 347.685 651.004 347.393 651.004 347.089C651.004 346.785 651.123 346.494 651.337 346.277C651.444 346.169 651.572 346.083 651.713 346.024C651.854 345.966 652.005 345.936 652.157 345.936C652.31 345.936 652.461 345.966 652.602 346.024C652.743 346.083 652.871 346.169 652.978 346.277L655.277 348.489C655.49 348.706 655.609 348.997 655.609 349.301C655.609 349.605 655.49 349.897 655.277 350.113Z",
    fill: "#F2B1B5"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M687.342 459.882L683.385 457.566V455.838L679.289 455.251L670.027 449.876C669.507 449.577 669.083 449.136 668.805 448.604C668.528 448.072 668.409 447.471 668.461 446.874C668.514 446.276 668.737 445.706 669.103 445.23C669.469 444.755 669.963 444.394 670.528 444.191C671.405 443.871 672.338 443.732 673.271 443.782C674.204 443.833 675.116 444.072 675.954 444.485L683.091 447.941L692.959 451.57L692.751 455.182C692.676 456.465 692.114 457.672 691.18 458.555C690.245 459.439 689.008 459.932 687.722 459.934L687.342 459.882Z",
    fill: "#363650"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M688.882 458.724H688.484L684.544 456.409V454.681L680.449 454.076L671.169 448.719C670.451 448.3 669.929 447.614 669.715 446.811C669.501 446.008 669.614 445.153 670.028 444.433C669.551 444.707 669.154 445.102 668.878 445.579C668.602 446.055 668.457 446.596 668.457 447.146C668.457 447.697 668.602 448.238 668.878 448.714C669.154 449.19 669.551 449.585 670.028 449.859L679.291 455.234L683.387 455.821V457.549L687.344 459.865H687.724C688.531 459.864 689.326 459.669 690.042 459.296C690.758 458.923 691.374 458.383 691.837 457.722C690.988 458.37 689.95 458.722 688.882 458.724Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M702.54 449.531L698.582 447.233V445.504L694.487 444.917L685.224 439.543C684.704 439.243 684.28 438.802 684.003 438.27C683.725 437.738 683.606 437.137 683.659 436.54C683.711 435.942 683.934 435.372 684.3 434.897C684.666 434.421 685.161 434.061 685.725 433.857C686.601 433.534 687.534 433.392 688.467 433.44C689.399 433.487 690.312 433.723 691.151 434.134L698.288 437.59L708.156 441.219L707.948 444.813C707.882 446.1 707.322 447.312 706.386 448.196C705.449 449.081 704.208 449.572 702.92 449.565L702.54 449.531Z",
    fill: "#363650"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M704.007 448.39H703.627L699.67 446.075V444.347L695.574 443.759L686.312 438.385C685.955 438.181 685.643 437.908 685.392 437.582C685.141 437.257 684.958 436.885 684.852 436.488C684.746 436.091 684.719 435.677 684.774 435.27C684.829 434.863 684.964 434.471 685.171 434.116C684.694 434.39 684.297 434.785 684.021 435.262C683.745 435.738 683.6 436.279 683.6 436.829C683.6 437.38 683.745 437.921 684.021 438.397C684.297 438.874 684.694 439.269 685.171 439.543L694.434 444.917L698.529 445.505V447.233L702.487 449.531H702.867C703.673 449.533 704.467 449.342 705.183 448.972C705.899 448.602 706.515 448.064 706.98 447.405C706.119 448.043 705.078 448.388 704.007 448.39Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M702.9 444.831C700.032 444.831 697.716 443.656 697.716 440.787L694.83 363.939C694.83 361.07 700.014 358.754 702.9 358.754C704.275 358.754 705.594 359.301 706.566 360.273C707.538 361.245 708.085 362.564 708.085 363.939V440.839C708.085 443.656 705.769 444.831 702.9 444.831Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M688.126 453.661C685.448 453.661 683.184 453.333 682.942 450.62L680.021 405.689V405.309L682.907 363.161C682.954 362.481 683.133 361.817 683.436 361.206C683.739 360.596 684.159 360.051 684.673 359.604C685.186 359.156 685.783 358.814 686.429 358.597C687.075 358.38 687.758 358.292 688.437 358.339C691.306 358.529 700.655 361.087 700.534 363.938L691.893 405.689L693.397 449.842C693.622 452.693 691.496 453.471 688.627 453.696L688.126 453.661Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M676.618 334.941C676.632 335.091 676.616 335.242 676.572 335.386C676.527 335.53 676.455 335.663 676.358 335.779C676.262 335.895 676.144 335.99 676.01 336.06C675.877 336.129 675.731 336.172 675.581 336.185L670.777 336.6C670.473 336.619 670.174 336.52 669.942 336.324C669.71 336.127 669.563 335.848 669.532 335.546C669.518 335.394 669.534 335.242 669.58 335.097C669.625 334.952 669.699 334.818 669.798 334.702C669.896 334.586 670.016 334.491 670.152 334.422C670.287 334.353 670.435 334.312 670.587 334.301L675.373 333.887C675.525 333.873 675.677 333.889 675.822 333.934C675.967 333.98 676.101 334.054 676.217 334.152C676.333 334.25 676.428 334.371 676.497 334.506C676.566 334.642 676.607 334.789 676.618 334.941Z",
    fill: "#F2B1B5"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M679.523 338.691C678.867 338.38 678.21 338.052 677.553 337.689L670.468 333.766C670.07 333.545 669.719 333.247 669.436 332.89C669.153 332.533 668.942 332.124 668.817 331.686C668.692 331.248 668.654 330.79 668.706 330.337C668.758 329.884 668.899 329.446 669.12 329.048C669.341 328.65 669.639 328.299 669.996 328.016C670.353 327.733 670.762 327.522 671.2 327.397C671.638 327.272 672.096 327.234 672.549 327.286C673.002 327.338 673.44 327.479 673.838 327.7L680.923 331.64C689.564 336.427 693.175 339.883 700.451 333.213C700.791 332.905 701.189 332.668 701.621 332.514C702.053 332.36 702.511 332.293 702.969 332.316C703.427 332.34 703.876 332.453 704.291 332.65C704.705 332.847 705.077 333.123 705.384 333.463C705.692 333.804 705.929 334.202 706.083 334.634C706.237 335.066 706.304 335.524 706.281 335.982C706.258 336.44 706.144 336.889 705.947 337.304C705.751 337.718 705.474 338.09 705.134 338.397C696.199 346.502 690.445 343.702 679.523 338.691Z",
    fill: "#F2B1B5"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M679.277 339.21C678.603 338.899 677.929 338.553 677.272 338.19C676.809 337.932 676.401 337.586 676.072 337.171C675.743 336.756 675.499 336.28 675.354 335.771C675.208 335.261 675.165 334.728 675.226 334.202C675.287 333.675 675.451 333.166 675.708 332.703C675.966 332.24 676.312 331.833 676.727 331.504C677.142 331.174 677.618 330.93 678.128 330.785C678.637 330.64 679.17 330.596 679.696 330.657C680.223 330.718 680.732 330.882 681.195 331.139C689.593 335.788 692.963 339.279 700.066 332.867C700.867 332.219 701.886 331.901 702.913 331.978C703.941 332.056 704.901 332.523 705.596 333.284C706.291 334.045 706.669 335.043 706.653 336.074C706.637 337.105 706.228 338.09 705.509 338.829C696.402 347.072 690.44 344.325 679.277 339.21Z",
    fill: "url(#paint260_linear_1591_524)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M700.07 332.832C693.521 338.829 690.134 336.288 683.049 332.21C682.045 334.725 681.355 337.355 680.992 340.038C690.998 344.618 696.891 346.674 705.514 338.794C706.232 338.055 706.642 337.069 706.658 336.039C706.674 335.008 706.296 334.01 705.601 333.249C704.906 332.487 703.946 332.02 702.918 331.943C701.89 331.865 700.872 332.184 700.07 332.832Z",
    fill: "#231F20"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M708.564 322.343C707.838 317.418 703.241 314.204 698.869 316.554C698.403 316.831 697.936 317.107 697.487 317.401C684.941 325.402 682.072 335.823 682.072 347.073L682.314 356.594L680.586 380.96C682.73 382.288 685.244 382.894 687.758 382.689C688 382.689 689.486 374.601 689.676 374.567C690.298 374.567 690.937 382.516 691.577 382.412C698.904 381.133 705.782 378.075 708.564 372.579L707.7 343.876C707.7 343.876 709.739 330.483 708.564 322.343Z",
    fill: "url(#paint261_linear_1591_524)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M697.976 323.432C697.302 323.432 696.656 323.164 696.18 322.688C695.703 322.211 695.436 321.565 695.436 320.891V309.158H700.516V320.891C700.516 321.565 700.248 322.211 699.772 322.688C699.296 323.164 698.65 323.432 697.976 323.432Z",
    fill: "#F2B1B5"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M688.711 294.987H704.057V316.9H698.613C697.306 316.9 696.011 316.641 694.804 316.138C693.597 315.635 692.501 314.897 691.581 313.969C690.66 313.04 689.933 311.938 689.44 310.727C688.948 309.516 688.7 308.219 688.711 306.911V294.987Z",
    fill: "#F2B1B5"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M690.076 307.862V294.987H688.711V307.862C688.711 310.259 689.663 312.557 691.358 314.252C693.053 315.947 695.352 316.9 697.749 316.9H699.08C696.688 316.89 694.399 315.934 692.711 314.24C691.024 312.546 690.076 310.253 690.076 307.862Z",
    fill: "#F7D0D3"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M708.984 306.254C708.984 305.684 708.984 305.114 708.984 304.526C709.125 302.309 709.085 300.084 708.863 297.873C708.739 296.478 708.278 295.135 707.519 293.958C706.761 292.78 705.727 291.805 704.508 291.116C702.929 290.536 701.243 290.306 699.566 290.442H689.353C687.826 290.307 686.293 290.625 684.946 291.358C682.527 292.983 683.719 296.093 685.171 297.96C685.939 298.993 686.932 299.837 688.074 300.431C689.18 300.967 691.064 300.431 691.772 301.64C692.774 303.196 690.891 308.121 693.051 308.726C694.779 309.192 694.503 307.464 694.779 306.496C694.839 306.189 694.989 305.906 695.211 305.684C695.432 305.462 695.715 305.312 696.023 305.252C696.818 305.252 697.337 306.082 697.492 306.859C697.604 308.413 697.481 309.974 697.129 311.491C696.958 312.252 696.972 313.044 697.171 313.798C697.369 314.553 697.746 315.249 698.27 315.828C698.701 316.189 699.201 316.46 699.739 316.623C701.277 317.193 704.093 317.867 705.528 316.761C706.516 316.109 707.346 315.244 707.959 314.231C708.572 313.218 708.951 312.081 709.07 310.903C709.141 309.353 709.113 307.801 708.984 306.254Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M664.043 356.041C663.317 356.041 662.574 356.041 661.831 355.955L649.337 355.333C648.883 355.31 648.438 355.198 648.027 355.003C647.616 354.809 647.248 354.535 646.943 354.198C646.638 353.861 646.403 353.467 646.25 353.039C646.097 352.611 646.03 352.157 646.053 351.704C646.076 351.25 646.188 350.805 646.382 350.394C646.577 349.983 646.851 349.615 647.188 349.31C647.525 349.005 647.918 348.77 648.346 348.617C648.774 348.464 649.228 348.397 649.682 348.42L662.263 349.042C667.069 349.413 671.869 348.261 675.983 345.748C680.096 343.235 683.314 339.49 685.177 335.045L687.545 329.394C687.721 328.975 687.977 328.595 688.3 328.276C688.623 327.956 689.005 327.703 689.426 327.532C689.846 327.36 690.296 327.273 690.75 327.275C691.204 327.277 691.654 327.369 692.072 327.545C692.491 327.721 692.871 327.977 693.19 328.3C693.51 328.623 693.763 329.005 693.935 329.426C694.106 329.846 694.193 330.296 694.191 330.75C694.189 331.204 694.097 331.654 693.921 332.072L691.554 337.723C689.285 343.149 685.462 347.782 680.567 351.041C675.673 354.3 669.923 356.04 664.043 356.041Z",
    fill: "#F2B1B5"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M693.499 333.576C693.66 333.07 693.719 332.537 693.673 332.008C693.626 331.479 693.476 330.965 693.23 330.494C692.985 330.023 692.648 329.606 692.241 329.266C691.833 328.926 691.362 328.67 690.855 328.512C688.73 327.838 687.226 329.221 686.552 331.346L683.96 336.997C683.568 338.236 683.071 339.438 682.474 340.592C682.202 342.741 682.069 344.906 682.076 347.072L682.249 353.552C686.662 349.825 689.927 344.924 691.667 339.417L693.499 333.576Z",
    fill: "#231F20"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M664.033 356.611C663.29 356.611 662.53 356.611 661.787 356.525L657.017 356.179C655.991 356.046 655.055 355.524 654.402 354.722C653.749 353.92 653.428 352.898 653.506 351.866C653.583 350.835 654.053 349.872 654.819 349.176C655.584 348.48 656.588 348.105 657.622 348.126L662.374 348.472C667.048 348.823 671.714 347.693 675.709 345.242C679.704 342.792 682.826 339.145 684.632 334.82L686.999 329.169C687.187 328.655 687.477 328.184 687.852 327.785C688.227 327.386 688.678 327.068 689.18 326.849C689.682 326.63 690.222 326.515 690.77 326.511C691.317 326.507 691.86 326.614 692.364 326.826C692.869 327.038 693.325 327.35 693.706 327.744C694.086 328.137 694.383 328.604 694.577 329.115C694.772 329.627 694.861 330.172 694.839 330.719C694.816 331.266 694.683 331.803 694.448 332.297L692.166 338.017C689.834 343.546 685.919 348.261 680.913 351.57C675.907 354.879 670.034 356.633 664.033 356.611Z",
    fill: "url(#paint262_linear_1591_524)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M579.529 313.565C579.529 316.122 581.257 317.142 583.504 315.846L629.955 288.352C631.103 287.576 632.061 286.552 632.758 285.355C633.455 284.159 633.873 282.82 633.982 281.439L634.396 243.179C634.396 240.639 632.668 239.602 630.456 240.898L583.521 268.375C582.366 269.14 581.405 270.162 580.712 271.361C580.019 272.561 579.615 273.905 579.529 275.287V313.565Z",
    fill: "#D3DAED"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M586.758 325.074C586.758 328.081 588.866 329.273 591.458 327.752L646.187 295.333C647.554 294.411 648.693 293.19 649.516 291.761C650.34 290.333 650.827 288.735 650.939 287.09L651.44 241.97C651.44 238.98 649.367 237.77 646.792 239.291L591.493 271.762C590.126 272.676 588.991 273.895 588.175 275.322C587.36 276.749 586.886 278.347 586.792 279.988L586.758 325.074Z",
    fill: "#D3DAED"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M593.959 340.177C593.959 343.633 596.447 345.119 599.489 343.322L663.86 305.183C665.472 304.106 666.815 302.673 667.785 300.996C668.756 299.318 669.329 297.44 669.459 295.506L670.03 242.436C670.03 238.893 667.61 237.476 664.569 239.256L599.506 277.534C597.892 278.604 596.55 280.036 595.587 281.716C594.624 283.396 594.067 285.277 593.959 287.211V340.177Z",
    fill: "#D3DAED"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M595.894 341.473V288.421C596.003 286.492 596.559 284.614 597.519 282.938C598.479 281.261 599.816 279.831 601.424 278.761L666.504 240.552C667.364 239.979 668.395 239.716 669.425 239.809C668.509 238.323 666.677 238.081 664.569 239.256L599.506 277.534C597.892 278.604 596.55 280.036 595.587 281.716C594.624 283.396 594.067 285.278 593.959 287.211V340.246C593.959 342.51 594.996 343.91 596.534 344.134C596.068 343.328 595.846 342.403 595.894 341.473Z",
    fill: "#D3DAED"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M669.824 261.531C669.824 262.102 667.249 264.383 666.8 264.988C665.832 266.232 664.795 267.459 663.862 268.703C662.134 271.071 661.581 274.406 659.974 276.981C658.491 279.598 656.172 281.643 653.39 282.787C651.427 283.384 649.393 283.716 647.342 283.772C645.285 283.832 643.265 284.326 641.414 285.224C637.733 287.297 637.353 292.724 636.23 296.387C635.83 298.145 635.078 299.803 634.018 301.26C632.813 302.555 631.338 303.57 629.698 304.233C628.207 304.984 626.636 305.564 625.015 305.961C621.852 306.687 618.534 306.185 615.303 306.548C612.892 306.838 610.565 307.609 608.457 308.814C606.35 310.019 604.506 311.634 603.033 313.564C601.992 315.042 601.035 316.577 600.165 318.161C598.693 320.565 597.071 322.874 595.309 325.074C594.709 325.757 594.274 326.569 594.034 327.446C593.795 328.323 593.758 329.243 593.926 330.137C594.03 333.438 593.926 336.755 593.926 340.056C593.926 343.357 596.415 344.998 599.456 343.201L663.862 305.183C665.474 304.106 666.816 302.673 667.787 300.996C668.758 299.318 669.331 297.44 669.461 295.506L669.824 261.531Z",
    fill: "#5A3CFF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M594.064 341.266V341.508C594.124 341.805 594.217 342.095 594.34 342.372V342.51C594.447 342.713 594.574 342.904 594.72 343.08C594.756 343.145 594.803 343.204 594.859 343.253C595.023 343.426 595.208 343.577 595.412 343.703L595.619 343.806C595.783 343.89 595.957 343.954 596.137 343.996H596.362C595.906 343.211 595.684 342.312 595.723 341.404V318.075L595.17 318.818C594.361 319.683 593.873 320.799 593.787 321.98V330.258C593.891 333.559 593.787 336.877 593.787 340.177C593.85 340.547 593.943 340.911 594.064 341.266Z",
    fill: "#D3DAED"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_1591_524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.969 235.292L438.128 170.078C438.453 169.877 438.826 169.767 439.208 169.759C439.59 169.751 439.967 169.846 440.3 170.034C440.633 170.222 440.909 170.496 441.1 170.828C441.29 171.159 441.388 171.535 441.383 171.917V252.348C441.386 253.449 441.098 254.531 440.55 255.485C440.001 256.439 439.211 257.232 438.258 257.784L325.099 323.502C324.776 323.708 324.404 323.823 324.021 323.834C323.638 323.845 323.26 323.752 322.926 323.565C322.592 323.378 322.315 323.104 322.124 322.772C321.934 322.44 321.837 322.062 321.844 321.679V240.711C321.845 239.614 322.133 238.535 322.682 237.584C323.23 236.633 324.019 235.842 324.969 235.292Z",
    fill: "url(#paint263_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.327 235.455L437.884 170.599C438.207 170.393 438.579 170.278 438.962 170.267C439.345 170.256 439.723 170.349 440.058 170.536C440.392 170.723 440.669 170.997 440.859 171.329C441.05 171.661 441.146 172.039 441.139 172.422V252.446C441.138 253.539 440.85 254.613 440.304 255.561C439.759 256.509 438.975 257.298 438.031 257.849L325.441 323.225C325.119 323.411 324.753 323.509 324.381 323.509C324.009 323.508 323.644 323.41 323.322 323.224C323 323.037 322.733 322.769 322.548 322.446C322.363 322.124 322.266 321.758 322.267 321.386V240.858C322.257 239.768 322.535 238.694 323.072 237.746C323.609 236.797 324.387 236.007 325.327 235.455Z",
    fill: "url(#paint264_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.669 235.617L437.624 171.104C437.945 170.918 438.309 170.821 438.679 170.82C439.05 170.82 439.414 170.917 439.735 171.101C440.057 171.286 440.324 171.552 440.51 171.872C440.697 172.192 440.796 172.556 440.797 172.926V252.527C440.793 253.614 440.506 254.681 439.964 255.623C439.422 256.565 438.643 257.349 437.705 257.898L325.734 322.997C325.414 323.184 325.051 323.283 324.681 323.283C324.311 323.284 323.947 323.187 323.626 323.002C323.306 322.817 323.04 322.551 322.855 322.23C322.671 321.909 322.575 321.545 322.577 321.175V240.956C322.584 239.874 322.874 238.813 323.416 237.877C323.958 236.941 324.734 236.162 325.669 235.617Z",
    fill: "url(#paint265_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.027 235.78L437.38 171.624C437.697 171.437 438.058 171.338 438.426 171.336C438.795 171.334 439.157 171.43 439.476 171.613C439.795 171.797 440.06 172.062 440.244 172.381C440.427 172.7 440.523 173.063 440.521 173.431V252.592C440.522 253.676 440.239 254.741 439.699 255.681C439.159 256.62 438.382 257.402 437.445 257.947L326.092 322.607C325.775 322.794 325.413 322.893 325.045 322.895C324.677 322.897 324.315 322.802 323.995 322.618C323.676 322.434 323.411 322.169 323.228 321.85C323.044 321.531 322.949 321.169 322.951 320.8V241.135C322.949 240.051 323.233 238.986 323.773 238.046C324.313 237.106 325.09 236.325 326.027 235.78Z",
    fill: "url(#paint266_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.385 235.959L437.054 172.145C437.37 171.963 437.728 171.867 438.092 171.866C438.457 171.866 438.815 171.961 439.131 172.142C439.448 172.323 439.711 172.584 439.895 172.899C440.078 173.214 440.176 173.571 440.179 173.936V252.674C440.177 253.748 439.893 254.803 439.356 255.734C438.819 256.665 438.048 257.439 437.119 257.979L326.45 322.33C326.133 322.513 325.774 322.609 325.408 322.609C325.042 322.609 324.682 322.513 324.366 322.33C324.049 322.146 323.786 321.883 323.603 321.566C323.421 321.249 323.325 320.889 323.325 320.524V241.265C323.324 240.19 323.606 239.133 324.143 238.202C324.681 237.27 325.454 236.497 326.385 235.959Z",
    fill: "url(#paint267_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.743 236.073L436.891 172.601C437.205 172.422 437.561 172.328 437.923 172.329C438.284 172.33 438.639 172.426 438.952 172.607C439.265 172.788 439.525 173.048 439.706 173.361C439.887 173.674 439.983 174.03 439.984 174.391V252.706C439.982 253.773 439.702 254.82 439.171 255.745C438.64 256.67 437.877 257.44 436.956 257.979L326.808 322.005C326.494 322.188 326.136 322.285 325.772 322.286C325.408 322.287 325.05 322.192 324.735 322.01C324.419 321.829 324.157 321.567 323.976 321.252C323.794 320.936 323.699 320.578 323.699 320.214V241.395C323.692 240.318 323.97 239.259 324.504 238.324C325.039 237.39 325.811 236.613 326.743 236.073Z",
    fill: "url(#paint268_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.068 236.285L436.598 173.171C436.91 172.987 437.266 172.889 437.628 172.886C437.99 172.884 438.346 172.978 438.66 173.158C438.975 173.339 439.235 173.599 439.416 173.913C439.597 174.226 439.692 174.582 439.691 174.945V252.82C439.69 253.884 439.41 254.93 438.879 255.852C438.347 256.775 437.584 257.542 436.663 258.077L327.117 321.695C326.806 321.875 326.452 321.97 326.092 321.97C325.733 321.97 325.379 321.876 325.067 321.696C324.756 321.516 324.497 321.258 324.317 320.946C324.137 320.635 324.042 320.281 324.041 319.921V241.541C324.039 240.476 324.317 239.43 324.849 238.507C325.38 237.584 326.146 236.817 327.068 236.285Z",
    fill: "url(#paint269_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.443 236.447L436.387 173.691C436.696 173.507 437.049 173.408 437.41 173.405C437.77 173.401 438.125 173.494 438.438 173.673C438.751 173.851 439.01 174.11 439.191 174.422C439.371 174.734 439.465 175.089 439.463 175.449V252.901C439.46 253.959 439.18 254.997 438.652 255.914C438.124 256.83 437.365 257.593 436.452 258.126L327.508 321.402C327.196 321.582 326.843 321.677 326.483 321.677C326.123 321.677 325.77 321.583 325.458 321.403C325.146 321.223 324.887 320.965 324.707 320.653C324.527 320.342 324.432 319.988 324.432 319.628V241.672C324.435 240.614 324.715 239.576 325.243 238.659C325.771 237.743 326.529 236.981 327.443 236.447Z",
    fill: "url(#paint270_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.801 236.61L436.11 174.228C436.419 174.052 436.769 173.96 437.124 173.961C437.48 173.961 437.829 174.055 438.137 174.233C438.445 174.411 438.7 174.667 438.879 174.974C439.057 175.282 439.152 175.631 439.154 175.986V252.999C439.154 254.051 438.879 255.086 438.357 255.999C437.835 256.913 437.083 257.674 436.175 258.207L327.833 321.126C327.524 321.306 327.173 321.402 326.815 321.403C326.457 321.404 326.105 321.311 325.795 321.133C325.484 320.954 325.226 320.697 325.047 320.387C324.868 320.078 324.774 319.726 324.774 319.368V241.818C324.778 240.761 325.06 239.724 325.591 238.81C326.123 237.896 326.884 237.137 327.801 236.61Z",
    fill: "url(#paint271_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.159 236.789L435.882 174.717C436.189 174.536 436.538 174.439 436.894 174.437C437.25 174.435 437.601 174.526 437.91 174.703C438.219 174.88 438.476 175.136 438.654 175.444C438.833 175.752 438.926 176.102 438.926 176.458V253.048C438.924 254.095 438.648 255.124 438.125 256.032C437.603 256.94 436.852 257.695 435.947 258.223L328.224 320.784C327.916 320.96 327.568 321.052 327.214 321.052C326.86 321.052 326.512 320.959 326.204 320.783C325.897 320.607 325.641 320.354 325.461 320.049C325.282 319.744 325.185 319.397 325.18 319.043V241.948C325.18 240.903 325.456 239.875 325.978 238.97C326.501 238.064 327.253 237.312 328.159 236.789Z",
    fill: "url(#paint272_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.517 236.952L435.638 175.221C435.944 175.044 436.292 174.951 436.646 174.951C436.999 174.951 437.347 175.043 437.654 175.22C437.96 175.396 438.215 175.65 438.393 175.956C438.57 176.262 438.664 176.609 438.665 176.963V253.129C438.661 254.17 438.386 255.192 437.866 256.093C437.347 256.995 436.601 257.746 435.703 258.272L328.582 320.475C328.278 320.656 327.931 320.754 327.576 320.757C327.222 320.761 326.873 320.67 326.565 320.495C326.258 320.319 326.002 320.065 325.824 319.759C325.647 319.452 325.554 319.104 325.555 318.75V242.095C325.553 241.053 325.825 240.029 326.345 239.126C326.865 238.223 327.614 237.473 328.517 236.952Z",
    fill: "url(#paint273_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.875 237.115L435.394 175.742C435.698 175.563 436.044 175.468 436.397 175.466C436.75 175.465 437.097 175.558 437.402 175.736C437.707 175.913 437.959 176.168 438.132 176.476C438.306 176.783 438.394 177.131 438.389 177.483V253.211C438.388 254.244 438.118 255.259 437.604 256.156C437.09 257.052 436.351 257.799 435.459 258.321L328.924 320.166C328.619 320.34 328.274 320.43 327.923 320.429C327.572 320.428 327.228 320.334 326.925 320.158C326.621 319.981 326.37 319.728 326.195 319.424C326.02 319.12 325.929 318.775 325.929 318.424V242.225C325.931 241.19 326.204 240.174 326.721 239.277C327.238 238.381 327.98 237.635 328.875 237.115Z",
    fill: "url(#paint274_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.217 237.277L435.134 176.263C435.435 176.085 435.778 175.99 436.128 175.987C436.478 175.985 436.823 176.075 437.127 176.248C437.431 176.422 437.684 176.673 437.859 176.975C438.035 177.278 438.128 177.622 438.128 177.972V253.276C438.129 254.305 437.859 255.316 437.344 256.207C436.83 257.099 436.09 257.839 435.199 258.353L329.282 319.873C328.98 320.047 328.637 320.139 328.288 320.139C327.939 320.138 327.596 320.046 327.294 319.871C326.992 319.696 326.741 319.445 326.567 319.142C326.394 318.84 326.302 318.496 326.303 318.147V242.371C326.302 241.342 326.57 240.33 327.081 239.436C327.592 238.542 328.328 237.798 329.217 237.277Z",
    fill: "url(#paint275_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.575 237.456L434.89 176.767C435.191 176.594 435.532 176.502 435.88 176.501C436.227 176.501 436.569 176.592 436.87 176.765C437.172 176.938 437.423 177.187 437.598 177.487C437.773 177.788 437.866 178.129 437.868 178.476V253.341C437.869 254.364 437.601 255.369 437.089 256.255C436.578 257.141 435.841 257.876 434.955 258.386L329.64 319.563C329.339 319.737 328.997 319.829 328.65 319.829C328.302 319.83 327.96 319.739 327.659 319.566C327.357 319.393 327.107 319.144 326.932 318.844C326.756 318.543 326.663 318.202 326.662 317.854V242.583C326.649 241.547 326.912 240.526 327.424 239.625C327.936 238.724 328.678 237.976 329.575 237.456Z",
    fill: "url(#paint276_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.933 237.701L434.645 177.37C434.938 177.197 435.271 177.103 435.611 177.098C435.951 177.093 436.286 177.177 436.583 177.341C436.881 177.506 437.13 177.745 437.307 178.035C437.484 178.326 437.582 178.657 437.591 178.997V253.438C437.593 254.455 437.328 255.455 436.823 256.338C436.317 257.22 435.589 257.955 434.711 258.467L329.998 319.27C329.697 319.44 329.358 319.529 329.012 319.527C328.667 319.526 328.328 319.434 328.029 319.261C327.73 319.089 327.481 318.841 327.307 318.543C327.133 318.245 327.039 317.907 327.036 317.562V242.583C327.061 241.589 327.34 240.619 327.847 239.764C328.355 238.909 329.073 238.199 329.933 237.701Z",
    fill: "url(#paint277_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.323 237.782L434.483 177.793C434.776 177.625 435.108 177.535 435.446 177.533C435.784 177.53 436.117 177.615 436.413 177.778C436.709 177.942 436.958 178.179 437.136 178.466C437.314 178.754 437.414 179.082 437.428 179.42V253.438C437.428 254.451 437.162 255.445 436.656 256.322C436.151 257.199 435.424 257.927 434.548 258.435L330.388 318.896C330.096 319.069 329.763 319.163 329.423 319.167C329.083 319.172 328.748 319.089 328.451 318.924C328.153 318.76 327.903 318.521 327.727 318.23C327.55 317.94 327.452 317.608 327.443 317.269V242.778C327.443 241.766 327.709 240.772 328.215 239.895C328.721 239.018 329.448 238.289 330.323 237.782Z",
    fill: "url(#paint278_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.649 237.945L434.141 178.313C434.433 178.145 434.764 178.054 435.102 178.051C435.439 178.048 435.772 178.133 436.067 178.297C436.362 178.461 436.61 178.699 436.785 178.987C436.961 179.275 437.059 179.604 437.07 179.941V253.52C437.069 254.528 436.804 255.518 436.301 256.391C435.799 257.265 435.076 257.992 434.206 258.5L330.698 318.603C330.407 318.773 330.076 318.864 329.739 318.868C329.402 318.871 329.07 318.786 328.776 318.622C328.482 318.457 328.236 318.219 328.062 317.93C327.888 317.642 327.792 317.313 327.784 316.976V242.909C327.786 241.903 328.051 240.915 328.554 240.044C329.056 239.173 329.779 238.449 330.649 237.945Z",
    fill: "url(#paint279_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.991 238.124L433.897 178.834C434.187 178.663 434.516 178.571 434.853 178.567C435.189 178.564 435.521 178.649 435.814 178.814C436.107 178.978 436.352 179.217 436.524 179.507C436.696 179.796 436.789 180.125 436.794 180.462V253.699C436.788 254.689 436.524 255.66 436.027 256.517C435.53 257.373 434.818 258.085 433.962 258.581L331.056 318.343C330.766 318.514 330.436 318.606 330.1 318.61C329.763 318.613 329.432 318.528 329.138 318.363C328.845 318.199 328.6 317.96 328.428 317.67C328.256 317.381 328.163 317.052 328.159 316.715V243.055C328.156 242.057 328.416 241.075 328.913 240.209C329.41 239.344 330.127 238.624 330.991 238.124Z",
    fill: "url(#paint280_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.349 238.286L433.653 179.339C433.942 179.172 434.27 179.083 434.604 179.081C434.938 179.08 435.267 179.165 435.558 179.33C435.849 179.494 436.092 179.731 436.263 180.019C436.434 180.306 436.527 180.632 436.533 180.966V253.699C436.531 254.69 436.268 255.662 435.771 256.519C435.274 257.376 434.56 258.087 433.701 258.581L331.414 318.001C331.124 318.168 330.797 318.257 330.462 318.258C330.128 318.26 329.799 318.174 329.509 318.01C329.218 317.846 328.975 317.608 328.804 317.321C328.633 317.034 328.539 316.708 328.533 316.373V243.136C328.541 242.153 328.805 241.189 329.298 240.339C329.792 239.488 330.499 238.781 331.349 238.286Z",
    fill: "url(#paint281_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.707 238.449L433.392 179.86C433.68 179.691 434.008 179.602 434.341 179.6C434.675 179.598 435.003 179.683 435.293 179.848C435.583 180.013 435.825 180.251 435.994 180.539C436.163 180.826 436.254 181.153 436.257 181.487V253.78C436.259 254.768 436.002 255.739 435.511 256.596C435.019 257.453 434.311 258.166 433.457 258.663L331.772 317.724C331.482 317.891 331.155 317.98 330.82 317.982C330.486 317.983 330.158 317.898 329.867 317.733C329.576 317.569 329.333 317.332 329.162 317.045C328.991 316.758 328.897 316.431 328.891 316.097V243.332C328.89 242.342 329.15 241.37 329.644 240.513C330.138 239.656 330.85 238.944 331.707 238.449Z",
    fill: "url(#paint282_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.065 238.612L433.148 180.38C433.435 180.211 433.762 180.12 434.095 180.118C434.428 180.116 434.756 180.201 435.045 180.367C435.334 180.532 435.575 180.771 435.742 181.059C435.909 181.347 435.997 181.675 435.996 182.008V253.878C436.002 254.864 435.748 255.835 435.26 256.692C434.771 257.549 434.065 258.263 433.213 258.76L332.114 317.448C331.826 317.612 331.5 317.698 331.169 317.698C330.838 317.698 330.512 317.612 330.225 317.447C329.937 317.283 329.697 317.046 329.529 316.761C329.361 316.476 329.27 316.151 329.265 315.82V243.462C329.269 242.48 329.528 241.515 330.02 240.664C330.511 239.814 331.216 239.106 332.065 238.612Z",
    fill: "url(#paint283_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.423 238.775L432.855 180.885C433.142 180.72 433.467 180.632 433.797 180.632C434.128 180.632 434.453 180.718 434.74 180.883C435.027 181.048 435.265 181.285 435.431 181.571C435.598 181.857 435.686 182.182 435.687 182.512V253.976C435.7 254.963 435.448 255.937 434.959 256.795C434.47 257.653 433.76 258.366 432.904 258.858L332.423 317.22C332.136 317.385 331.812 317.472 331.481 317.473C331.15 317.473 330.825 317.386 330.538 317.222C330.251 317.057 330.013 316.82 329.847 316.534C329.68 316.248 329.592 315.923 329.591 315.592V243.608C329.597 242.625 329.862 241.66 330.359 240.812C330.856 239.963 331.568 239.261 332.423 238.775Z",
    fill: "url(#paint284_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.765 238.954L432.644 181.406C432.929 181.239 433.253 181.151 433.583 181.15C433.914 181.149 434.238 181.236 434.524 181.401C434.81 181.567 435.047 181.805 435.212 182.091C435.376 182.378 435.461 182.703 435.459 183.033V253.976C435.462 254.947 435.21 255.902 434.727 256.745C434.244 257.587 433.548 258.288 432.709 258.777L332.83 316.78C332.544 316.947 332.22 317.035 331.89 317.036C331.56 317.037 331.235 316.95 330.949 316.785C330.663 316.619 330.426 316.381 330.262 316.095C330.098 315.808 330.012 315.483 330.014 315.153V243.739C330.014 242.77 330.268 241.818 330.75 240.979C331.233 240.139 331.928 239.441 332.765 238.954Z",
    fill: "url(#paint285_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.123 239.116L432.399 181.91C432.684 181.748 433.007 181.663 433.335 181.664C433.663 181.665 433.984 181.753 434.268 181.918C434.551 182.083 434.787 182.319 434.95 182.603C435.113 182.888 435.199 183.21 435.199 183.538V254.122C435.198 255.086 434.945 256.033 434.466 256.87C433.986 257.706 433.296 258.403 432.465 258.891L333.188 316.536C332.904 316.704 332.58 316.793 332.25 316.794C331.92 316.796 331.596 316.709 331.311 316.543C331.026 316.377 330.79 316.138 330.628 315.851C330.466 315.564 330.383 315.239 330.388 314.909V243.885C330.388 242.921 330.64 241.973 331.119 241.136C331.599 240.299 332.29 239.603 333.123 239.116Z",
    fill: "url(#paint286_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.481 239.328L432.155 182.366C432.439 182.202 432.761 182.116 433.088 182.117C433.416 182.118 433.737 182.206 434.02 182.371C434.302 182.536 434.536 182.774 434.698 183.058C434.859 183.343 434.942 183.666 434.938 183.993V254.138C434.936 255.095 434.682 256.035 434.202 256.863C433.722 257.692 433.033 258.379 432.204 258.858L333.578 316.227C333.295 316.391 332.973 316.477 332.645 316.476C332.318 316.475 331.997 316.387 331.714 316.222C331.431 316.057 331.197 315.819 331.036 315.534C330.875 315.25 330.792 314.927 330.795 314.6V244.015C330.797 243.068 331.046 242.138 331.517 241.316C331.988 240.494 332.664 239.809 333.481 239.328Z",
    fill: "url(#paint287_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.839 239.442L431.895 182.952C432.177 182.787 432.499 182.7 432.826 182.7C433.153 182.701 433.474 182.789 433.756 182.954C434.037 183.12 434.27 183.358 434.429 183.644C434.589 183.929 434.669 184.252 434.662 184.579V254.301C434.663 255.253 434.414 256.188 433.939 257.014C433.465 257.839 432.783 258.526 431.96 259.004L333.888 315.967C333.605 316.132 333.284 316.218 332.957 316.218C332.63 316.218 332.309 316.13 332.027 315.964C331.745 315.798 331.513 315.56 331.353 315.275C331.194 314.989 331.114 314.666 331.121 314.339V244.211C331.113 243.247 331.361 242.298 331.838 241.461C332.315 240.623 333.006 239.927 333.839 239.442Z",
    fill: "url(#paint288_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.197 239.621L431.651 183.456C431.933 183.295 432.252 183.212 432.577 183.215C432.902 183.217 433.22 183.306 433.499 183.471C433.778 183.636 434.009 183.872 434.168 184.156C434.326 184.439 434.407 184.759 434.401 185.084V254.382C434.402 255.328 434.154 256.257 433.682 257.076C433.211 257.896 432.533 258.578 431.716 259.053L334.246 315.657C333.965 315.824 333.644 315.912 333.317 315.912C332.991 315.912 332.67 315.824 332.389 315.658C332.108 315.491 331.876 315.252 331.719 314.966C331.562 314.68 331.485 314.356 331.495 314.03V244.292C331.495 243.345 331.745 242.414 332.219 241.594C332.693 240.774 333.376 240.093 334.197 239.621Z",
    fill: "url(#paint289_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.539 239.784L431.407 183.993C431.687 183.831 432.006 183.747 432.331 183.749C432.655 183.751 432.973 183.839 433.251 184.005C433.53 184.171 433.759 184.408 433.915 184.692C434.072 184.976 434.15 185.297 434.141 185.621V254.48C434.142 255.423 433.894 256.35 433.422 257.167C432.951 257.984 432.273 258.663 431.456 259.135L334.604 315.381C334.324 315.549 334.004 315.638 333.677 315.638C333.351 315.639 333.031 315.551 332.75 315.384C332.47 315.217 332.24 314.977 332.085 314.69C331.93 314.403 331.855 314.079 331.869 313.753V244.422C331.872 243.483 332.119 242.562 332.587 241.748C333.055 240.934 333.728 240.257 334.539 239.784Z",
    fill: "url(#paint290_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.897 239.947L431.228 184.482C431.507 184.318 431.825 184.233 432.149 184.234C432.473 184.236 432.791 184.324 433.068 184.491C433.346 184.657 433.574 184.895 433.729 185.18C433.883 185.465 433.958 185.786 433.946 186.109V254.464C433.945 255.399 433.701 256.317 433.235 257.128C432.77 257.939 432.1 258.614 431.293 259.086L334.962 315.006C334.682 315.17 334.364 315.255 334.04 315.254C333.716 315.252 333.399 315.164 333.121 314.997C332.843 314.831 332.615 314.593 332.461 314.308C332.306 314.023 332.232 313.703 332.244 313.379V244.569C332.244 243.634 332.489 242.715 332.954 241.904C333.42 241.093 334.089 240.418 334.897 239.947Z",
    fill: "url(#paint291_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.206 240.109L430.853 185.002C431.132 184.837 431.449 184.751 431.773 184.752C432.096 184.753 432.414 184.842 432.691 185.009C432.968 185.176 433.195 185.414 433.347 185.7C433.499 185.985 433.571 186.307 433.555 186.63V254.627C433.552 255.555 433.308 256.466 432.846 257.271C432.383 258.076 431.719 258.746 430.918 259.216L335.255 314.762C334.983 314.919 334.674 315.002 334.361 315.002C334.047 315.002 333.738 314.92 333.466 314.763C333.194 314.607 332.968 314.381 332.811 314.11C332.653 313.838 332.57 313.53 332.569 313.216V244.699C332.572 243.771 332.816 242.859 333.279 242.054C333.741 241.249 334.405 240.579 335.206 240.109Z",
    fill: "url(#paint292_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.613 240.288L430.658 185.523C430.93 185.366 431.238 185.284 431.552 185.283C431.866 185.283 432.174 185.366 432.446 185.522C432.719 185.679 432.945 185.904 433.102 186.176C433.259 186.447 433.343 186.755 433.343 187.069V254.626C433.343 255.553 433.099 256.463 432.636 257.266C432.174 258.068 431.508 258.735 430.707 259.2L335.662 314.388C335.392 314.545 335.086 314.629 334.774 314.63C334.462 314.632 334.155 314.551 333.884 314.395C333.614 314.24 333.389 314.016 333.232 313.747C333.075 313.477 332.993 313.17 332.992 312.858V244.845C332.989 243.922 333.23 243.015 333.69 242.214C334.15 241.414 334.813 240.75 335.613 240.288Z",
    fill: "url(#paint293_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.971 240.451L430.365 186.028C430.635 185.874 430.941 185.793 431.252 185.795C431.563 185.796 431.869 185.879 432.137 186.036C432.406 186.193 432.629 186.417 432.783 186.687C432.938 186.957 433.019 187.263 433.018 187.574V254.708C433.02 255.624 432.781 256.525 432.324 257.32C431.867 258.114 431.208 258.774 430.414 259.232L336.02 314.095C335.748 314.248 335.442 314.327 335.13 314.326C334.819 314.324 334.513 314.241 334.243 314.084C333.974 313.928 333.75 313.705 333.593 313.435C333.436 313.166 333.353 312.86 333.35 312.549V244.975C333.35 244.057 333.592 243.155 334.052 242.361C334.512 241.566 335.174 240.907 335.971 240.451Z",
    fill: "url(#paint294_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.313 240.614L430.154 186.549C430.423 186.395 430.727 186.315 431.037 186.316C431.346 186.316 431.65 186.398 431.919 186.553C432.187 186.707 432.41 186.93 432.566 187.197C432.721 187.465 432.804 187.769 432.806 188.078V254.806C432.805 255.715 432.565 256.608 432.111 257.396C431.657 258.184 431.005 258.84 430.219 259.297L336.378 313.802C336.109 313.955 335.804 314.036 335.495 314.035C335.185 314.034 334.881 313.953 334.613 313.798C334.344 313.643 334.121 313.421 333.965 313.153C333.81 312.886 333.727 312.582 333.725 312.272V245.122C333.725 244.21 333.964 243.314 334.418 242.523C334.872 241.732 335.525 241.074 336.313 240.614Z",
    fill: "url(#paint295_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.671 240.777L429.909 187.069C430.175 186.914 430.476 186.832 430.784 186.831C431.091 186.831 431.393 186.911 431.659 187.065C431.925 187.219 432.146 187.44 432.299 187.707C432.452 187.973 432.531 188.276 432.53 188.583V254.854C432.53 255.76 432.293 256.65 431.842 257.436C431.39 258.221 430.741 258.874 429.958 259.33L336.736 313.477C336.469 313.63 336.167 313.712 335.859 313.712C335.551 313.712 335.249 313.632 334.982 313.479C334.715 313.325 334.493 313.105 334.338 312.839C334.183 312.573 334.101 312.271 334.099 311.963V245.236C334.101 244.333 334.34 243.446 334.791 242.664C335.242 241.882 335.89 241.231 336.671 240.777Z",
    fill: "url(#paint296_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.029 240.956L429.6 187.574C429.865 187.423 430.165 187.344 430.47 187.345C430.775 187.347 431.074 187.428 431.338 187.581C431.602 187.734 431.82 187.954 431.972 188.219C432.124 188.483 432.204 188.783 432.204 189.087V254.936C432.202 255.835 431.966 256.718 431.517 257.497C431.069 258.276 430.425 258.925 429.649 259.379L337.012 313.167C336.749 313.323 336.45 313.406 336.144 313.408C335.839 313.41 335.538 313.331 335.274 313.178C335.009 313.026 334.789 312.806 334.637 312.541C334.485 312.276 334.406 311.976 334.408 311.67V245.399C334.413 244.493 334.659 243.604 335.119 242.824C335.579 242.043 336.238 241.399 337.029 240.956Z",
    fill: "url(#paint297_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.387 241.118L429.405 188.095C429.669 187.944 429.967 187.865 430.271 187.866C430.574 187.867 430.872 187.946 431.136 188.098C431.399 188.249 431.618 188.467 431.771 188.729C431.924 188.991 432.006 189.288 432.009 189.592V255.001C432.007 255.896 431.773 256.775 431.327 257.551C430.882 258.328 430.242 258.974 429.47 259.428L337.435 312.874C337.173 313.026 336.875 313.106 336.572 313.106C336.269 313.105 335.971 313.025 335.709 312.874C335.447 312.722 335.229 312.504 335.078 312.241C334.926 311.978 334.847 311.68 334.848 311.377V245.529C334.845 244.635 335.079 243.757 335.525 242.983C335.971 242.208 336.613 241.565 337.387 241.118Z",
    fill: "url(#paint298_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.745 241.281L429.161 188.599C429.423 188.452 429.719 188.375 430.02 188.377C430.32 188.38 430.615 188.46 430.875 188.612C431.135 188.763 431.351 188.98 431.501 189.24C431.652 189.501 431.731 189.796 431.732 190.097V255.082C431.732 255.971 431.499 256.844 431.056 257.615C430.613 258.386 429.977 259.028 429.21 259.476L337.794 312.565C337.533 312.717 337.238 312.798 336.937 312.799C336.635 312.8 336.339 312.721 336.078 312.571C335.817 312.42 335.6 312.204 335.45 311.943C335.3 311.682 335.221 311.385 335.222 311.084V245.675C335.221 244.786 335.453 243.912 335.896 243.141C336.339 242.37 336.976 241.729 337.745 241.281Z",
    fill: "url(#paint299_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.086 241.444L428.917 189.12C429.171 188.942 429.471 188.84 429.781 188.827C430.091 188.813 430.399 188.889 430.667 189.044C430.936 189.2 431.154 189.429 431.297 189.705C431.439 189.981 431.5 190.292 431.472 190.601V255.164C431.471 256.044 431.239 256.909 430.799 257.671C430.359 258.434 429.727 259.067 428.965 259.509L338.152 312.256C337.899 312.438 337.599 312.543 337.287 312.56C336.976 312.576 336.667 312.503 336.396 312.349C336.125 312.195 335.904 311.966 335.76 311.69C335.615 311.414 335.553 311.102 335.58 310.791V245.838C335.577 244.95 335.807 244.078 336.247 243.307C336.687 242.536 337.321 241.893 338.086 241.444Z",
    fill: "url(#paint300_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.461 241.607L428.673 189.641C428.926 189.464 429.224 189.362 429.532 189.349C429.841 189.335 430.147 189.409 430.415 189.562C430.683 189.716 430.902 189.943 431.045 190.216C431.189 190.489 431.253 190.798 431.228 191.106V255.229C431.226 256.105 430.995 256.965 430.558 257.724C430.121 258.483 429.494 259.116 428.738 259.558L338.461 311.963C338.208 312.135 337.911 312.233 337.605 312.244C337.3 312.255 336.997 312.18 336.732 312.027C336.467 311.874 336.25 311.65 336.107 311.379C335.964 311.109 335.899 310.803 335.922 310.498V245.936C335.927 245.055 336.165 244.191 336.611 243.431C337.056 242.67 337.694 242.041 338.461 241.607Z",
    fill: "url(#paint301_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.803 241.786L428.412 190.145C428.665 189.978 428.96 189.884 429.263 189.875C429.566 189.866 429.866 189.942 430.128 190.095C430.39 190.247 430.605 190.47 430.747 190.737C430.89 191.005 430.955 191.307 430.935 191.61V255.31C430.934 256.18 430.705 257.034 430.271 257.788C429.837 258.542 429.213 259.169 428.461 259.607L338.851 311.686C338.6 311.853 338.307 311.946 338.005 311.955C337.703 311.965 337.405 311.89 337.143 311.74C336.882 311.59 336.667 311.37 336.523 311.105C336.379 310.839 336.312 310.539 336.329 310.238V246.115C336.314 245.237 336.536 244.372 336.971 243.611C337.407 242.849 338.039 242.218 338.803 241.786Z",
    fill: "url(#paint302_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.161 241.948L428.168 190.666C428.42 190.504 428.711 190.415 429.01 190.408C429.309 190.4 429.604 190.476 429.863 190.626C430.122 190.775 430.335 190.993 430.478 191.256C430.621 191.519 430.689 191.816 430.674 192.115V255.391C430.679 256.256 430.454 257.107 430.022 257.856C429.59 258.605 428.967 259.226 428.217 259.655L339.209 311.345C338.958 311.506 338.667 311.596 338.368 311.603C338.069 311.61 337.773 311.535 337.514 311.385C337.255 311.235 337.043 311.017 336.899 310.755C336.756 310.492 336.688 310.195 336.703 309.896V246.212C336.698 245.348 336.924 244.497 337.355 243.748C337.787 242.999 338.41 242.378 339.161 241.948Z",
    fill: "url(#paint303_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.519 242.111L427.973 191.171C428.224 191.009 428.516 190.919 428.815 190.912C429.114 190.905 429.409 190.98 429.668 191.13C429.927 191.28 430.14 191.498 430.283 191.761C430.426 192.023 430.494 192.32 430.479 192.619V255.457C430.482 256.317 430.258 257.163 429.83 257.909C429.401 258.655 428.783 259.274 428.038 259.704L339.633 311.052C339.381 311.209 339.092 311.295 338.795 311.3C338.499 311.305 338.207 311.228 337.95 311.079C337.694 310.93 337.483 310.714 337.341 310.454C337.198 310.193 337.13 309.899 337.143 309.603V246.359C337.132 245.505 337.347 244.663 337.764 243.918C338.181 243.172 338.786 242.549 339.519 242.111Z",
    fill: "url(#paint304_linear_1591_524)",
    fillOpacity: 0.15
  }))), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M337.823 239.507L439.069 181.177C439.357 181.009 439.684 180.919 440.018 180.917C440.351 180.915 440.68 181.001 440.97 181.166C441.26 181.331 441.502 181.569 441.671 181.857C441.84 182.144 441.93 182.471 441.933 182.805V254.789C441.939 255.777 441.683 256.75 441.192 257.607C440.7 258.465 439.99 259.177 439.134 259.671L337.888 318.489C337.6 318.657 337.272 318.746 336.939 318.748C336.605 318.75 336.277 318.665 335.987 318.5C335.697 318.335 335.455 318.097 335.286 317.809C335.117 317.522 335.026 317.195 335.023 316.861V244.373C335.025 243.388 335.285 242.421 335.776 241.567C336.267 240.714 336.972 240.003 337.823 239.507Z",
    fill: "#4B30BA"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M337.465 318.457V246.001C337.464 245.013 337.722 244.043 338.213 243.186C338.704 242.329 339.411 241.616 340.264 241.118L441.51 182.789C441.634 182.721 441.765 182.667 441.901 182.626C441.873 182.31 441.765 182.005 441.588 181.741C441.411 181.477 441.17 181.262 440.887 181.116C440.605 180.969 440.29 180.897 439.972 180.905C439.654 180.913 439.344 181.001 439.069 181.162L337.823 239.507C336.97 240.005 336.263 240.718 335.772 241.575C335.28 242.432 335.022 243.402 335.023 244.39V316.846C335.024 317.143 335.095 317.437 335.231 317.702C335.367 317.967 335.563 318.196 335.805 318.371C336.046 318.545 336.325 318.66 336.619 318.706C336.913 318.752 337.214 318.728 337.497 318.636C337.477 318.578 337.466 318.518 337.465 318.457Z",
    fill: "url(#paint305_linear_1591_524)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M376.174 251.16C378.046 249.594 379.577 247.661 380.674 245.48C381.771 243.3 382.411 240.919 382.554 238.482C382.768 237.622 382.695 236.715 382.348 235.899C382.001 235.083 381.398 234.402 380.63 233.959C379.861 233.516 378.97 233.335 378.09 233.443C377.21 233.552 376.389 233.944 375.751 234.56C372.772 236.476 370.458 239.268 369.127 242.551L367.011 241.639C368.544 237.899 371.199 234.726 374.612 232.558C375.608 231.751 376.825 231.265 378.103 231.165C379.381 231.065 380.66 231.355 381.769 231.997C382.879 232.639 383.767 233.603 384.317 234.761C384.867 235.919 385.052 237.216 384.849 238.482C384.689 241.258 383.966 243.972 382.723 246.459C381.481 248.947 379.746 251.155 377.623 252.951L376.174 251.16ZM371.389 255.555C372.934 255.507 374.439 255.052 375.751 254.236L374.612 252.251C373.974 252.867 373.153 253.259 372.273 253.367C371.393 253.476 370.501 253.295 369.733 252.852C368.965 252.409 368.362 251.728 368.014 250.912C367.667 250.096 367.595 249.189 367.809 248.328C367.819 247.093 368.006 245.866 368.362 244.683L366.133 244.048C365.724 245.439 365.511 246.879 365.498 248.328C365.376 249.59 365.598 250.861 366.139 252.007C366.681 253.153 367.522 254.131 368.574 254.838C369.427 255.341 370.399 255.605 371.389 255.603V255.555ZM403.939 226.764H406.234C406.437 225.497 406.25 224.198 405.698 223.039C405.146 221.881 404.255 220.917 403.143 220.276C402.031 219.636 400.751 219.348 399.472 219.452C398.193 219.555 396.975 220.045 395.981 220.856C395.105 221.364 394.287 221.964 393.539 222.647L395.167 224.356C395.796 223.781 396.483 223.274 397.218 222.842C397.855 222.226 398.676 221.834 399.556 221.726C400.437 221.617 401.328 221.798 402.096 222.241C402.864 222.684 403.468 223.365 403.815 224.181C404.162 224.997 404.234 225.904 404.02 226.764H403.939ZM386.883 236.611H389.194C389.419 232.609 390.991 228.8 393.653 225.804L391.912 224.307C388.907 227.723 387.161 232.065 386.964 236.611H386.883ZM392.775 243.837C394.317 243.789 395.82 243.341 397.136 242.535C399.47 241.003 401.465 239.011 402.998 236.679C404.532 234.347 405.572 231.727 406.055 228.978L403.776 228.62C403.361 231.033 402.455 233.335 401.114 235.384C399.773 237.434 398.026 239.186 395.981 240.533C395.318 241.014 394.549 241.329 393.739 241.451C392.929 241.572 392.101 241.498 391.326 241.233C390.745 240.899 390.256 240.428 389.901 239.86C389.546 239.292 389.337 238.646 389.292 237.978L387.029 238.352C387.132 239.37 387.483 240.347 388.05 241.198C388.617 242.049 389.385 242.748 390.284 243.234C391.083 243.632 391.964 243.838 392.856 243.837H392.775ZM360.062 249.207L362.324 248.849C362.225 247.969 361.948 247.117 361.508 246.348C361.069 245.578 360.477 244.907 359.769 244.374L358.451 246.262C358.918 246.612 359.31 247.054 359.601 247.56C359.892 248.067 360.076 248.627 360.143 249.207H360.062ZM349.011 267.712C350.555 267.656 352.057 267.202 353.373 266.394L352.217 264.392C351.58 265.008 350.759 265.4 349.879 265.508C348.999 265.617 348.107 265.436 347.339 264.993C346.571 264.55 345.967 263.869 345.62 263.053C345.273 262.237 345.201 261.33 345.415 260.47C345.591 257.717 346.401 255.041 347.781 252.653C349.162 250.265 351.075 248.228 353.373 246.701C354.486 245.976 355.808 245.639 357.133 245.741L357.474 243.462C355.631 243.281 353.78 243.722 352.217 244.715C349.572 246.444 347.37 248.771 345.789 251.507C344.209 254.244 343.294 257.314 343.12 260.47C343.003 261.731 343.227 263 343.768 264.145C344.309 265.29 345.148 266.269 346.196 266.98C347.076 267.484 348.078 267.737 349.093 267.712H349.011ZM356.319 264.131C359.996 260.563 362.193 255.74 362.471 250.623H360.176C359.891 255.112 357.948 259.335 354.724 262.471L356.319 264.131Z",
    fill: "#5A3CFF"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M436.268 225.706V230.263L344.982 283.286V278.762L436.268 225.706Z",
    fill: "#F9F7F9"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M436.268 238.042V242.599L344.982 295.623V291.098L436.268 238.042Z",
    fill: "#F9F7F9"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M406.323 268.59V273.147L344.982 308.578V304.053L406.323 268.59Z",
    fill: "#F9F7F9"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M432.278 377.274L433.905 376.818C435.159 376.456 436.478 376.384 437.764 376.606C439.05 376.829 440.268 377.341 441.327 378.104L442.954 376.9L444.582 380.708L452.572 380.041L450.766 387.137C450.709 387.361 450.596 387.568 450.436 387.736C450.276 387.904 450.076 388.028 449.855 388.097L446.6 389.057C445.254 389.449 443.828 389.482 442.466 389.15C441.103 388.819 439.852 388.136 438.836 387.169L431.562 380.236C431.337 380.023 431.173 379.755 431.086 379.459C430.998 379.162 430.99 378.848 431.063 378.548C431.136 378.247 431.286 377.972 431.499 377.748C431.713 377.524 431.981 377.361 432.278 377.274Z",
    fill: "black"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M432.28 377.274L433.907 376.818C435.161 376.456 436.48 376.384 437.766 376.606C439.052 376.829 440.27 377.341 441.329 378.104L442.956 376.9L444.584 380.708L452.575 380.041L451.68 383.719C451.482 384.523 451.077 385.261 450.506 385.86C449.935 386.46 449.218 386.9 448.425 387.137L447.025 387.543C445.679 387.936 444.254 387.968 442.891 387.637C441.529 387.306 440.277 386.622 439.262 385.656L431.971 378.722C431.722 378.479 431.552 378.168 431.482 377.827C431.69 377.57 431.967 377.378 432.28 377.274Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M443.522 379.943C441.894 378.316 442.301 376.526 444.531 375.875C445.763 375.597 447.042 375.61 448.268 375.912C449.494 376.214 450.633 376.798 451.594 377.616C451.983 377.865 452.284 378.229 452.456 378.657C452.627 379.086 452.661 379.557 452.551 380.005C452.442 380.454 452.195 380.856 451.846 381.158C451.496 381.459 451.061 381.643 450.601 381.685C449.367 381.965 448.085 381.954 446.856 381.651C445.627 381.349 444.485 380.764 443.522 379.943Z",
    fill: "black"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M447.916 380.204C448.617 380.199 449.287 379.918 449.781 379.421C450.275 378.924 450.552 378.252 450.552 377.551V367.379C450.552 366.68 450.275 366.009 449.78 365.515C449.286 365.02 448.615 364.743 447.916 364.743C447.217 364.743 446.546 365.02 446.052 365.515C445.557 366.009 445.279 366.68 445.279 367.379V377.551C445.277 377.898 445.344 378.243 445.475 378.565C445.607 378.887 445.801 379.179 446.046 379.426C446.291 379.672 446.582 379.868 446.903 380.001C447.224 380.135 447.568 380.204 447.916 380.204Z",
    fill: "#EF9EA3"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M447.921 377.03H448.1C450.395 376.932 452.169 377.99 452.055 375.695L450.932 349.297L452.072 309.456C452.098 308.357 451.688 307.291 450.932 306.493C450.176 305.694 449.135 305.226 448.035 305.192C445.757 305.111 442.714 306.934 442.648 309.228V349.525L443.771 376.037C443.869 378.299 445.708 377.03 447.921 377.03Z",
    fill: "#5A3CFF"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M421.213 387.43L422.613 386.632C423.745 385.981 425.01 385.595 426.312 385.505C427.615 385.415 428.921 385.622 430.132 386.111L431.418 384.484L433.94 387.739L441.541 385.167V392.491C441.539 392.721 441.479 392.947 441.365 393.146C441.251 393.346 441.087 393.513 440.89 393.63L437.928 395.339C436.712 396.039 435.335 396.407 433.932 396.407C432.53 396.407 431.152 396.039 429.937 395.339L421.213 390.343C420.975 390.182 420.78 389.965 420.645 389.711C420.51 389.457 420.439 389.174 420.439 388.886C420.439 388.599 420.51 388.315 420.645 388.061C420.78 387.807 420.975 387.59 421.213 387.43Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M421.213 387.43L422.613 386.632C423.745 385.981 425.01 385.595 426.313 385.505C427.615 385.415 428.921 385.622 430.132 386.111L431.418 384.484L433.94 387.739L441.541 385.167V389.057C441.542 389.883 441.326 390.696 440.915 391.413C440.504 392.13 439.911 392.726 439.197 393.142L437.928 393.874C436.712 394.574 435.335 394.942 433.932 394.942C432.53 394.942 431.152 394.574 429.937 393.874L421.213 388.862C420.909 388.69 420.665 388.428 420.514 388.113C420.68 387.825 420.922 387.589 421.213 387.43Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M432.768 387.429C432.328 387.282 431.945 387 431.673 386.624C431.402 386.247 431.256 385.794 431.256 385.33C431.256 384.865 431.402 384.413 431.673 384.036C431.945 383.659 432.328 383.377 432.768 383.23C433.898 382.666 435.143 382.372 436.406 382.372C437.668 382.372 438.914 382.666 440.043 383.23C440.484 383.377 440.867 383.659 441.138 384.036C441.41 384.413 441.556 384.865 441.556 385.33C441.556 385.794 441.41 386.247 441.138 386.624C440.867 387 440.484 387.282 440.043 387.429C438.914 387.994 437.668 388.287 436.406 388.287C435.143 388.287 433.898 387.994 432.768 387.429Z",
    fill: "black"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M436.408 386.925C437.107 386.925 437.778 386.647 438.272 386.153C438.767 385.658 439.045 384.988 439.045 384.289V374.101C439.045 373.401 438.767 372.731 438.272 372.236C437.778 371.742 437.107 371.464 436.408 371.464C435.709 371.464 435.038 371.742 434.544 372.236C434.049 372.731 433.771 373.401 433.771 374.101V384.289C433.776 384.987 434.055 385.655 434.548 386.148C435.042 386.642 435.71 386.921 436.408 386.925Z",
    fill: "#EF9EA3"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M447.924 316.292C448.453 316.291 448.972 316.15 449.429 315.884C449.886 315.619 450.265 315.237 450.528 314.779L455.997 305.323C458.74 300.557 459.655 294.956 458.571 289.565C457.487 284.174 454.477 279.363 450.105 276.028L448.624 274.889C447.984 274.471 447.209 274.31 446.456 274.44C445.702 274.569 445.025 274.979 444.562 275.587C444.098 276.195 443.881 276.956 443.956 277.717C444.03 278.478 444.39 279.183 444.962 279.69L446.46 280.829C449.662 283.278 451.865 286.807 452.659 290.759C453.452 294.711 452.782 298.817 450.772 302.312L445.304 311.751C444.903 312.446 444.794 313.272 445.002 314.047C445.209 314.823 445.716 315.484 446.411 315.885C446.87 316.154 447.393 316.294 447.924 316.292Z",
    fill: "black"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M436.416 384.711H436.758C439.037 384.532 440.745 384.711 440.55 382.498L438.32 352.21L447.353 312.988C447.499 310.693 438.971 312.304 436.677 312.158C435.581 312.091 434.503 312.461 433.68 313.187C432.856 313.913 432.354 314.936 432.282 316.031L430.004 352.292L432.282 383.214C432.461 385.33 434.284 384.711 436.416 384.711Z",
    fill: "#5A3CFF"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M450.524 314.779C450.261 315.238 449.882 315.619 449.425 315.885C448.968 316.15 448.449 316.291 447.92 316.293C447.388 316.294 446.866 316.154 446.407 315.886C445.712 315.484 445.205 314.823 444.998 314.048C444.79 313.273 444.899 312.447 445.3 311.752L450.768 302.312C451.638 300.794 452.259 299.145 452.607 297.43C452.584 300.151 452.752 302.87 453.112 305.567L453.535 309.538L450.524 314.779Z",
    fill: "#231F20"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M452.86 260.225L439.84 267.744C437.001 269.381 434.644 271.736 433.004 274.573C431.364 277.41 430.5 280.628 430.498 283.905V320.979C435.787 324.69 450.028 319.531 452.86 313.737L451.997 305.6C451.569 302.363 451.411 299.097 451.525 295.835L452.86 260.225Z",
    fill: "black"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M447.807 268.362H443.461C440.543 268.362 437.745 267.203 435.682 265.14C433.619 263.077 432.459 260.278 432.459 257.36V250.639H447.807V268.362Z",
    fill: "#F2B1B5"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M443.594 271.341H441.771C441.163 271.341 440.579 271.099 440.149 270.668C439.718 270.238 439.476 269.654 439.476 269.046V258.516H445.889V269.046C445.889 269.654 445.647 270.238 445.217 270.668C444.786 271.099 444.203 271.341 443.594 271.341Z",
    fill: "#F2B1B5"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M430.498 292.026C430.965 291.851 431.374 291.547 431.676 291.15C431.978 290.752 432.162 290.278 432.207 289.78L433.411 280.357C433.517 279.564 433.932 278.845 434.566 278.357C435.201 277.869 436.003 277.652 436.796 277.753C438.424 277.965 438.522 279.706 438.31 281.366L438.18 290.545C437.995 292.241 437.315 293.845 436.224 295.157C435.132 296.468 433.679 297.429 432.044 297.918C431.542 298.077 431.023 298.181 430.498 298.227V292.026Z",
    fill: "#231F20"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M422.887 293.621L414.163 283.693C413.902 283.396 413.701 283.05 413.573 282.676C413.444 282.301 413.391 281.905 413.416 281.51C413.441 281.114 413.544 280.728 413.718 280.372C413.892 280.017 414.135 279.699 414.432 279.437C414.729 279.175 415.075 278.975 415.449 278.846C415.824 278.718 416.22 278.665 416.615 278.69C417.011 278.715 417.397 278.818 417.753 278.992C418.108 279.166 418.426 279.409 418.688 279.706L427.427 289.633C427.777 290.028 428.233 290.314 428.741 290.456C429.248 290.599 429.786 290.593 430.29 290.439C430.795 290.284 431.244 289.988 431.585 289.586C431.925 289.183 432.143 288.691 432.212 288.169L433.417 278.762C433.518 277.968 433.931 277.246 434.564 276.756C435.197 276.266 435.999 276.048 436.794 276.15C437.588 276.251 438.309 276.664 438.799 277.297C439.289 277.931 439.507 278.733 439.406 279.527L438.185 288.95C437.999 290.642 437.317 292.241 436.226 293.546C435.134 294.852 433.681 295.807 432.049 296.29C431.208 296.56 430.329 296.697 429.445 296.697C428.196 296.684 426.963 296.403 425.832 295.872C424.7 295.341 423.696 294.573 422.887 293.621Z",
    fill: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M420.136 281.35L418.688 279.722C418.426 279.425 418.108 279.183 417.753 279.008C417.397 278.834 417.011 278.732 416.615 278.707C416.22 278.682 415.824 278.735 415.449 278.863C415.075 278.991 414.729 279.192 414.432 279.454C414.135 279.716 413.892 280.033 413.718 280.389C413.544 280.745 413.441 281.131 413.416 281.526C413.391 281.921 413.444 282.318 413.573 282.692C413.701 283.067 413.902 283.413 414.163 283.71L415.905 285.695L420.136 281.35Z",
    fill: "#F2B1B5"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M411.33 280.78C411.327 281.506 411.539 282.216 411.94 282.821C412.342 283.425 412.913 283.897 413.583 284.177C414.253 284.456 414.991 284.53 415.702 284.389C416.414 284.248 417.068 283.899 417.581 283.386C418.094 282.873 418.443 282.219 418.584 281.507C418.725 280.795 418.651 280.057 418.372 279.388C418.093 278.718 417.621 278.146 417.016 277.745C416.412 277.344 415.701 277.131 414.976 277.135C414.01 277.139 413.085 277.524 412.403 278.207C411.72 278.89 411.334 279.815 411.33 280.78Z",
    fill: "#F2B1B5"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M416.57 279.48L411.711 274.376C411.604 274.264 411.546 274.113 411.55 273.958C411.554 273.803 411.619 273.655 411.732 273.548L412.062 273.234C412.171 273.13 412.317 273.073 412.469 273.077C412.62 273.081 412.763 273.144 412.867 273.254L417.771 278.405C417.878 278.517 417.936 278.668 417.932 278.823C417.928 278.979 417.863 279.126 417.75 279.233L417.42 279.547C417.366 279.599 417.302 279.639 417.233 279.666C417.163 279.693 417.088 279.706 417.014 279.704C416.939 279.702 416.865 279.686 416.797 279.656C416.728 279.625 416.667 279.582 416.615 279.528L416.57 279.48Z",
    fill: "#F2B1B5"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M431.37 247.579C434.022 244.438 440.223 245.382 443.657 246.472C447.889 247.839 453.178 249.418 453.943 254.61C454.041 255.915 454.041 257.226 453.943 258.532C453.929 261.564 454.626 264.557 455.977 267.271C457.898 271.129 458.825 273.602 456.791 277.606C455.587 279.982 454.805 283.677 452.348 285.125C449.89 286.574 444.438 287.566 442.013 285.727C438.644 283.172 436.936 276.955 437.245 272.968C437.57 268.671 439.719 264.326 438.417 260.208C437.603 257.637 434.136 254.74 432.183 252.933C430.23 251.127 429.612 249.662 431.37 247.579Z",
    fill: "black"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.364 247.58C432.91 245.741 435.693 245.317 438.411 245.496C437.46 245.479 436.515 245.654 435.634 246.012C434.753 246.371 433.954 246.904 433.284 247.58C431.527 249.663 432.422 251.258 434.147 252.853C435.872 254.448 439.583 257.556 440.396 260.128C441.698 264.245 439.55 268.591 439.208 272.887C438.899 276.874 440.608 283.091 443.993 285.647C444.898 286.245 445.952 286.577 447.037 286.607C445.315 286.877 443.554 286.538 442.056 285.647C438.688 283.091 436.979 276.874 437.288 272.887C437.613 268.591 439.762 264.245 438.46 260.128C437.646 257.556 434.179 254.659 432.226 252.853C430.273 251.046 429.606 249.663 431.364 247.58Z",
    fill: "#FEC55E"
  }))), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M411.968 495.267C408.741 493.638 405.176 492.789 401.56 492.789C397.945 492.789 394.38 493.638 391.153 495.267L322.896 534.669C317.167 537.924 317.118 543.474 322.782 546.891L354.453 565.998C357.638 567.688 361.181 568.588 364.786 568.625C368.391 568.662 371.952 567.834 375.171 566.21L444.697 526.173C450.426 522.918 450.426 517.466 444.697 514.162L411.968 495.267Z",
    fill: "black"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_1591_524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.924 498.538C404.272 497.198 401.342 496.5 398.371 496.5C395.4 496.5 392.47 497.198 389.819 498.538L333.752 530.909C329.048 533.611 328.999 538.135 333.654 540.934L359.612 556.688C362.226 558.076 365.135 558.817 368.094 558.848C371.054 558.879 373.977 558.2 376.62 556.867L433.745 523.976C438.448 521.258 438.448 516.815 433.745 514.113L406.924 498.538Z",
    fill: "url(#paint306_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 556.135L433.81 523.244C438.513 520.526 438.513 516.083 433.81 513.365L406.924 497.838C404.27 496.506 401.341 495.812 398.371 495.812C395.401 495.812 392.473 496.506 389.819 497.838L333.752 530.209C329.048 532.927 328.999 537.451 333.654 540.251L359.694 555.956C362.307 557.337 365.212 558.074 368.168 558.105C371.123 558.136 374.043 557.461 376.685 556.135Z",
    fill: "url(#paint307_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 555.452L433.81 522.511C438.513 519.809 438.513 515.366 433.81 512.649L406.924 497.122C404.272 495.782 401.342 495.084 398.371 495.084C395.4 495.084 392.47 495.782 389.819 497.122L333.752 529.493C329.048 532.211 328.999 536.735 333.654 539.535L359.694 555.24C362.304 556.626 365.208 557.368 368.164 557.405C371.119 557.442 374.041 556.772 376.685 555.452Z",
    fill: "url(#paint308_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 554.752L433.81 521.86C438.513 519.159 438.513 514.715 433.81 511.998L406.924 496.471C404.272 495.131 401.342 494.433 398.371 494.433C395.4 494.433 392.47 495.131 389.819 496.471L333.752 528.842C329.048 531.56 328.999 536.068 333.654 538.884L359.694 554.589C362.307 555.971 365.213 556.708 368.17 556.736C371.126 556.764 374.046 556.084 376.685 554.752Z",
    fill: "url(#paint309_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 554.068L433.81 521.177C438.513 518.459 438.513 514.032 433.81 511.314L406.924 495.788C404.272 494.447 401.342 493.749 398.371 493.749C395.4 493.749 392.47 494.447 389.819 495.788L333.752 528.159C329.048 530.876 328.999 535.385 333.654 538.2L359.694 553.889C362.304 555.278 365.211 556.019 368.168 556.05C371.124 556.082 374.046 555.402 376.685 554.068Z",
    fill: "url(#paint310_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 553.433L433.81 520.542C438.513 517.824 438.513 513.381 433.81 510.679L406.924 495.153C404.272 493.813 401.342 493.115 398.371 493.115C395.4 493.115 392.47 493.813 389.819 495.153L333.752 527.524C329.048 530.225 328.999 534.75 333.654 537.549L359.694 553.254C362.306 554.639 365.211 555.378 368.168 555.41C371.124 555.441 374.044 554.763 376.685 553.433Z",
    fill: "url(#paint311_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 552.701L433.81 519.809C438.513 517.092 438.513 512.649 433.81 509.931L406.924 494.404C404.27 493.072 401.341 492.378 398.371 492.378C395.401 492.378 392.473 493.072 389.819 494.404L333.752 526.775C329.048 529.493 328.999 534.017 333.654 536.817L359.694 552.522C362.307 553.903 365.212 554.64 368.168 554.671C371.123 554.702 374.043 554.027 376.685 552.701Z",
    fill: "url(#paint312_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 552.018L433.81 519.11C438.513 516.408 438.513 511.965 433.81 509.247L406.924 493.721C404.272 492.381 401.342 491.682 398.371 491.682C395.4 491.682 392.47 492.381 389.819 493.721L333.752 526.092C329.048 528.81 328.999 533.334 333.654 536.133L359.612 551.806C362.233 553.206 365.152 553.955 368.123 553.992C371.094 554.029 374.03 553.352 376.685 552.018Z",
    fill: "url(#paint313_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 551.318L433.81 518.426C438.513 515.724 438.513 511.281 433.81 508.564L406.924 493.037C404.272 491.697 401.342 490.999 398.371 490.999C395.4 490.999 392.47 491.697 389.819 493.037L333.752 525.408C329.048 528.126 328.999 532.634 333.654 535.45L359.694 551.155C362.307 552.537 365.213 553.274 368.17 553.302C371.126 553.33 374.046 552.65 376.685 551.318Z",
    fill: "url(#paint314_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 550.634L433.81 517.743C438.513 515.025 438.513 510.598 433.81 507.88L406.924 492.354C404.272 491.014 401.342 490.315 398.371 490.315C395.4 490.315 392.47 491.014 389.819 492.354L333.752 524.724C329.048 527.442 328.999 531.951 333.654 534.766L359.694 550.455C362.304 551.844 365.211 552.585 368.168 552.616C371.124 552.648 374.046 551.968 376.685 550.634Z",
    fill: "url(#paint315_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 549.951L433.81 517.059C438.513 514.341 438.513 509.898 433.81 507.196L406.924 491.67C404.272 490.33 401.342 489.632 398.371 489.632C395.4 489.632 392.47 490.33 389.819 491.67L333.752 524.041C329.048 526.743 328.999 531.267 333.654 534.066L359.694 549.772C362.306 551.157 365.211 551.895 368.168 551.927C371.124 551.958 374.044 551.28 376.685 549.951Z",
    fill: "url(#paint316_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 549.267L433.81 516.376C438.513 513.658 438.513 509.215 433.81 506.497L406.924 490.97C404.27 489.638 401.341 488.944 398.371 488.944C395.401 488.944 392.473 489.638 389.819 490.97L333.752 523.341C329.048 526.059 328.999 530.583 333.654 533.383L359.694 549.088C362.306 550.473 365.211 551.212 368.168 551.243C371.124 551.274 374.044 550.597 376.685 549.267Z",
    fill: "url(#paint317_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 548.551L433.81 515.643C438.513 512.941 438.513 508.498 433.81 505.781L406.924 490.254C404.272 488.914 401.342 488.216 398.371 488.216C395.4 488.216 392.47 488.914 389.819 490.254L333.752 522.625C329.048 525.343 328.999 529.867 333.654 532.667L359.694 548.372C362.307 549.753 365.212 550.49 368.168 550.521C371.123 550.552 374.043 549.877 376.685 548.551Z",
    fill: "url(#paint318_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 547.884L433.81 514.992C438.513 512.29 438.513 507.847 433.81 505.13L406.924 489.603C404.272 488.263 401.342 487.565 398.371 487.565C395.4 487.565 392.47 488.263 389.819 489.603L333.752 521.974C329.048 524.692 328.999 529.2 333.654 532.016L359.694 547.721C362.307 549.103 365.213 549.84 368.17 549.868C371.126 549.896 374.046 549.216 376.685 547.884Z",
    fill: "url(#paint319_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 547.2L433.81 514.374C438.513 511.656 438.513 507.229 433.81 504.511L406.924 488.985C404.272 487.645 401.342 486.946 398.371 486.946C395.4 486.946 392.47 487.645 389.819 488.985L333.752 521.356C329.048 524.074 328.999 528.582 333.654 531.397L359.694 547.102C362.312 548.475 365.221 549.2 368.177 549.217C371.134 549.234 374.051 548.542 376.685 547.2Z",
    fill: "url(#paint320_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 546.517L433.81 513.625C438.513 510.907 438.513 506.48 433.81 503.762L406.924 488.236C404.272 486.896 401.342 486.198 398.371 486.198C395.4 486.198 392.47 486.896 389.819 488.236L333.752 520.607C329.048 523.309 328.999 527.833 333.654 530.632L359.694 546.338C362.304 547.726 365.211 548.468 368.168 548.499C371.124 548.53 374.046 547.85 376.685 546.517Z",
    fill: "url(#paint321_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 545.833L433.81 512.941C438.513 510.224 438.513 505.781 433.81 503.063L406.924 487.553C404.272 486.212 401.342 485.514 398.371 485.514C395.4 485.514 392.47 486.212 389.819 487.553L333.752 519.907C329.048 522.625 328.999 527.149 333.654 529.949L359.694 545.654C362.306 547.039 365.211 547.778 368.168 547.809C371.124 547.84 374.044 547.163 376.685 545.833Z",
    fill: "url(#paint322_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 545.15L433.81 512.242C438.513 509.54 438.513 505.097 433.81 502.379L406.924 486.853C404.272 485.513 401.342 484.814 398.371 484.814C395.4 484.814 392.47 485.513 389.819 486.853L333.752 519.256C329.048 521.974 328.999 526.499 333.654 529.298L359.694 545.003C362.31 546.379 365.216 547.11 368.172 547.136C371.127 547.161 374.046 546.48 376.685 545.15Z",
    fill: "url(#paint323_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 544.45L433.81 511.558C438.513 508.856 438.513 504.413 433.81 501.696L406.924 486.169C404.272 484.829 401.342 484.131 398.371 484.131C395.4 484.131 392.47 484.829 389.819 486.169L333.752 518.54C329.048 521.258 328.999 525.766 333.654 528.582L359.694 544.287C362.307 545.669 365.213 546.406 368.17 546.434C371.126 546.462 374.046 545.782 376.685 544.45Z",
    fill: "url(#paint324_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 543.766L433.81 510.875C438.513 508.157 438.513 503.73 433.81 501.012L406.924 485.486C404.272 484.146 401.342 483.447 398.371 483.447C395.4 483.447 392.47 484.146 389.819 485.486L333.752 517.857C329.048 520.574 328.999 525.083 333.654 527.898L359.612 543.669C362.241 545.054 365.165 545.787 368.137 545.804C371.108 545.821 374.04 545.122 376.685 543.766Z",
    fill: "url(#paint325_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 543.083L433.81 510.191C438.513 507.473 438.513 503.046 433.81 500.328L406.924 484.802C404.272 483.462 401.342 482.764 398.371 482.764C395.4 482.764 392.47 483.462 389.819 484.802L333.752 517.173C329.048 519.891 328.999 524.399 333.654 527.198L359.694 542.904C362.304 544.292 365.211 545.034 368.168 545.065C371.124 545.096 374.046 544.416 376.685 543.083Z",
    fill: "url(#paint326_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 542.399L433.81 509.491C438.513 506.773 438.513 502.33 433.81 499.612L406.924 484.102C404.272 482.762 401.342 482.064 398.371 482.064C395.4 482.064 392.47 482.762 389.819 484.102L333.752 516.457C329.048 519.175 328.999 523.699 333.654 526.498L359.694 542.204C362.304 543.591 365.209 544.333 368.166 544.367C371.122 544.401 374.043 543.726 376.685 542.399Z",
    fill: "url(#paint327_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 541.715L433.81 508.808C438.513 506.106 438.513 501.663 433.81 498.945L406.924 483.451C404.27 482.119 401.341 481.425 398.371 481.425C395.401 481.425 392.473 482.119 389.819 483.451L333.752 515.822C329.048 518.54 328.999 523.064 333.654 525.864L359.694 541.569C362.31 542.945 365.216 543.676 368.172 543.702C371.127 543.727 374.046 543.046 376.685 541.715Z",
    fill: "url(#paint328_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 541.016L433.81 508.124C438.513 505.422 438.513 500.979 433.81 498.262L406.924 482.735C404.272 481.395 401.342 480.697 398.371 480.697C395.4 480.697 392.47 481.395 389.819 482.735L333.752 515.106C329.048 517.824 328.999 522.332 333.654 525.148L359.694 540.853C362.307 542.235 365.213 542.972 368.17 543C371.126 543.028 374.046 542.348 376.685 541.016Z",
    fill: "url(#paint329_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 540.414L433.81 507.522C438.513 504.82 438.513 500.377 433.81 497.659L406.924 482.133C404.272 480.793 401.342 480.095 398.371 480.095C395.4 480.095 392.47 480.793 389.819 482.133L333.752 514.374C329.048 517.092 328.999 521.6 333.654 524.415L359.694 540.121C362.297 541.523 365.198 542.282 368.154 542.333C371.11 542.384 374.035 541.726 376.685 540.414Z",
    fill: "url(#paint330_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 539.649L433.81 506.757C438.513 504.039 438.513 499.612 433.81 496.894L406.924 481.368C404.272 480.028 401.342 479.33 398.371 479.33C395.4 479.33 392.47 480.028 389.819 481.368L333.752 513.739C329.048 516.457 328.999 520.965 333.654 523.764L359.694 539.47C362.304 540.858 365.211 541.6 368.168 541.631C371.124 541.662 374.046 540.982 376.685 539.649Z",
    fill: "url(#paint331_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 538.965L433.81 506.073C438.513 503.356 438.513 498.913 433.81 496.211L406.924 480.685C404.272 479.344 401.342 478.646 398.371 478.646C395.4 478.646 392.47 479.344 389.819 480.685L333.752 513.039C329.048 515.757 328.999 520.281 333.654 523.081L359.612 538.786C362.235 540.185 365.155 540.931 368.127 540.962C371.098 540.993 374.034 540.308 376.685 538.965Z",
    fill: "url(#paint332_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 538.282L433.81 505.374C438.513 502.672 438.513 498.229 433.81 495.511L406.924 479.985C404.27 478.652 401.341 477.958 398.371 477.958C395.401 477.958 392.473 478.652 389.819 479.985L333.752 512.356C329.048 515.074 328.999 519.598 333.654 522.397L359.694 538.102C362.307 539.484 365.212 540.22 368.168 540.251C371.123 540.283 374.043 539.607 376.685 538.282Z",
    fill: "url(#paint333_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 537.582L433.81 504.69C438.513 501.988 438.513 497.545 433.81 494.827L406.924 479.301C404.272 477.961 401.342 477.263 398.371 477.263C395.4 477.263 392.47 477.961 389.819 479.301L333.752 511.672C329.048 514.39 328.999 518.914 333.654 521.714L359.694 537.419C362.307 538.801 365.213 539.538 368.17 539.566C371.126 539.594 374.046 538.914 376.685 537.582Z",
    fill: "url(#paint334_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 536.898L433.81 504.007C438.513 501.305 438.513 496.862 433.81 494.144L406.924 478.569C404.272 477.229 401.342 476.53 398.371 476.53C395.4 476.53 392.47 477.229 389.819 478.569L333.752 510.94C329.048 513.658 328.999 518.166 333.654 520.981L359.694 536.687C362.303 538.077 365.207 538.821 368.164 538.858C371.12 538.895 374.042 538.223 376.685 536.898Z",
    fill: "url(#paint335_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 536.215L433.81 503.323C438.513 500.605 438.513 496.178 433.81 493.46L406.924 477.934C404.272 476.594 401.342 475.896 398.371 475.896C395.4 475.896 392.47 476.594 389.819 477.934L333.752 510.305C329.048 513.023 328.999 517.531 333.654 520.347L359.694 536.036C362.304 537.424 365.211 538.166 368.168 538.197C371.124 538.228 374.046 537.548 376.685 536.215Z",
    fill: "url(#paint336_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 535.531L433.81 502.639C438.513 499.922 438.513 495.479 433.81 492.777L406.924 477.251C404.272 475.91 401.342 475.212 398.371 475.212C395.4 475.212 392.47 475.91 389.819 477.251L333.752 509.621C329.048 512.323 328.999 516.847 333.654 519.647L359.694 535.352C362.306 536.737 365.211 537.476 368.168 537.507C371.124 537.538 374.044 536.861 376.685 535.531Z",
    fill: "url(#paint337_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 534.847L433.81 501.94C438.513 499.238 438.513 494.795 433.81 492.077L406.924 476.551C404.27 475.218 401.341 474.524 398.371 474.524C395.401 474.524 392.473 475.218 389.819 476.551L333.752 508.922C329.048 511.639 328.999 516.164 333.654 518.963L359.694 534.668C362.307 536.05 365.212 536.786 368.168 536.817C371.123 536.849 374.043 536.173 376.685 534.847Z",
    fill: "url(#paint338_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 534.148L433.81 501.256C438.513 498.554 438.513 494.111 433.81 491.394L406.924 475.867C404.272 474.527 401.342 473.829 398.371 473.829C395.4 473.829 392.47 474.527 389.819 475.867L333.752 508.238C329.048 510.956 328.999 515.48 333.654 518.28L359.694 533.985C362.307 535.367 365.213 536.104 368.17 536.132C371.126 536.16 374.046 535.48 376.685 534.148Z",
    fill: "url(#paint339_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 533.464L433.81 500.573C438.513 497.871 438.513 493.428 433.81 490.71L406.924 475.184C404.272 473.844 401.342 473.145 398.371 473.145C395.4 473.145 392.47 473.844 389.819 475.184L333.752 507.554C329.048 510.272 328.999 514.781 333.654 517.596L359.694 533.301C362.307 534.684 365.213 535.42 368.17 535.448C371.126 535.477 374.046 534.796 376.685 533.464Z",
    fill: "url(#paint340_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 532.781L433.81 499.889C438.513 497.171 438.513 492.744 433.81 490.026L406.924 474.5C404.272 473.16 401.342 472.462 398.371 472.462C395.4 472.462 392.47 473.16 389.819 474.5L333.752 506.871C329.048 509.589 328.999 514.097 333.654 516.913L359.694 532.602C362.304 533.99 365.211 534.732 368.168 534.763C371.124 534.794 374.046 534.114 376.685 532.781Z",
    fill: "url(#paint341_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 532.097L433.81 499.205C438.513 496.488 438.513 492.044 433.81 489.343L406.924 473.817C404.272 472.476 401.342 471.778 398.371 471.778C395.4 471.778 392.47 472.476 389.819 473.817L333.752 506.236C329.048 508.938 328.999 513.462 333.654 516.262L359.694 531.967C362.31 533.344 365.217 534.075 368.174 534.097C371.13 534.12 374.048 533.434 376.685 532.097Z",
    fill: "url(#paint342_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 531.414L433.81 498.506C438.513 495.804 438.513 491.361 433.81 488.643L406.924 473.117C404.27 471.784 401.341 471.09 398.371 471.09C395.401 471.09 392.473 471.784 389.819 473.117L333.752 505.488C329.048 508.205 328.999 512.73 333.654 515.529L359.694 531.234C362.307 532.615 365.212 533.352 368.168 533.383C371.123 533.415 374.043 532.739 376.685 531.414Z",
    fill: "url(#paint343_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 530.649L433.81 497.757C438.513 495.055 438.513 490.612 433.81 487.894L406.924 472.368C404.272 471.028 401.342 470.33 398.371 470.33C395.4 470.33 392.47 471.028 389.819 472.368L333.752 504.739C329.048 507.457 328.999 511.981 333.654 514.781L359.694 530.486C362.307 531.868 365.213 532.604 368.17 532.633C371.126 532.661 374.046 531.981 376.685 530.649Z",
    fill: "url(#paint344_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 530.03L433.81 497.139C438.513 494.437 438.513 489.994 433.81 487.276L406.924 471.75C404.272 470.409 401.342 469.711 398.371 469.711C395.4 469.711 392.47 470.409 389.819 471.75L333.752 504.121C329.048 506.838 328.999 511.347 333.654 514.162L359.694 529.867C362.307 531.25 365.213 531.986 368.17 532.014C371.126 532.043 374.046 531.362 376.685 530.03Z",
    fill: "url(#paint345_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.685 529.347L433.81 496.471C438.513 493.753 438.513 489.327 433.81 486.609L406.924 471.082C404.272 469.742 401.342 469.044 398.371 469.044C395.4 469.044 392.47 469.742 389.819 471.082L333.752 503.453C329.048 506.171 328.999 510.679 333.654 513.495L359.694 529.184C362.306 530.57 365.213 531.309 368.17 531.337C371.126 531.365 374.047 530.683 376.685 529.347Z",
    fill: "url(#paint346_linear_1591_524)",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.924 470.431C404.272 469.091 401.342 468.393 398.371 468.393C395.4 468.393 392.47 469.091 389.819 470.431L333.752 502.802C329.048 505.504 328.999 510.028 333.654 512.828L359.694 528.533C362.308 529.921 365.216 530.661 368.176 530.692C371.135 530.723 374.059 530.044 376.701 528.712L433.826 495.82C438.529 493.102 438.529 488.659 433.826 485.958L406.924 470.431Z",
    fill: "url(#paint347_linear_1591_524)",
    fillOpacity: 0.15
  }))), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M411.965 455.605C408.737 453.976 405.172 453.127 401.557 453.127C397.942 453.127 394.377 453.976 391.149 455.605L318.596 496.959V502.884C318.596 503.421 318.735 503.95 319 504.418C319.266 504.886 319.648 505.277 320.109 505.553L354.449 526.336C357.634 528.025 361.178 528.926 364.783 528.963C368.387 529 371.949 528.171 375.167 526.547L446.256 485.616C447.082 485.139 447.768 484.454 448.245 483.628C448.722 482.802 448.973 481.866 448.974 480.912V476.534L411.965 455.605Z",
    fill: "url(#paint348_linear_1591_524)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M411.968 451.992C408.741 450.363 405.176 449.514 401.56 449.514C397.945 449.514 394.38 450.363 391.153 451.992L322.896 491.394C317.167 494.649 317.118 500.198 322.782 503.616L354.453 522.739C357.639 524.425 361.182 525.323 364.786 525.36C368.39 525.397 371.951 524.571 375.171 522.951L444.697 482.898C450.426 479.643 450.426 474.191 444.697 470.887L411.968 451.992Z",
    fill: "#4B30BA"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M320.762 388.113L352.449 369.706C352.539 369.656 352.64 369.629 352.744 369.63C352.847 369.63 352.948 369.657 353.038 369.707C353.128 369.758 353.203 369.831 353.257 369.919C353.31 370.007 353.34 370.107 353.344 370.21V408.863C353.342 409.17 353.261 409.472 353.106 409.737C352.952 410.003 352.731 410.223 352.465 410.377L320.778 428.784C320.688 428.834 320.586 428.86 320.483 428.86C320.38 428.86 320.279 428.833 320.189 428.782C320.099 428.732 320.024 428.659 319.97 428.571C319.917 428.483 319.886 428.382 319.883 428.279V389.626C319.884 389.319 319.966 389.018 320.12 388.752C320.275 388.487 320.496 388.266 320.762 388.113Z",
    fill: "#D3DAED"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M327.933 392.979L375.049 365.621C375.184 365.544 375.337 365.505 375.492 365.505C375.647 365.506 375.799 365.547 375.934 365.624C376.069 365.701 376.181 365.812 376.26 365.945C376.338 366.079 376.381 366.23 376.384 366.385V423.836C376.38 424.293 376.258 424.742 376.03 425.138C375.802 425.534 375.475 425.865 375.082 426.098L327.885 453.472C327.751 453.55 327.599 453.59 327.444 453.59C327.29 453.59 327.138 453.549 327.004 453.471C326.87 453.394 326.76 453.282 326.683 453.148C326.606 453.014 326.566 452.862 326.566 452.707V395.241C326.572 394.776 326.701 394.321 326.942 393.923C327.182 393.526 327.524 393.199 327.933 392.979Z",
    fill: "#D3DAED"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M334.151 395.567L398.681 358.135C398.864 358.029 399.071 357.973 399.283 357.973C399.494 357.973 399.702 358.029 399.885 358.134C400.068 358.24 400.22 358.392 400.326 358.575C400.431 358.758 400.487 358.965 400.487 359.176V437.882C400.49 438.51 400.328 439.128 400.017 439.674C399.705 440.219 399.256 440.673 398.713 440.99L334.2 478.423C334.016 478.532 333.807 478.591 333.593 478.593C333.38 478.596 333.169 478.541 332.984 478.435C332.798 478.329 332.644 478.175 332.538 477.99C332.431 477.805 332.376 477.595 332.377 477.381V398.643C332.381 398.021 332.547 397.41 332.858 396.871C333.169 396.332 333.614 395.882 334.151 395.567Z",
    fill: "#D3DAED"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M348.801 419.8H349.094V469.715L348.801 469.894V419.8Z",
    fill: "#6D6D88"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M389.619 446.182L389.326 446.361V403.07H389.619V446.182Z",
    fill: "#6D6D88"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M377.361 453.294L377.068 453.473V408.961H377.361V453.294Z",
    fill: "#6D6D88"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M362.891 461.708L362.598 461.871V403.07H362.891V461.708Z",
    fill: "#6D6D88"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M389.477 403.672C389.729 403.672 389.933 403.402 389.933 403.069C389.933 402.737 389.729 402.467 389.477 402.467C389.226 402.467 389.021 402.737 389.021 403.069C389.021 403.402 389.226 403.672 389.477 403.672Z",
    fill: "#6D6D88"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M377.217 409.563C377.469 409.563 377.673 409.294 377.673 408.961C377.673 408.629 377.469 408.359 377.217 408.359C376.966 408.359 376.762 408.629 376.762 408.961C376.762 409.294 376.966 409.563 377.217 409.563Z",
    fill: "#6D6D88"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M362.755 403.672C363.006 403.672 363.21 403.402 363.21 403.069C363.21 402.737 363.006 402.467 362.755 402.467C362.503 402.467 362.299 402.737 362.299 403.069C362.299 403.402 362.503 403.672 362.755 403.672Z",
    fill: "#6D6D88"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M348.49 419.801C348.49 420.142 348.686 420.403 348.946 420.403C349.082 420.371 349.203 420.294 349.29 420.185C349.376 420.075 349.423 419.94 349.423 419.801C349.423 419.661 349.376 419.526 349.29 419.416C349.203 419.307 349.082 419.23 348.946 419.198C348.686 419.198 348.49 419.459 348.49 419.801Z",
    fill: "#6D6D88"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M400.493 406.194V403.379C397.772 405.514 395.333 407.986 393.235 410.735L391.851 412.362C388.954 415.78 384.365 415.617 379.531 414.95C375.056 414.413 369.994 414.104 366.511 417.277C364.918 418.919 363.697 420.884 362.931 423.039C362.638 423.69 362.345 424.341 362.036 424.975C361.515 426.033 359.546 429.484 356.714 429.37C356.163 429.317 355.618 429.214 355.086 429.06L353.931 428.784C350.155 428.1 345.924 429.956 342.538 433.764C341.272 435.295 340.134 436.928 339.137 438.646C337.265 441.755 335.491 444.668 332.334 446.003L333.18 448.037C337.005 446.41 339.056 443.057 341.025 439.802C341.952 438.165 343.013 436.608 344.198 435.147C346.998 431.892 350.448 430.346 353.459 430.9C353.784 430.9 354.126 431.046 354.452 431.127C355.132 431.322 355.83 431.447 356.535 431.502C359.383 431.632 362.133 429.516 363.94 425.903C364.265 425.236 364.558 424.536 364.868 423.853C365.524 421.989 366.56 420.282 367.911 418.84C370.726 416.285 375.218 416.594 379.206 417.066C383.193 417.538 389.557 418.319 393.462 413.811L394.862 412.183C396.562 410.028 398.446 408.024 400.493 406.194Z",
    fill: "black"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M334.021 478.423V399.75C334.022 399.123 334.188 398.507 334.503 397.965C334.817 397.422 335.268 396.971 335.811 396.658L400.325 359.226H400.487C400.502 359.008 400.456 358.791 400.355 358.598C400.254 358.405 400.102 358.243 399.916 358.131C399.729 358.018 399.516 357.959 399.298 357.96C399.08 357.961 398.867 358.021 398.681 358.135L334.151 395.567C333.612 395.884 333.165 396.336 332.854 396.878C332.543 397.421 332.378 398.034 332.377 398.66V477.349C332.38 477.542 332.43 477.731 332.522 477.901C332.613 478.07 332.744 478.215 332.904 478.324C333.063 478.432 333.247 478.501 333.438 478.524C333.63 478.547 333.824 478.523 334.004 478.455L334.021 478.423Z",
    fill: "#D3DAED"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M331.038 444.277L330.176 444.489V442.243C333.431 440.908 335.058 437.995 336.995 434.887C337.992 433.168 339.13 431.535 340.396 430.004C343.651 426.196 347.915 424.341 351.691 425.024L352.863 425.301C353.395 425.454 353.94 425.557 354.49 425.61C357.322 425.724 359.373 422.274 359.829 421.216C360.138 420.581 360.431 419.93 360.707 419.279C361.487 417.13 362.706 415.168 364.288 413.518C367.803 410.344 372.865 410.653 377.308 411.19C382.19 411.776 386.747 412.02 389.628 408.603L391.028 406.975C393.908 403.509 396.626 400.237 400.793 397.991L401.834 397.747V399.944C397.977 401.979 395.324 405.104 392.655 408.391L391.255 410.019C387.349 414.608 381.116 413.859 376.982 413.274C372.849 412.688 368.519 412.492 365.688 415.048C364.337 416.49 363.301 418.197 362.644 420.06C362.351 420.744 362.042 421.444 361.717 422.111C359.926 425.724 357.176 427.823 354.328 427.709C353.622 427.657 352.924 427.531 352.245 427.335C351.903 427.254 351.577 427.156 351.236 427.107C348.241 426.554 344.726 428.149 341.991 431.355C340.773 432.809 339.684 434.366 338.736 436.01C336.832 439.297 334.863 442.666 331.038 444.277Z",
    fill: "#5A3CFF"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M432.528 501.435C431.959 501.444 431.398 501.304 430.9 501.028C430.144 500.615 429.581 499.919 429.337 499.092C429.093 498.265 429.187 497.375 429.599 496.618L440.307 477.088C440.869 476.034 441.024 474.812 440.746 473.651C440.467 472.491 439.772 471.473 438.794 470.789L424.797 461.22C424.083 460.732 423.592 459.98 423.431 459.13C423.271 458.28 423.455 457.401 423.943 456.687C424.431 455.973 425.182 455.481 426.032 455.321C426.882 455.161 427.761 455.345 428.476 455.833L442.472 465.402C444.782 466.998 446.422 469.39 447.077 472.12C447.732 474.85 447.355 477.726 446.02 480.196L435.376 499.726C435.098 500.24 434.688 500.67 434.186 500.971C433.685 501.272 433.112 501.432 432.528 501.435Z",
    fill: "#EF9EA3"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M392.965 432.706C392.741 432.791 392.492 432.784 392.272 432.687C392.053 432.589 391.881 432.409 391.793 432.186L389.303 425.676C389.217 425.453 389.222 425.206 389.316 424.987C389.411 424.768 389.587 424.594 389.808 424.504C389.919 424.459 390.038 424.438 390.157 424.44C390.277 424.442 390.395 424.468 390.504 424.517C390.613 424.566 390.711 424.635 390.793 424.723C390.875 424.81 390.938 424.912 390.98 425.025L393.486 431.535C393.571 431.759 393.564 432.008 393.467 432.227C393.369 432.447 393.189 432.619 392.965 432.706Z",
    fill: "#F2B1B5"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M442.853 573.305L439.81 571.531L436.653 569.708L429.606 565.574C429.206 565.344 428.88 565.005 428.666 564.596C428.453 564.187 428.36 563.726 428.399 563.266C428.439 562.807 428.608 562.368 428.888 562.001C429.168 561.634 429.547 561.355 429.98 561.196C430.657 560.954 431.376 560.849 432.094 560.888C432.812 560.927 433.516 561.11 434.163 561.424L439.647 564.093L446.304 566.534C446.575 566.632 446.806 566.815 446.965 567.056C447.123 567.296 447.2 567.581 447.182 567.869L447.02 569.708C446.962 570.697 446.529 571.626 445.809 572.307C445.089 572.987 444.137 573.367 443.146 573.37L442.853 573.305Z",
    fill: "black"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M443.927 565.151L439.582 564.093L436.327 562.466C435.958 562.676 435.652 562.981 435.439 563.348C435.226 563.715 435.113 564.132 435.113 564.557C435.113 564.982 435.226 565.399 435.439 565.766C435.652 566.133 435.958 566.438 436.327 566.648L441.128 569.399L441.372 569.529C442.016 569.91 442.767 570.066 443.509 569.975C444.251 569.884 444.941 569.55 445.473 569.024C446.287 568.211 446.987 567.397 446.71 567.039L444.839 566.437C444.84 566.154 444.753 565.878 444.59 565.647C444.426 565.417 444.195 565.243 443.927 565.151Z",
    fill: "#F2B1B5"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M419.339 585.983L416.084 584.063L412.666 582.093L404.936 577.618C404.504 577.366 404.152 576.996 403.923 576.551C403.693 576.106 403.595 575.606 403.639 575.108C403.684 574.609 403.869 574.134 404.173 573.737C404.478 573.34 404.889 573.038 405.359 572.866C406.09 572.598 406.868 572.482 407.646 572.524C408.424 572.566 409.185 572.765 409.883 573.11L415.823 575.99L423.05 578.643C423.344 578.752 423.596 578.954 423.766 579.218C423.937 579.482 424.016 579.794 423.993 580.108L423.896 582.028C423.83 583.098 423.359 584.102 422.579 584.837C421.799 585.571 420.768 585.981 419.697 585.983H419.339Z",
    fill: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M420.507 577.179L415.787 576.023L412.272 574.314C411.869 574.543 411.534 574.874 411.301 575.275C411.068 575.675 410.945 576.13 410.945 576.593C410.945 577.056 411.068 577.511 411.301 577.911C411.534 578.311 411.869 578.643 412.272 578.871L417.496 581.849L417.756 581.996C418.457 582.401 419.271 582.564 420.074 582.461C420.877 582.358 421.623 581.995 422.199 581.426C423.078 580.564 423.827 579.652 423.55 579.294L421.5 578.643C421.519 578.324 421.432 578.007 421.253 577.742C421.073 577.477 420.811 577.279 420.507 577.179Z",
    fill: "#F2B1B5"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M443.811 570.473C443.043 570.471 442.291 570.253 441.64 569.844C440.99 569.436 440.468 568.853 440.132 568.162L426.104 538.867L430.123 506.236C430.258 505.164 430.811 504.19 431.662 503.525C432.512 502.86 433.592 502.559 434.664 502.688C436.894 502.965 440.914 504.999 440.637 507.229L434.485 537.516L445.878 564.647C446.854 566.665 447.619 569.106 445.601 570.066C445.043 570.338 444.431 570.477 443.811 570.473Z",
    fill: "#F2B1B5"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M419.515 582.5C417.269 582.5 416.26 580.677 416.26 578.431V503.567C416.258 503.032 416.361 502.502 416.565 502.007C416.769 501.513 417.068 501.063 417.447 500.685C417.825 500.307 418.274 500.007 418.769 499.804C419.264 499.6 419.794 499.496 420.329 499.498C422.574 499.498 427.88 502.558 427.88 504.804L424.365 542.92L423.584 578.415C423.586 578.951 423.482 579.482 423.278 579.977C423.075 580.473 422.776 580.923 422.398 581.303C422.02 581.682 421.57 581.983 421.076 582.189C420.581 582.394 420.05 582.5 419.515 582.5Z",
    fill: "#F2B1B5"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M440.333 449.274C440.333 448.197 440.054 447.138 439.522 446.201C438.989 445.264 438.223 444.482 437.298 443.93C436.372 443.379 435.319 443.078 434.242 443.056C433.165 443.034 432.101 443.292 431.154 443.805H431.072C430.335 444.259 429.706 444.87 429.233 445.596C423.081 455.686 415.237 457.997 415.237 468.381L417.646 486.95L414.781 505.048L413.805 536.605C415.846 537.847 418.225 538.417 420.608 538.232C420.852 538.232 423.618 538.053 424.221 537.956C431.186 536.751 437.696 536.328 440.333 531.071L441.358 517.873C441.911 508.849 440.903 499.798 438.38 491.117L440.333 449.274Z",
    fill: "black"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M426.174 464.914C425.996 464.93 425.816 464.93 425.637 464.914L422.382 464.361C415.349 463.195 408.709 460.319 403.048 455.986C397.386 451.652 392.876 445.994 389.914 439.509L387.196 433.569C386.838 432.783 386.806 431.888 387.108 431.079C387.41 430.27 388.021 429.614 388.807 429.256C389.593 428.898 390.488 428.866 391.297 429.168C392.106 429.471 392.762 430.082 393.12 430.867L395.838 436.808C398.349 442.325 402.179 447.141 406.989 450.83C411.8 454.52 417.444 456.97 423.424 457.965L426.679 458.518C427.542 458.589 428.342 459.001 428.902 459.661C429.462 460.322 429.736 461.179 429.665 462.042C429.594 462.905 429.183 463.705 428.522 464.265C427.861 464.825 427.005 465.099 426.142 465.028L426.174 464.914Z",
    fill: "#F2B1B5"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M426.169 465.728C425.942 465.752 425.713 465.752 425.485 465.728L422.23 465.175C419.707 464.753 417.224 464.116 414.809 463.27C414.305 463.092 413.84 462.816 413.443 462.458C413.045 462.1 412.722 461.667 412.491 461.185C412.261 460.702 412.128 460.178 412.099 459.644C412.071 459.11 412.149 458.575 412.327 458.071C412.506 457.566 412.782 457.102 413.139 456.704C413.497 456.306 413.93 455.983 414.413 455.753C414.896 455.522 415.419 455.389 415.954 455.361C416.488 455.333 417.022 455.41 417.527 455.589C419.492 456.31 421.519 456.855 423.581 457.216L426.836 457.769C427.37 457.813 427.891 457.962 428.368 458.207C428.845 458.452 429.269 458.788 429.615 459.197C429.962 459.606 430.225 460.079 430.389 460.589C430.553 461.1 430.615 461.638 430.571 462.172C430.527 462.706 430.379 463.227 430.134 463.703C429.889 464.18 429.552 464.604 429.144 464.951C428.735 465.298 428.262 465.561 427.751 465.725C427.241 465.889 426.703 465.951 426.169 465.907V465.728Z",
    fill: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M430.288 450.299C429.65 450.295 429.04 450.04 428.589 449.589C428.138 449.138 427.883 448.528 427.879 447.891V436.759H432.761V447.891C432.761 448.212 432.697 448.531 432.572 448.828C432.447 449.124 432.264 449.393 432.033 449.617C431.802 449.842 431.529 450.018 431.229 450.135C430.93 450.252 430.609 450.308 430.288 450.299Z",
    fill: "#F2B1B5"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M435.183 444.392L430.301 445.026C429.465 445.149 428.612 445.081 427.806 444.829C426.999 444.576 426.26 444.146 425.643 443.569C425.025 442.993 424.545 442.284 424.239 441.497C423.932 440.709 423.807 439.863 423.872 439.021C423.889 438.829 423.922 438.638 423.97 438.451L426.444 427.059L438.341 429.647L435.183 444.392Z",
    fill: "#F2B1B5"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M444.707 457.216C444.2 456.442 443.857 455.572 443.698 454.661C443.503 452.74 445.082 451.097 445.456 449.209C446.025 446.41 444.089 443.838 444.203 441.071C444.333 437.979 445.147 435.408 444.203 432.283C444.069 431.817 443.906 431.361 443.714 430.916C442.087 426.928 438.165 424.91 434.063 424.243C432.311 423.942 430.524 423.893 428.758 424.097C427.712 424.166 426.69 424.437 425.747 424.894C425.332 425.088 424.973 425.385 424.705 425.757C424.354 426.357 424.19 427.048 424.233 427.742C424.396 429.37 426.382 429.842 426.561 431.323C426.472 432.111 426.314 432.89 426.089 433.65C425.999 434.635 426.161 435.626 426.561 436.531C427.342 438.158 428.953 439.672 428.872 441.527C428.872 442.357 428.449 443.155 428.335 443.952C427.912 446.865 430.971 449.079 430.174 452.089C429.653 453.977 427.505 455.344 427.7 457.314C427.781 458.111 428.253 458.811 428.383 459.592C428.66 461.22 427.488 462.847 428.188 464.393C430.629 469.422 439.06 468.56 442.966 466.379C443.972 465.874 444.83 465.117 445.456 464.182C446.709 462.033 445.879 459.348 444.707 457.216Z",
    fill: "#5A3CFF"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M427.863 498.18C431.882 498.199 435.88 497.59 439.711 496.374C439.321 494.583 438.881 492.809 438.377 491.052V489.945C431.476 492.232 424.022 492.232 417.122 489.945L416.08 496.455C419.896 497.632 423.87 498.214 427.863 498.18Z",
    fill: "url(#paint349_linear_1591_524)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M395.945 475.948L413.685 486.087C413.773 486.139 413.845 486.213 413.896 486.302C413.946 486.39 413.973 486.49 413.973 486.592C413.973 486.694 413.946 486.794 413.896 486.883C413.845 486.971 413.773 487.045 413.685 487.097L386.018 503.046C385.671 503.246 385.278 503.351 384.878 503.351C384.479 503.351 384.086 503.246 383.739 503.046L365.983 492.907C365.896 492.855 365.823 492.781 365.772 492.693C365.722 492.604 365.695 492.504 365.695 492.402C365.695 492.3 365.722 492.2 365.772 492.112C365.823 492.023 365.896 491.949 365.983 491.898L393.651 475.948C394 475.748 394.396 475.643 394.798 475.643C395.201 475.643 395.596 475.748 395.945 475.948Z",
    fill: "#FBFBFB"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M395.901 475.98L413.575 486.087C413.663 486.137 413.737 486.209 413.788 486.296C413.839 486.383 413.866 486.482 413.866 486.583C413.866 486.685 413.839 486.784 413.788 486.871C413.737 486.958 413.663 487.03 413.575 487.08L386.054 502.98C385.71 503.176 385.32 503.279 384.923 503.279C384.527 503.279 384.137 503.176 383.792 502.98L366.134 492.874C366.05 492.821 365.981 492.748 365.933 492.661C365.885 492.574 365.859 492.477 365.859 492.377C365.859 492.278 365.885 492.181 365.933 492.094C365.981 492.007 366.05 491.934 366.134 491.881L393.655 475.98C393.997 475.786 394.384 475.684 394.778 475.684C395.171 475.684 395.558 475.786 395.901 475.98Z",
    fill: "#F6F6F8"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M395.852 476.014L413.461 486.088C413.549 486.138 413.623 486.21 413.674 486.297C413.725 486.384 413.752 486.483 413.752 486.584C413.752 486.685 413.725 486.785 413.674 486.872C413.623 486.959 413.549 487.031 413.461 487.081L386.054 502.981C385.711 503.182 385.321 503.287 384.923 503.287C384.526 503.287 384.136 503.182 383.792 502.981L366.134 492.842C366.05 492.789 365.981 492.716 365.933 492.629C365.885 492.543 365.859 492.445 365.859 492.346C365.859 492.247 365.885 492.149 365.933 492.062C365.981 491.975 366.05 491.902 366.134 491.849L393.541 476.03C393.89 475.823 394.288 475.713 394.694 475.71C395.1 475.707 395.5 475.812 395.852 476.014Z",
    fill: "#F2F2F4"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M395.818 476.062L413.33 486.088C413.419 486.135 413.493 486.205 413.544 486.291C413.596 486.377 413.623 486.476 413.623 486.576C413.623 486.676 413.596 486.775 413.544 486.861C413.493 486.947 413.419 487.017 413.33 487.064L386.037 502.835C385.697 503.035 385.309 503.141 384.914 503.141C384.519 503.141 384.132 503.035 383.791 502.835L366.247 492.809C366.163 492.759 366.093 492.687 366.045 492.601C365.996 492.516 365.971 492.419 365.971 492.321C365.971 492.223 365.996 492.126 366.045 492.04C366.093 491.955 366.163 491.883 366.247 491.833L393.556 476.062C393.898 475.859 394.289 475.751 394.687 475.751C395.085 475.751 395.476 475.859 395.818 476.062Z",
    fill: "#EDEDF0"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M395.785 476.095L413.231 486.088C413.32 486.135 413.394 486.205 413.445 486.291C413.497 486.377 413.524 486.476 413.524 486.576C413.524 486.676 413.497 486.775 413.445 486.861C413.394 486.947 413.32 487.017 413.231 487.064L386.036 502.753C385.694 502.949 385.307 503.052 384.913 503.052C384.519 503.052 384.132 502.949 383.79 502.753L366.327 492.76C366.243 492.71 366.173 492.638 366.125 492.553C366.076 492.467 366.051 492.371 366.051 492.272C366.051 492.174 366.076 492.077 366.125 491.992C366.173 491.906 366.243 491.835 366.327 491.784L393.522 476.095C393.866 475.896 394.256 475.792 394.653 475.792C395.051 475.792 395.441 475.896 395.785 476.095Z",
    fill: "#E9E9ED"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M395.744 476.144L413.142 486.072C413.226 486.124 413.295 486.197 413.343 486.284C413.391 486.371 413.416 486.469 413.416 486.568C413.416 486.667 413.391 486.765 413.343 486.852C413.295 486.938 413.226 487.012 413.142 487.064L386.06 502.688C385.723 502.887 385.338 502.992 384.946 502.992C384.553 502.992 384.169 502.887 383.831 502.688L366.433 492.761C366.349 492.708 366.279 492.635 366.231 492.548C366.183 492.461 366.158 492.363 366.158 492.264C366.158 492.165 366.183 492.067 366.231 491.981C366.279 491.894 366.349 491.82 366.433 491.768L393.514 476.144C393.852 475.943 394.237 475.837 394.629 475.837C395.022 475.837 395.407 475.943 395.744 476.144Z",
    fill: "#E4E4E9"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M395.706 476.176L413.022 486.071C413.107 486.122 413.176 486.194 413.225 486.279C413.273 486.365 413.299 486.461 413.299 486.56C413.299 486.658 413.273 486.755 413.225 486.84C413.176 486.926 413.107 486.997 413.022 487.048L386.055 502.623C385.715 502.816 385.331 502.917 384.94 502.917C384.549 502.917 384.165 502.816 383.825 502.623L366.509 492.728C366.424 492.677 366.355 492.606 366.306 492.52C366.258 492.434 366.232 492.338 366.232 492.24C366.232 492.141 366.258 492.045 366.306 491.959C366.355 491.874 366.424 491.802 366.509 491.751L393.476 476.176C393.816 475.984 394.2 475.882 394.591 475.882C394.982 475.882 395.366 475.984 395.706 476.176Z",
    fill: "#E0E0E6"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M395.658 476.209L412.909 486.071C412.993 486.122 413.063 486.193 413.111 486.279C413.16 486.365 413.185 486.461 413.185 486.559C413.185 486.658 413.16 486.754 413.111 486.84C413.063 486.925 412.993 486.997 412.909 487.048L386.055 502.541C385.72 502.737 385.338 502.84 384.949 502.84C384.56 502.84 384.178 502.737 383.842 502.541L366.591 492.679C366.506 492.628 366.437 492.557 366.388 492.471C366.34 492.385 366.314 492.289 366.314 492.191C366.314 492.092 366.34 491.996 366.388 491.91C366.437 491.825 366.506 491.753 366.591 491.702L393.444 476.209C393.78 476.013 394.162 475.91 394.551 475.91C394.94 475.91 395.322 476.013 395.658 476.209Z",
    fill: "#DBDBE2"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M395.604 476.258L412.79 486.023C412.875 486.071 412.945 486.141 412.994 486.226C413.042 486.31 413.068 486.406 413.068 486.503C413.068 486.6 413.042 486.696 412.994 486.78C412.945 486.865 412.875 486.935 412.79 486.983L386.05 502.428C385.713 502.621 385.332 502.722 384.944 502.722C384.555 502.722 384.174 502.621 383.837 502.428L366.667 492.663C366.582 492.615 366.512 492.545 366.463 492.46C366.414 492.376 366.389 492.28 366.389 492.183C366.389 492.085 366.414 491.99 366.463 491.905C366.512 491.821 366.582 491.751 366.667 491.703L393.407 476.258C393.741 476.067 394.12 475.966 394.505 475.966C394.89 475.966 395.269 476.067 395.604 476.258Z",
    fill: "#D7D7DE"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M395.578 476.29L412.683 486.055C412.767 486.103 412.837 486.173 412.886 486.258C412.935 486.342 412.961 486.438 412.961 486.535C412.961 486.633 412.935 486.728 412.886 486.813C412.837 486.897 412.767 486.967 412.683 487.015L386.057 502.395C385.722 502.586 385.344 502.687 384.958 502.687C384.573 502.687 384.194 502.586 383.86 502.395L366.755 492.63C366.67 492.582 366.6 492.512 366.551 492.427C366.502 492.343 366.477 492.247 366.477 492.15C366.477 492.053 366.502 491.957 366.551 491.873C366.6 491.788 366.67 491.718 366.755 491.67L393.381 476.29C393.715 476.099 394.094 475.998 394.479 475.998C394.864 475.998 395.243 476.099 395.578 476.29Z",
    fill: "#D2D2DB"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M395.55 476.323L412.573 486.088C412.658 486.136 412.728 486.206 412.777 486.29C412.826 486.375 412.851 486.47 412.851 486.568C412.851 486.665 412.826 486.761 412.777 486.845C412.728 486.93 412.658 486.999 412.573 487.048L386.061 502.346C385.726 502.534 385.348 502.633 384.963 502.633C384.578 502.633 384.2 502.534 383.864 502.346L366.841 492.581C366.756 492.533 366.686 492.463 366.637 492.379C366.588 492.294 366.562 492.199 366.562 492.101C366.562 492.004 366.588 491.908 366.637 491.824C366.686 491.74 366.756 491.67 366.841 491.621L393.353 476.323C393.688 476.135 394.066 476.036 394.451 476.036C394.836 476.036 395.214 476.135 395.55 476.323Z",
    fill: "#CECED7"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M395.433 476.372L412.392 486.137C412.477 486.183 412.547 486.251 412.597 486.334C412.646 486.417 412.672 486.512 412.672 486.608C412.672 486.705 412.646 486.8 412.597 486.883C412.547 486.966 412.477 487.034 412.392 487.08L385.994 502.33C385.662 502.521 385.286 502.622 384.903 502.622C384.52 502.622 384.144 502.521 383.813 502.33L366.854 492.646C366.77 492.598 366.7 492.528 366.651 492.444C366.602 492.36 366.576 492.264 366.576 492.166C366.576 492.069 366.602 491.973 366.651 491.889C366.7 491.805 366.77 491.735 366.854 491.686L393.252 476.437C393.578 476.235 393.951 476.123 394.334 476.112C394.717 476.1 395.096 476.19 395.433 476.372Z",
    fill: "#C9C9D3"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M395.432 476.404L412.325 486.055C412.41 486.104 412.48 486.174 412.529 486.258C412.578 486.342 412.603 486.438 412.603 486.535C412.603 486.633 412.578 486.728 412.529 486.813C412.48 486.897 412.41 486.967 412.325 487.015L386.041 502.2C385.709 502.388 385.333 502.487 384.951 502.487C384.569 502.487 384.193 502.388 383.86 502.2L366.983 492.549C366.899 492.5 366.829 492.431 366.78 492.346C366.731 492.262 366.705 492.166 366.705 492.069C366.705 491.971 366.731 491.876 366.78 491.791C366.829 491.707 366.899 491.637 366.983 491.589L393.284 476.404C393.613 476.223 393.982 476.128 394.358 476.128C394.733 476.128 395.103 476.223 395.432 476.404Z",
    fill: "#C5C5D0"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M395.432 476.453L412.244 486.055C412.329 486.101 412.4 486.169 412.449 486.252C412.498 486.335 412.525 486.43 412.525 486.527C412.525 486.624 412.498 486.718 412.449 486.801C412.4 486.885 412.329 486.953 412.244 486.999L386.074 502.118C385.744 502.307 385.371 502.406 384.991 502.406C384.612 502.406 384.239 502.307 383.909 502.118L367.081 492.5C367 492.45 366.933 492.381 366.887 492.298C366.841 492.216 366.816 492.123 366.816 492.028C366.816 491.933 366.841 491.84 366.887 491.757C366.933 491.675 367 491.605 367.081 491.556L393.267 476.436C393.597 476.247 393.971 476.149 394.352 476.152C394.732 476.155 395.105 476.259 395.432 476.453Z",
    fill: "#C1C1CC"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M395.43 476.486L412.161 486.055C412.246 486.101 412.317 486.17 412.366 486.253C412.416 486.336 412.442 486.431 412.442 486.527C412.442 486.624 412.416 486.719 412.366 486.802C412.317 486.885 412.246 486.953 412.161 486.999L386.121 502.054C385.793 502.245 385.419 502.346 385.039 502.346C384.659 502.346 384.285 502.245 383.957 502.054L367.21 492.484C367.129 492.434 367.062 492.365 367.016 492.282C366.97 492.2 366.945 492.107 366.945 492.012C366.945 491.917 366.97 491.824 367.016 491.741C367.062 491.659 367.129 491.589 367.21 491.54L393.25 476.486C393.583 476.299 393.958 476.201 394.34 476.201C394.722 476.201 395.097 476.299 395.43 476.486Z",
    fill: "#BCBCC8"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M395.333 476.518L411.998 486.055C412.083 486.101 412.154 486.169 412.203 486.252C412.253 486.335 412.279 486.43 412.279 486.527C412.279 486.624 412.253 486.719 412.203 486.802C412.154 486.885 412.083 486.953 411.998 486.999L386.04 501.988C385.712 502.172 385.342 502.269 384.966 502.269C384.589 502.269 384.22 502.172 383.891 501.988L367.21 492.451C367.129 492.404 367.061 492.336 367.015 492.255C366.968 492.173 366.943 492.081 366.943 491.987C366.943 491.893 366.968 491.801 367.015 491.72C367.061 491.638 367.129 491.571 367.21 491.523L393.25 476.534C393.567 476.355 393.925 476.26 394.289 476.257C394.653 476.254 395.013 476.344 395.333 476.518Z",
    fill: "#B8B8C5"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M395.274 476.567L411.891 486.055C411.972 486.102 412.039 486.17 412.086 486.251C412.133 486.333 412.157 486.425 412.157 486.519C412.157 486.613 412.133 486.705 412.086 486.786C412.039 486.868 411.972 486.935 411.891 486.983L386.03 501.907C385.708 502.099 385.339 502.2 384.964 502.2C384.589 502.2 384.22 502.099 383.898 501.907L367.298 492.419C367.217 492.371 367.149 492.304 367.103 492.222C367.056 492.141 367.031 492.049 367.031 491.955C367.031 491.861 367.056 491.769 367.103 491.687C367.149 491.606 367.217 491.538 367.298 491.491L393.142 476.567C393.466 476.38 393.834 476.281 394.208 476.281C394.582 476.281 394.95 476.38 395.274 476.567Z",
    fill: "#B3B3C1"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M395.252 476.599L411.787 486.055C411.868 486.102 411.936 486.17 411.982 486.251C412.029 486.333 412.054 486.425 412.054 486.519C412.054 486.613 412.029 486.705 411.982 486.786C411.936 486.868 411.868 486.935 411.787 486.983L386.041 501.842C385.718 502.026 385.354 502.123 384.983 502.123C384.612 502.123 384.247 502.026 383.925 501.842L367.39 492.402C367.309 492.353 367.242 492.283 367.196 492.201C367.149 492.118 367.125 492.025 367.125 491.93C367.125 491.835 367.149 491.742 367.196 491.66C367.242 491.577 367.309 491.508 367.39 491.458L393.12 476.599C393.445 476.415 393.813 476.318 394.186 476.318C394.56 476.318 394.927 476.415 395.252 476.599Z",
    fill: "#AFAFBE"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M395.201 476.632L411.703 486.055C411.785 486.1 411.853 486.166 411.9 486.246C411.947 486.326 411.972 486.418 411.972 486.511C411.972 486.604 411.947 486.695 411.9 486.775C411.853 486.855 411.785 486.921 411.703 486.967L386.07 501.76C385.749 501.948 385.384 502.046 385.012 502.046C384.641 502.046 384.276 501.948 383.955 501.76L367.501 492.354C367.42 492.306 367.352 492.239 367.306 492.157C367.259 492.076 367.234 491.984 367.234 491.89C367.234 491.796 367.259 491.704 367.306 491.622C367.352 491.541 367.42 491.473 367.501 491.426L393.134 476.632C393.449 476.454 393.805 476.36 394.167 476.36C394.529 476.36 394.885 476.454 395.201 476.632Z",
    fill: "#AAAABA"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M395.162 476.681L411.551 486.039C411.632 486.086 411.699 486.154 411.746 486.235C411.793 486.317 411.817 486.409 411.817 486.503C411.817 486.597 411.793 486.689 411.746 486.77C411.699 486.852 411.632 486.919 411.551 486.967L386.032 501.614C385.713 501.798 385.351 501.895 384.982 501.895C384.614 501.895 384.252 501.798 383.932 501.614L367.544 492.256C367.463 492.209 367.395 492.141 367.349 492.059C367.302 491.978 367.277 491.886 367.277 491.792C367.277 491.698 367.302 491.606 367.349 491.525C367.395 491.443 367.463 491.376 367.544 491.328L393.063 476.599C393.389 476.427 393.755 476.344 394.123 476.359C394.492 476.373 394.85 476.484 395.162 476.681Z",
    fill: "#A6A6B6"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M395.119 476.714L411.394 486.039C411.475 486.086 411.542 486.154 411.589 486.236C411.636 486.317 411.66 486.409 411.66 486.503C411.66 486.597 411.636 486.689 411.589 486.77C411.542 486.852 411.475 486.92 411.394 486.967L385.989 501.614C385.67 501.798 385.308 501.895 384.939 501.895C384.57 501.895 384.208 501.798 383.889 501.614L367.614 492.289C367.533 492.244 367.465 492.178 367.418 492.098C367.371 492.017 367.346 491.926 367.346 491.833C367.346 491.74 367.371 491.649 367.418 491.569C367.465 491.488 367.533 491.422 367.614 491.377L393.019 476.73C393.336 476.54 393.698 476.438 394.067 476.435C394.436 476.433 394.799 476.529 395.119 476.714Z",
    fill: "#A1A1B3"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M395.09 476.762L411.365 486.039C411.447 486.084 411.514 486.15 411.562 486.23C411.609 486.31 411.634 486.402 411.634 486.495C411.634 486.588 411.609 486.679 411.562 486.759C411.514 486.839 411.447 486.905 411.365 486.95L386.074 501.598C385.756 501.777 385.397 501.872 385.032 501.872C384.667 501.872 384.309 501.777 383.991 501.598L367.716 492.305C367.635 492.26 367.567 492.194 367.519 492.114C367.472 492.033 367.447 491.942 367.447 491.849C367.447 491.756 367.472 491.665 367.519 491.585C367.567 491.504 367.635 491.438 367.716 491.393L393.007 476.746C393.325 476.564 393.685 476.47 394.051 476.472C394.417 476.475 394.776 476.575 395.09 476.762Z",
    fill: "#9D9DAF"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M395.034 476.795L411.211 486.039C411.292 486.084 411.36 486.15 411.407 486.23C411.455 486.31 411.48 486.402 411.48 486.495C411.48 486.588 411.455 486.679 411.407 486.759C411.36 486.839 411.292 486.905 411.211 486.95L386.034 501.484C385.718 501.668 385.358 501.765 384.992 501.765C384.626 501.765 384.267 501.668 383.95 501.484L367.757 492.24C367.676 492.195 367.608 492.129 367.56 492.049C367.513 491.968 367.488 491.877 367.488 491.784C367.488 491.691 367.513 491.6 367.56 491.519C367.608 491.439 367.676 491.373 367.757 491.328L392.934 476.795C393.252 476.606 393.614 476.506 393.984 476.506C394.354 476.506 394.716 476.606 395.034 476.795Z",
    fill: "#9898AB"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.59,
    d: "M395.004 476.828L411.1 486.039C411.182 486.082 411.251 486.146 411.299 486.225C411.347 486.304 411.372 486.394 411.372 486.487C411.372 486.579 411.347 486.67 411.299 486.749C411.251 486.827 411.182 486.892 411.1 486.934L386.037 501.419C385.722 501.599 385.366 501.693 385.003 501.693C384.641 501.693 384.285 501.599 383.97 501.419L367.874 492.224C367.793 492.179 367.725 492.113 367.678 492.032C367.63 491.952 367.605 491.861 367.605 491.768C367.605 491.675 367.63 491.584 367.678 491.503C367.725 491.423 367.793 491.357 367.874 491.312L392.937 476.844C393.251 476.662 393.606 476.564 393.969 476.561C394.331 476.558 394.688 476.65 395.004 476.828Z",
    fill: "#9494A8"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M394.954 476.941L410.985 486.104C411.067 486.147 411.136 486.211 411.183 486.29C411.231 486.369 411.257 486.459 411.257 486.552C411.257 486.644 411.231 486.735 411.183 486.813C411.136 486.892 411.067 486.957 410.985 486.999L386.036 501.354C385.721 501.534 385.365 501.628 385.002 501.628C384.64 501.628 384.283 501.534 383.969 501.354L367.954 492.191C367.873 492.146 367.805 492.08 367.758 492C367.71 491.92 367.686 491.828 367.686 491.735C367.686 491.642 367.71 491.551 367.758 491.471C367.805 491.391 367.873 491.325 367.954 491.28L392.904 476.941C393.214 476.758 393.568 476.661 393.929 476.661C394.29 476.661 394.644 476.758 394.954 476.941Z",
    fill: "#8F8FA4"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M394.924 476.941L410.873 486.072C410.951 486.118 411.015 486.183 411.06 486.262C411.104 486.34 411.128 486.429 411.128 486.519C411.128 486.609 411.104 486.698 411.06 486.777C411.015 486.855 410.951 486.921 410.873 486.967L386.038 501.354C385.727 501.537 385.373 501.634 385.012 501.634C384.652 501.634 384.298 501.537 383.987 501.354L368.038 492.24C367.96 492.194 367.896 492.128 367.851 492.05C367.807 491.971 367.783 491.882 367.783 491.792C367.783 491.702 367.807 491.613 367.851 491.535C367.896 491.456 367.96 491.391 368.038 491.345L392.873 476.941C393.186 476.766 393.539 476.674 393.899 476.674C394.258 476.674 394.611 476.766 394.924 476.941Z",
    fill: "#8B8BA1"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M394.874 476.941L410.775 486.023C410.852 486.069 410.917 486.134 410.961 486.213C411.006 486.291 411.029 486.38 411.029 486.47C411.029 486.561 411.006 486.649 410.961 486.728C410.917 486.806 410.852 486.872 410.775 486.918L386.037 501.207C385.727 501.383 385.376 501.475 385.02 501.475C384.663 501.475 384.313 501.383 384.003 501.207L368.102 492.126C368.025 492.08 367.96 492.014 367.916 491.936C367.871 491.857 367.848 491.769 367.848 491.678C367.848 491.588 367.871 491.499 367.916 491.421C367.96 491.342 368.025 491.277 368.102 491.231L392.84 476.958C393.147 476.775 393.498 476.677 393.855 476.674C394.212 476.672 394.564 476.764 394.874 476.941Z",
    fill: "#86869D"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M394.84 476.941L410.66 485.974C410.737 486.02 410.801 486.086 410.846 486.164C410.891 486.242 410.914 486.331 410.914 486.421C410.914 486.512 410.891 486.6 410.846 486.679C410.801 486.757 410.737 486.823 410.66 486.869L386.036 501.077C385.727 501.257 385.376 501.352 385.019 501.352C384.661 501.352 384.31 501.257 384.001 501.077L368.182 492.028C368.105 491.982 368.04 491.916 367.996 491.838C367.951 491.76 367.928 491.671 367.928 491.581C367.928 491.49 367.951 491.402 367.996 491.323C368.04 491.245 368.105 491.179 368.182 491.133L392.806 476.941C393.116 476.766 393.467 476.674 393.823 476.674C394.18 476.674 394.53 476.766 394.84 476.941Z",
    fill: "#828299"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M394.798 477.023L410.552 486.023C410.63 486.069 410.694 486.135 410.739 486.213C410.784 486.292 410.807 486.38 410.807 486.47C410.807 486.561 410.784 486.649 410.739 486.728C410.694 486.806 410.63 486.872 410.552 486.918L386.042 501.061C385.735 501.236 385.387 501.329 385.033 501.329C384.68 501.329 384.332 501.236 384.024 501.061L368.27 492.061C368.192 492.017 368.128 491.953 368.083 491.876C368.037 491.799 368.014 491.711 368.014 491.621C368.014 491.532 368.037 491.444 368.083 491.367C368.128 491.29 368.192 491.226 368.27 491.182L392.78 477.023C393.088 476.847 393.435 476.755 393.789 476.755C394.143 476.755 394.491 476.847 394.798 477.023Z",
    fill: "#7E7E96"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M394.759 477.071L410.432 486.023C410.51 486.067 410.575 486.13 410.62 486.208C410.665 486.285 410.689 486.373 410.689 486.462C410.689 486.552 410.665 486.639 410.62 486.717C410.575 486.794 410.51 486.858 410.432 486.901L386.02 500.996C385.712 501.171 385.365 501.263 385.011 501.263C384.657 501.263 384.309 501.171 384.002 500.996L368.329 492.028C368.251 491.984 368.186 491.92 368.141 491.843C368.096 491.766 368.072 491.678 368.072 491.589C368.072 491.499 368.096 491.411 368.141 491.334C368.186 491.257 368.251 491.193 368.329 491.149L392.741 477.071C393.049 476.896 393.396 476.804 393.75 476.804C394.104 476.804 394.452 476.896 394.759 477.071Z",
    fill: "#797992"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M394.71 477.105L410.318 486.023C410.396 486.067 410.461 486.131 410.506 486.208C410.551 486.285 410.575 486.373 410.575 486.463C410.575 486.552 410.551 486.64 410.506 486.717C410.461 486.794 410.396 486.858 410.318 486.902L386.036 500.915C385.731 501.087 385.386 501.178 385.035 501.178C384.684 501.178 384.34 501.087 384.034 500.915L368.427 491.996C368.349 491.952 368.284 491.888 368.239 491.811C368.194 491.734 368.17 491.646 368.17 491.557C368.17 491.467 368.194 491.38 368.239 491.302C368.284 491.225 368.349 491.161 368.427 491.117L392.709 477.088C393.014 476.915 393.36 476.825 393.712 476.828C394.063 476.831 394.408 476.926 394.71 477.105Z",
    fill: "#75758E"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M394.679 477.137L410.205 486.023C410.283 486.064 410.349 486.126 410.394 486.202C410.44 486.278 410.464 486.365 410.464 486.454C410.464 486.543 410.44 486.63 410.394 486.706C410.349 486.782 410.283 486.844 410.205 486.885L386.037 500.849C385.732 501.025 385.387 501.117 385.036 501.117C384.684 501.117 384.339 501.025 384.035 500.849L368.509 491.979C368.431 491.935 368.366 491.872 368.321 491.794C368.276 491.717 368.252 491.629 368.252 491.54C368.252 491.451 368.276 491.363 368.321 491.286C368.366 491.208 368.431 491.145 368.509 491.101L392.677 477.153C392.981 476.978 393.325 476.884 393.676 476.882C394.026 476.879 394.372 476.967 394.679 477.137Z",
    fill: "#70708B"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M394.627 477.185L410.089 486.006C410.166 486.05 410.231 486.114 410.276 486.191C410.321 486.268 410.345 486.356 410.345 486.446C410.345 486.535 410.321 486.623 410.276 486.7C410.231 486.777 410.166 486.841 410.089 486.885L386.034 500.784C385.73 500.952 385.389 501.04 385.041 501.04C384.694 501.04 384.353 500.952 384.049 500.784L368.588 491.947C368.509 491.905 368.444 491.843 368.398 491.767C368.352 491.691 368.328 491.604 368.328 491.515C368.328 491.427 368.352 491.34 368.398 491.264C368.444 491.188 368.509 491.126 368.588 491.084L392.642 477.185C392.943 477.009 393.286 476.917 393.635 476.917C393.983 476.917 394.326 477.009 394.627 477.185Z",
    fill: "#6C6C87"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.83,
    d: "M394.603 477.218L409.983 486.006C410.061 486.05 410.126 486.114 410.171 486.191C410.216 486.268 410.24 486.356 410.24 486.445C410.24 486.535 410.216 486.623 410.171 486.7C410.126 486.777 410.061 486.841 409.983 486.885L386.043 500.702C385.741 500.878 385.399 500.971 385.05 500.971C384.701 500.971 384.358 500.878 384.057 500.702L368.677 491.914C368.599 491.872 368.534 491.81 368.488 491.734C368.442 491.658 368.418 491.571 368.418 491.483C368.418 491.394 368.442 491.307 368.488 491.231C368.534 491.155 368.599 491.093 368.677 491.051L392.618 477.218C392.92 477.045 393.262 476.954 393.611 476.954C393.959 476.954 394.301 477.045 394.603 477.218Z",
    fill: "#676783"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M394.547 477.251L409.862 486.007C409.94 486.048 410.006 486.11 410.051 486.186C410.097 486.262 410.121 486.349 410.121 486.438C410.121 486.527 410.097 486.614 410.051 486.69C410.006 486.766 409.94 486.828 409.862 486.869L386.036 500.638C385.736 500.809 385.396 500.899 385.051 500.899C384.706 500.899 384.366 500.809 384.066 500.638L368.752 491.882C368.673 491.84 368.608 491.778 368.562 491.702C368.516 491.626 368.492 491.539 368.492 491.451C368.492 491.362 368.516 491.275 368.562 491.199C368.608 491.123 368.673 491.061 368.752 491.019L392.594 477.267C392.89 477.093 393.226 477 393.569 476.997C393.911 476.994 394.249 477.082 394.547 477.251Z",
    fill: "#636380"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "M394.513 477.299L409.746 486.006C409.825 486.048 409.89 486.11 409.936 486.186C409.982 486.262 410.006 486.349 410.006 486.438C410.006 486.526 409.982 486.613 409.936 486.689C409.89 486.765 409.825 486.827 409.746 486.869L386.034 500.556C385.734 500.727 385.395 500.817 385.049 500.817C384.704 500.817 384.364 500.727 384.065 500.556L368.831 491.833C368.752 491.794 368.686 491.733 368.639 491.659C368.593 491.584 368.568 491.498 368.568 491.41C368.568 491.322 368.593 491.235 368.639 491.161C368.686 491.086 368.752 491.025 368.831 490.986L392.56 477.283C392.858 477.114 393.196 477.027 393.539 477.029C393.882 477.032 394.218 477.125 394.513 477.299Z",
    fill: "#5E5E7C"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M394.476 477.332L409.644 486.006C409.718 486.049 409.78 486.111 409.823 486.185C409.866 486.259 409.889 486.344 409.889 486.429C409.889 486.515 409.866 486.6 409.823 486.674C409.78 486.748 409.718 486.81 409.644 486.853L386.029 500.491C385.734 500.667 385.396 500.76 385.053 500.76C384.709 500.76 384.371 500.667 384.076 500.491L368.908 491.833C368.83 491.791 368.764 491.729 368.718 491.653C368.673 491.577 368.648 491.49 368.648 491.401C368.648 491.313 368.673 491.226 368.718 491.15C368.764 491.074 368.83 491.012 368.908 490.97L392.523 477.332C392.82 477.16 393.156 477.07 393.499 477.07C393.842 477.07 394.179 477.16 394.476 477.332Z",
    fill: "#5A5A79"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.93,
    d: "M394.439 477.38L409.542 486.006C409.616 486.049 409.678 486.11 409.721 486.185C409.764 486.259 409.787 486.343 409.787 486.429C409.787 486.515 409.764 486.599 409.721 486.673C409.678 486.748 409.616 486.809 409.542 486.852L386.025 500.425C385.73 500.594 385.396 500.682 385.056 500.682C384.717 500.682 384.383 500.594 384.088 500.425L369.001 491.8C368.922 491.761 368.856 491.7 368.809 491.626C368.763 491.551 368.738 491.465 368.738 491.377C368.738 491.289 368.763 491.202 368.809 491.128C368.856 491.053 368.922 490.992 369.001 490.953L392.502 477.38C392.795 477.205 393.13 477.113 393.471 477.113C393.812 477.113 394.146 477.205 394.439 477.38Z",
    fill: "#555575"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M394.388 477.413L409.426 486.006C409.5 486.049 409.562 486.111 409.605 486.185C409.648 486.259 409.671 486.344 409.671 486.429C409.671 486.515 409.648 486.599 409.605 486.674C409.562 486.748 409.5 486.81 409.426 486.853L386.023 500.344C385.732 500.516 385.4 500.607 385.063 500.607C384.725 500.607 384.393 500.516 384.102 500.344L369.081 491.751C369.006 491.708 368.944 491.647 368.901 491.573C368.859 491.498 368.836 491.414 368.836 491.328C368.836 491.242 368.859 491.158 368.901 491.084C368.944 491.009 369.006 490.948 369.081 490.905L392.484 477.397C392.775 477.234 393.104 477.149 393.438 477.152C393.772 477.155 394.099 477.245 394.388 477.413Z",
    fill: "#515171"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M394.353 477.446L409.31 485.99C409.384 486.033 409.446 486.094 409.489 486.169C409.532 486.243 409.554 486.327 409.554 486.413C409.554 486.499 409.532 486.583 409.489 486.657C409.446 486.732 409.384 486.793 409.31 486.836L386.02 500.279C385.728 500.448 385.397 500.537 385.06 500.537C384.723 500.537 384.392 500.448 384.1 500.279L369.143 491.735C369.069 491.692 369.007 491.631 368.964 491.556C368.921 491.482 368.898 491.398 368.898 491.312C368.898 491.226 368.921 491.142 368.964 491.067C369.007 490.993 369.069 490.932 369.143 490.889L392.432 477.462C392.722 477.288 393.053 477.194 393.39 477.191C393.728 477.188 394.061 477.276 394.353 477.446Z",
    fill: "#4C4C6E"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M394.307 477.495L409.198 485.99C409.273 486.033 409.334 486.095 409.377 486.169C409.42 486.243 409.443 486.328 409.443 486.414C409.443 486.499 409.42 486.584 409.377 486.658C409.334 486.732 409.273 486.794 409.198 486.837L386.023 500.215C385.733 500.382 385.405 500.47 385.071 500.47C384.736 500.47 384.408 500.382 384.119 500.215L369.227 491.703C369.156 491.659 369.098 491.598 369.058 491.525C369.017 491.453 368.996 491.371 368.996 491.288C368.996 491.205 369.017 491.123 369.058 491.05C369.098 490.978 369.156 490.917 369.227 490.873L392.403 477.495C392.692 477.328 393.02 477.24 393.355 477.24C393.689 477.24 394.017 477.328 394.307 477.495Z",
    fill: "black"
  }))), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M367.214 469.097L393.335 454.01C393.417 453.969 393.507 453.949 393.599 453.952C393.69 453.955 393.779 453.982 393.857 454.029C393.935 454.076 394 454.143 394.046 454.222C394.091 454.301 394.115 454.391 394.117 454.482V474.159C394.119 474.36 394.068 474.558 393.968 474.733C393.868 474.908 393.722 475.052 393.547 475.151L367.426 490.238C367.344 490.28 367.254 490.3 367.162 490.297C367.071 490.293 366.982 490.267 366.904 490.22C366.826 490.172 366.761 490.106 366.715 490.027C366.67 489.947 366.646 489.858 366.645 489.766V470.09C366.645 469.889 366.698 469.692 366.798 469.518C366.898 469.344 367.041 469.199 367.214 469.097Z",
    fill: "url(#paint350_linear_1591_524)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M367.549 469.325L393.589 454.238C393.669 454.193 393.76 454.17 393.853 454.171C393.945 454.171 394.036 454.195 394.116 454.241C394.196 454.287 394.263 454.353 394.31 454.432C394.358 454.511 394.384 454.601 394.386 454.694V474.386C394.386 474.587 394.333 474.784 394.233 474.958C394.133 475.132 393.989 475.277 393.816 475.379L367.76 490.45C367.68 490.494 367.589 490.518 367.496 490.517C367.404 490.516 367.313 490.492 367.233 490.446C367.153 490.401 367.086 490.335 367.039 490.256C366.991 490.176 366.965 490.086 366.963 489.994V470.318C366.963 470.115 367.018 469.916 367.121 469.742C367.224 469.567 367.372 469.423 367.549 469.325Z",
    fill: "black"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M368.529 470.562L393.088 456.288V474.305L368.529 488.562V470.562Z",
    fill: "#5A3CFF"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M395.513 476.323L412.243 485.079C412.243 485.079 412.341 486.397 411.983 486.592L386.35 501.386C386.029 501.574 385.664 501.672 385.292 501.672C384.92 501.672 384.555 501.574 384.234 501.386L367.764 492.044C367.08 491.621 367.487 490.531 367.487 490.531L393.381 476.339C393.702 476.146 394.07 476.043 394.445 476.04C394.819 476.037 395.188 476.135 395.513 476.323Z",
    fill: "url(#paint351_linear_1591_524)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M395.511 475.314L411.981 484.721C412.062 484.768 412.13 484.836 412.176 484.917C412.223 484.999 412.248 485.091 412.248 485.185C412.248 485.279 412.223 485.371 412.176 485.452C412.13 485.534 412.062 485.601 411.981 485.649L386.348 500.443C386.026 500.627 385.662 500.724 385.29 500.724C384.919 500.724 384.555 500.627 384.233 500.443L367.762 491.036C367.681 490.988 367.614 490.921 367.567 490.839C367.521 490.758 367.496 490.666 367.496 490.572C367.496 490.478 367.521 490.386 367.567 490.304C367.614 490.223 367.681 490.155 367.762 490.108L393.395 475.314C393.718 475.13 394.082 475.033 394.453 475.033C394.824 475.033 395.189 475.13 395.511 475.314Z",
    fill: "#F7F7F7"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M397.062 487.504L401.391 489.978C401.411 489.991 401.427 490.009 401.439 490.031C401.45 490.052 401.456 490.076 401.456 490.1C401.456 490.124 401.45 490.148 401.439 490.169C401.427 490.19 401.411 490.209 401.391 490.222L394.637 494.112C394.551 494.163 394.452 494.19 394.352 494.19C394.251 494.19 394.153 494.163 394.067 494.112L389.673 491.589C389.648 491.58 389.626 491.563 389.611 491.541C389.596 491.519 389.588 491.493 389.588 491.467C389.588 491.44 389.596 491.414 389.611 491.393C389.626 491.371 389.648 491.354 389.673 491.345L396.427 487.455C396.521 487.386 396.637 487.353 396.753 487.362C396.87 487.371 396.979 487.421 397.062 487.504Z",
    fill: "#E5E9F4"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M393.703 476.746L392.287 477.576V477.722L392.987 478.129C393.013 478.149 393.044 478.16 393.076 478.16C393.109 478.16 393.14 478.149 393.166 478.129L394.582 477.316V477.169L393.882 476.762C393.856 476.744 393.826 476.733 393.795 476.73C393.763 476.727 393.732 476.733 393.703 476.746Z",
    fill: "#D3DAED"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M391.619 477.983L390.203 478.813C390.193 478.822 390.184 478.833 390.179 478.846C390.173 478.858 390.17 478.872 390.17 478.886C390.17 478.9 390.173 478.914 390.179 478.926C390.184 478.939 390.193 478.95 390.203 478.959L390.903 479.366C390.933 479.382 390.966 479.39 391 479.39C391.034 479.39 391.068 479.382 391.098 479.366L392.514 478.536C392.524 478.527 392.533 478.516 392.538 478.503C392.544 478.49 392.547 478.477 392.547 478.463C392.547 478.449 392.544 478.435 392.538 478.423C392.533 478.41 392.524 478.399 392.514 478.39L391.798 477.983C391.771 477.967 391.74 477.959 391.708 477.959C391.677 477.959 391.646 477.967 391.619 477.983Z",
    fill: "#D3DAED"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M389.541 479.154L388.125 479.984V480.131L388.825 480.538C388.852 480.554 388.883 480.562 388.914 480.562C388.946 480.562 388.977 480.554 389.004 480.538L390.436 479.708C390.446 479.699 390.455 479.687 390.46 479.675C390.466 479.662 390.469 479.648 390.469 479.635C390.469 479.621 390.466 479.607 390.46 479.594C390.455 479.582 390.446 479.57 390.436 479.561L389.72 479.154C389.693 479.139 389.662 479.13 389.63 479.13C389.599 479.13 389.568 479.139 389.541 479.154Z",
    fill: "#D3DAED"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M387.385 480.376L385.969 481.189V481.336L386.669 481.743C386.696 481.758 386.727 481.767 386.758 481.767C386.79 481.767 386.82 481.758 386.848 481.743L388.28 480.929C388.29 480.92 388.298 480.908 388.304 480.896C388.31 480.883 388.313 480.869 388.313 480.856C388.313 480.842 388.31 480.828 388.304 480.815C388.298 480.803 388.29 480.792 388.28 480.782L387.564 480.376C387.536 480.36 387.506 480.352 387.474 480.352C387.443 480.352 387.412 480.36 387.385 480.376Z",
    fill: "#D3DAED"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M385.328 481.515L383.912 482.345C383.902 482.354 383.893 482.365 383.888 482.378C383.882 482.39 383.879 482.404 383.879 482.418C383.879 482.432 383.882 482.445 383.888 482.458C383.893 482.471 383.902 482.482 383.912 482.491L384.612 482.898C384.642 482.914 384.675 482.922 384.709 482.922C384.743 482.922 384.777 482.914 384.807 482.898L386.223 482.068C386.233 482.059 386.242 482.048 386.247 482.035C386.253 482.022 386.256 482.009 386.256 481.995C386.256 481.981 386.253 481.967 386.247 481.955C386.242 481.942 386.233 481.931 386.223 481.921L385.507 481.515C385.48 481.499 385.449 481.491 385.417 481.491C385.386 481.491 385.355 481.499 385.328 481.515Z",
    fill: "#D3DAED"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M383.322 482.751L381.906 483.581V483.728L382.606 484.135C382.633 484.15 382.664 484.159 382.696 484.159C382.727 484.159 382.758 484.15 382.785 484.135L384.201 483.305V483.158L383.501 482.751C383.474 482.736 383.443 482.727 383.412 482.727C383.38 482.727 383.349 482.736 383.322 482.751Z",
    fill: "#D3DAED"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M381.223 483.923L379.807 484.737V484.883L380.506 485.29C380.534 485.306 380.565 485.314 380.596 485.314C380.627 485.314 380.658 485.306 380.685 485.29L382.101 484.46V484.314L381.402 483.923C381.374 483.907 381.343 483.899 381.312 483.899C381.281 483.899 381.25 483.907 381.223 483.923Z",
    fill: "#D3DAED"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M379.152 485.079L377.736 485.909V486.056L378.436 486.463C378.463 486.478 378.494 486.487 378.526 486.487C378.557 486.487 378.588 486.478 378.615 486.463L380.031 485.633V485.486L379.331 485.079C379.304 485.063 379.273 485.055 379.242 485.055C379.21 485.055 379.179 485.063 379.152 485.079Z",
    fill: "#D3DAED"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M377.119 486.349L375.703 487.162V487.309L376.403 487.716C376.43 487.731 376.461 487.74 376.492 487.74C376.524 487.74 376.555 487.731 376.582 487.716L377.998 486.902V486.756L377.298 486.349C377.271 486.333 377.24 486.325 377.209 486.325C377.177 486.325 377.146 486.333 377.119 486.349Z",
    fill: "#D3DAED"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M374.971 487.585L373.555 488.399V488.545L374.255 488.952C374.282 488.968 374.313 488.976 374.344 488.976C374.375 488.976 374.406 488.968 374.434 488.952L375.849 488.138V487.992L375.15 487.585C375.122 487.569 375.092 487.561 375.06 487.561C375.029 487.561 374.998 487.569 374.971 487.585Z",
    fill: "#D3DAED"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M372.883 488.757L371.467 489.571V489.717L372.167 490.124C372.194 490.14 372.225 490.148 372.256 490.148C372.288 490.148 372.318 490.14 372.346 490.124L373.762 489.31V489.164L373.062 488.757C373.035 488.741 373.004 488.733 372.972 488.733C372.941 488.733 372.91 488.741 372.883 488.757Z",
    fill: "#D3DAED"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M396.587 478.292L395.627 477.739C395.565 477.703 395.495 477.684 395.423 477.684C395.352 477.684 395.282 477.703 395.22 477.739L394.292 478.292C394.262 478.309 394.236 478.334 394.218 478.364C394.201 478.394 394.191 478.428 394.191 478.463C394.191 478.498 394.201 478.532 394.218 478.562C394.236 478.592 394.262 478.617 394.292 478.634L395.236 479.204C395.297 479.243 395.367 479.264 395.44 479.264C395.512 479.264 395.582 479.243 395.643 479.204L396.603 478.65C396.637 478.633 396.666 478.607 396.685 478.574C396.705 478.542 396.714 478.504 396.713 478.466C396.711 478.428 396.698 478.391 396.676 478.36C396.653 478.329 396.623 478.306 396.587 478.292Z",
    fill: "#D3DAED"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M394.435 479.529L393.475 478.976C393.414 478.936 393.344 478.916 393.272 478.916C393.199 478.916 393.129 478.936 393.068 478.976L392.124 479.513C392.094 479.53 392.068 479.554 392.051 479.584C392.033 479.614 392.023 479.649 392.023 479.684C392.023 479.718 392.033 479.753 392.051 479.783C392.068 479.813 392.094 479.838 392.124 479.854L393.052 480.424C393.115 480.465 393.188 480.486 393.263 480.486C393.338 480.486 393.412 480.465 393.475 480.424L394.435 479.871C394.466 479.854 394.491 479.829 394.509 479.799C394.527 479.769 394.536 479.735 394.536 479.7C394.536 479.665 394.527 479.631 394.509 479.601C394.491 479.571 394.466 479.546 394.435 479.529Z",
    fill: "#D3DAED"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M392.357 480.701L391.397 480.148C391.336 480.109 391.266 480.088 391.193 480.088C391.121 480.088 391.051 480.109 390.99 480.148L390.046 480.685C390.016 480.702 389.99 480.727 389.972 480.757C389.955 480.787 389.945 480.821 389.945 480.856C389.945 480.891 389.955 480.925 389.972 480.955C389.99 480.985 390.016 481.01 390.046 481.027L390.974 481.596C391.034 481.636 391.105 481.656 391.177 481.656C391.249 481.656 391.32 481.636 391.381 481.596L392.341 481.043C392.372 481.028 392.399 481.004 392.418 480.975C392.437 480.946 392.448 480.912 392.45 480.877C392.452 480.842 392.444 480.807 392.428 480.776C392.411 480.745 392.387 480.72 392.357 480.701Z",
    fill: "#D3DAED"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M390.126 481.921L389.166 481.352C389.105 481.313 389.034 481.292 388.962 481.292C388.89 481.292 388.819 481.313 388.759 481.352L387.831 481.889C387.801 481.906 387.775 481.931 387.758 481.961C387.74 481.991 387.73 482.025 387.73 482.06C387.73 482.095 387.74 482.129 387.758 482.159C387.775 482.189 387.801 482.214 387.831 482.231L388.775 482.8C388.837 482.836 388.907 482.855 388.979 482.855C389.05 482.855 389.12 482.836 389.182 482.8L390.142 482.247C390.168 482.228 390.189 482.203 390.203 482.173C390.217 482.144 390.223 482.112 390.222 482.08C390.22 482.048 390.21 482.016 390.194 481.989C390.177 481.961 390.154 481.938 390.126 481.921Z",
    fill: "#D3DAED"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M388.17 483.061L387.209 482.507C387.149 482.468 387.078 482.447 387.006 482.447C386.934 482.447 386.863 482.468 386.803 482.507L385.859 483.044C385.828 483.061 385.803 483.086 385.785 483.116C385.767 483.146 385.758 483.18 385.758 483.215C385.758 483.25 385.767 483.284 385.785 483.314C385.803 483.344 385.828 483.369 385.859 483.386L386.786 483.956C386.849 483.996 386.923 484.018 386.998 484.018C387.073 484.018 387.146 483.996 387.209 483.956L388.17 483.402C388.2 483.386 388.226 483.361 388.243 483.331C388.261 483.301 388.27 483.266 388.27 483.231C388.27 483.197 388.261 483.162 388.243 483.132C388.226 483.102 388.2 483.078 388.17 483.061Z",
    fill: "#D3DAED"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M386.181 484.297L385.221 483.728C385.158 483.696 385.088 483.68 385.018 483.68C384.947 483.68 384.877 483.696 384.814 483.728L383.87 484.265C383.84 484.284 383.815 484.31 383.798 484.342C383.781 484.373 383.771 484.408 383.771 484.444C383.771 484.48 383.781 484.515 383.798 484.546C383.815 484.577 383.84 484.604 383.87 484.623L384.798 485.192C384.859 485.232 384.929 485.253 385.001 485.253C385.074 485.253 385.144 485.232 385.205 485.192L386.181 484.639C386.212 484.622 386.237 484.597 386.255 484.567C386.273 484.537 386.282 484.503 386.282 484.468C386.282 484.433 386.273 484.399 386.255 484.369C386.237 484.339 386.212 484.314 386.181 484.297Z",
    fill: "#D3DAED"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M384.034 485.453L383.074 484.899C383.013 484.86 382.943 484.839 382.871 484.839C382.798 484.839 382.728 484.86 382.667 484.899L381.739 485.436C381.709 485.453 381.683 485.478 381.666 485.508C381.648 485.538 381.639 485.572 381.639 485.607C381.639 485.642 381.648 485.676 381.666 485.707C381.683 485.737 381.709 485.761 381.739 485.778L382.683 486.348C382.745 486.384 382.815 486.402 382.887 486.402C382.958 486.402 383.028 486.384 383.09 486.348L384.05 485.794C384.076 485.774 384.097 485.747 384.111 485.716C384.125 485.686 384.131 485.653 384.129 485.619C384.128 485.586 384.118 485.554 384.102 485.525C384.085 485.496 384.062 485.471 384.034 485.453Z",
    fill: "#D3DAED"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M381.97 486.706L381.009 486.137C380.946 486.105 380.877 486.089 380.806 486.089C380.735 486.089 380.666 486.105 380.602 486.137L379.675 486.674C379.648 486.695 379.626 486.722 379.611 486.753C379.596 486.784 379.588 486.818 379.588 486.853C379.588 486.887 379.596 486.921 379.611 486.952C379.626 486.983 379.648 487.011 379.675 487.032L380.619 487.602C380.679 487.641 380.75 487.662 380.822 487.662C380.894 487.662 380.965 487.641 381.026 487.602L381.986 487.048C382.016 487.03 382.04 487.004 382.056 486.973C382.073 486.942 382.08 486.907 382.079 486.873C382.077 486.838 382.066 486.804 382.047 486.775C382.028 486.745 382.001 486.722 381.97 486.706Z",
    fill: "#D3DAED"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M379.941 487.895L378.981 487.325C378.918 487.294 378.848 487.277 378.777 487.277C378.707 487.277 378.637 487.294 378.574 487.325L377.63 487.878C377.6 487.895 377.574 487.92 377.556 487.95C377.539 487.98 377.529 488.014 377.529 488.049C377.529 488.084 377.539 488.118 377.556 488.148C377.574 488.179 377.6 488.203 377.63 488.22L378.558 488.79C378.618 488.829 378.689 488.85 378.761 488.85C378.833 488.85 378.904 488.829 378.965 488.79L379.941 488.236C379.972 488.22 379.997 488.195 380.015 488.165C380.033 488.135 380.042 488.1 380.042 488.066C380.042 488.031 380.033 487.996 380.015 487.966C379.997 487.936 379.972 487.912 379.941 487.895Z",
    fill: "#D3DAED"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M377.705 489.213L376.745 488.643C376.684 488.604 376.613 488.583 376.541 488.583C376.469 488.583 376.398 488.604 376.338 488.643L375.394 489.18C375.363 489.197 375.338 489.222 375.32 489.252C375.302 489.282 375.293 489.316 375.293 489.351C375.293 489.386 375.302 489.42 375.32 489.45C375.338 489.48 375.363 489.505 375.394 489.522L376.321 490.092C376.386 490.127 376.459 490.146 376.533 490.146C376.607 490.146 376.68 490.127 376.745 490.092L377.705 489.538C377.732 489.521 377.754 489.496 377.769 489.468C377.784 489.44 377.792 489.408 377.792 489.376C377.792 489.343 377.784 489.312 377.769 489.283C377.754 489.255 377.732 489.231 377.705 489.213Z",
    fill: "#D3DAED"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M375.685 490.303L374.725 489.733C374.662 489.702 374.592 489.685 374.522 489.685C374.451 489.685 374.381 489.702 374.318 489.733L373.374 490.27C373.344 490.287 373.318 490.312 373.301 490.342C373.283 490.372 373.273 490.406 373.273 490.441C373.273 490.476 373.283 490.51 373.301 490.541C373.318 490.571 373.344 490.595 373.374 490.612L374.302 491.198C374.368 491.23 374.44 491.246 374.513 491.246C374.587 491.246 374.659 491.23 374.725 491.198L375.685 490.645C375.716 490.628 375.741 490.603 375.759 490.573C375.777 490.543 375.786 490.509 375.786 490.474C375.786 490.439 375.777 490.405 375.759 490.375C375.741 490.345 375.716 490.32 375.685 490.303Z",
    fill: "#D3DAED"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M398.675 479.464L397.715 478.894C397.652 478.863 397.582 478.846 397.512 478.846C397.441 478.846 397.372 478.863 397.308 478.894L396.364 479.431C396.334 479.448 396.308 479.473 396.291 479.503C396.273 479.533 396.264 479.567 396.264 479.602C396.264 479.637 396.273 479.671 396.291 479.701C396.308 479.731 396.334 479.756 396.364 479.773L397.292 480.359C397.355 480.39 397.425 480.407 397.496 480.407C397.566 480.407 397.636 480.39 397.699 480.359L398.659 479.806C398.691 479.79 398.717 479.767 398.736 479.737C398.756 479.708 398.767 479.674 398.768 479.639C398.77 479.605 398.762 479.57 398.746 479.539C398.73 479.508 398.705 479.482 398.675 479.464Z",
    fill: "#D3DAED"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M396.567 480.701L395.607 480.132C395.547 480.099 395.48 480.082 395.412 480.082C395.344 480.082 395.276 480.099 395.217 480.132L394.273 480.669C394.242 480.686 394.217 480.71 394.199 480.74C394.181 480.77 394.172 480.805 394.172 480.84C394.172 480.874 394.181 480.909 394.199 480.939C394.217 480.969 394.242 480.994 394.273 481.01L395.2 481.596C395.263 481.628 395.333 481.644 395.404 481.644C395.474 481.644 395.544 481.628 395.607 481.596L396.567 481.043C396.598 481.026 396.623 481.001 396.641 480.971C396.659 480.941 396.668 480.907 396.668 480.872C396.668 480.837 396.659 480.803 396.641 480.773C396.623 480.743 396.598 480.718 396.567 480.701Z",
    fill: "#D3DAED"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M394.484 481.824L393.524 481.254C393.461 481.223 393.391 481.206 393.32 481.206C393.25 481.206 393.18 481.223 393.117 481.254L392.173 481.824C392.142 481.841 392.117 481.865 392.099 481.895C392.082 481.926 392.072 481.96 392.072 481.995C392.072 482.03 392.082 482.064 392.099 482.094C392.117 482.124 392.142 482.149 392.173 482.165L393.117 482.751C393.18 482.783 393.25 482.799 393.32 482.799C393.391 482.799 393.461 482.783 393.524 482.751L394.484 482.198C394.524 482.186 394.56 482.161 394.585 482.128C394.61 482.094 394.624 482.053 394.624 482.011C394.624 481.969 394.61 481.928 394.585 481.894C394.56 481.86 394.524 481.836 394.484 481.824Z",
    fill: "#D3DAED"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M392.265 483.077L391.305 482.507C391.242 482.476 391.172 482.459 391.102 482.459C391.031 482.459 390.961 482.476 390.898 482.507L389.954 483.06C389.924 483.077 389.898 483.102 389.881 483.132C389.863 483.162 389.854 483.196 389.854 483.231C389.854 483.266 389.863 483.3 389.881 483.331C389.898 483.361 389.924 483.385 389.954 483.402L390.882 483.972C390.943 484.011 391.013 484.032 391.085 484.032C391.158 484.032 391.228 484.011 391.289 483.972L392.249 483.419C392.28 483.403 392.307 483.38 392.326 483.35C392.345 483.321 392.356 483.287 392.358 483.252C392.36 483.218 392.352 483.183 392.336 483.152C392.319 483.121 392.295 483.095 392.265 483.077Z",
    fill: "#D3DAED"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M390.308 484.233L389.347 483.663C389.284 483.631 389.215 483.615 389.144 483.615C389.073 483.615 389.004 483.631 388.941 483.663L388.013 484.2C387.982 484.217 387.957 484.242 387.939 484.272C387.921 484.302 387.912 484.336 387.912 484.371C387.912 484.406 387.921 484.44 387.939 484.47C387.957 484.5 387.982 484.525 388.013 484.542L388.941 485.128C389.002 485.163 389.073 485.182 389.144 485.182C389.215 485.182 389.286 485.163 389.347 485.128L390.308 484.574C390.338 484.557 390.364 484.533 390.381 484.503C390.399 484.473 390.408 484.438 390.408 484.403C390.408 484.369 390.399 484.334 390.381 484.304C390.364 484.274 390.338 484.249 390.308 484.233Z",
    fill: "#D3DAED"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M388.321 485.453L387.361 484.899C387.3 484.86 387.23 484.839 387.158 484.839C387.085 484.839 387.015 484.86 386.954 484.899L386.027 485.436C385.996 485.453 385.971 485.478 385.953 485.508C385.935 485.538 385.926 485.572 385.926 485.607C385.926 485.642 385.935 485.676 385.953 485.707C385.971 485.737 385.996 485.761 386.027 485.778L386.97 486.348C387.032 486.384 387.102 486.402 387.174 486.402C387.245 486.402 387.315 486.384 387.377 486.348L388.338 485.794C388.364 485.774 388.384 485.747 388.398 485.716C388.412 485.686 388.418 485.653 388.416 485.619C388.415 485.586 388.405 485.554 388.389 485.525C388.372 485.496 388.349 485.471 388.321 485.453Z",
    fill: "#D3DAED"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M386.195 486.706L385.218 486.137C385.158 486.105 385.091 486.089 385.023 486.089C384.955 486.089 384.888 486.105 384.828 486.137L383.884 486.69C383.853 486.707 383.828 486.732 383.81 486.762C383.793 486.792 383.783 486.826 383.783 486.861C383.783 486.896 383.793 486.93 383.81 486.96C383.828 486.99 383.853 487.015 383.884 487.032L384.812 487.602C384.872 487.641 384.943 487.662 385.015 487.662C385.087 487.662 385.158 487.641 385.218 487.602L386.179 487.048C386.21 487.033 386.237 487.009 386.256 486.98C386.275 486.951 386.286 486.917 386.288 486.882C386.289 486.847 386.282 486.813 386.265 486.782C386.249 486.751 386.225 486.725 386.195 486.706Z",
    fill: "#D3DAED"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M384.121 487.796L383.161 487.243C383.1 487.204 383.029 487.183 382.957 487.183C382.885 487.183 382.814 487.204 382.754 487.243L381.81 487.78C381.779 487.797 381.754 487.822 381.736 487.852C381.718 487.882 381.709 487.916 381.709 487.951C381.709 487.986 381.718 488.02 381.736 488.05C381.754 488.08 381.779 488.105 381.81 488.122L382.737 488.691C382.802 488.727 382.875 488.746 382.949 488.746C383.023 488.746 383.096 488.727 383.161 488.691L384.121 488.138C384.148 488.118 384.17 488.093 384.185 488.063C384.2 488.033 384.208 488.001 384.208 487.967C384.208 487.934 384.2 487.901 384.185 487.871C384.17 487.842 384.148 487.816 384.121 487.796Z",
    fill: "#D3DAED"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M382.067 489.05L381.107 488.497C381.047 488.457 380.976 488.437 380.904 488.437C380.832 488.437 380.761 488.457 380.7 488.497L379.773 489.034C379.742 489.051 379.717 489.075 379.699 489.105C379.681 489.135 379.672 489.17 379.672 489.205C379.672 489.239 379.681 489.274 379.699 489.304C379.717 489.334 379.742 489.359 379.773 489.375L380.717 489.945C380.778 489.981 380.849 490 380.92 490C380.991 490 381.062 489.981 381.123 489.945L382.084 489.392C382.11 489.371 382.13 489.344 382.144 489.314C382.158 489.283 382.164 489.25 382.163 489.217C382.161 489.183 382.151 489.151 382.135 489.122C382.118 489.093 382.095 489.068 382.067 489.05Z",
    fill: "#D3DAED"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M379.835 490.368L378.874 489.798C378.811 489.767 378.742 489.75 378.671 489.75C378.6 489.75 378.531 489.767 378.468 489.798L377.54 490.352C377.513 490.371 377.491 490.397 377.476 490.427C377.461 490.456 377.453 490.489 377.453 490.523C377.453 490.556 377.461 490.589 377.476 490.619C377.491 490.648 377.513 490.674 377.54 490.694L378.484 491.263C378.544 491.302 378.615 491.323 378.687 491.323C378.76 491.323 378.83 491.302 378.891 491.263L379.851 490.71C379.881 490.692 379.905 490.666 379.921 490.635C379.938 490.604 379.945 490.569 379.944 490.534C379.942 490.499 379.931 490.465 379.912 490.436C379.893 490.407 379.866 490.383 379.835 490.368Z",
    fill: "#D3DAED"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M377.819 491.459L376.859 490.905C376.802 490.865 376.734 490.844 376.664 490.844C376.594 490.844 376.526 490.865 376.469 490.905L375.525 491.442C375.494 491.459 375.469 491.484 375.451 491.514C375.433 491.544 375.424 491.578 375.424 491.613C375.424 491.648 375.433 491.682 375.451 491.712C375.469 491.743 375.494 491.767 375.525 491.784L376.452 492.354C376.513 492.393 376.583 492.414 376.656 492.414C376.728 492.414 376.799 492.393 376.859 492.354L377.819 491.8C377.85 491.784 377.875 491.759 377.893 491.729C377.911 491.699 377.92 491.664 377.92 491.63C377.92 491.595 377.911 491.56 377.893 491.53C377.875 491.5 377.85 491.476 377.819 491.459Z",
    fill: "#D3DAED"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M400.868 480.62L399.908 480.066C399.847 480.027 399.777 480.006 399.704 480.006C399.632 480.006 399.562 480.027 399.501 480.066L398.573 480.603C398.543 480.62 398.517 480.645 398.5 480.675C398.482 480.705 398.473 480.739 398.473 480.774C398.473 480.809 398.482 480.843 398.5 480.874C398.517 480.904 398.543 480.928 398.573 480.945L399.517 481.515C399.578 481.554 399.649 481.575 399.721 481.575C399.793 481.575 399.864 481.554 399.924 481.515L400.884 480.961C400.914 480.943 400.939 480.917 400.955 480.886C400.971 480.855 400.979 480.821 400.977 480.786C400.976 480.751 400.965 480.717 400.945 480.688C400.926 480.659 400.9 480.635 400.868 480.62Z",
    fill: "#D3DAED"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M398.675 481.824L397.715 481.27C397.655 481.231 397.584 481.21 397.512 481.21C397.44 481.21 397.369 481.231 397.308 481.27L396.364 481.807C396.334 481.824 396.308 481.849 396.291 481.879C396.273 481.909 396.264 481.943 396.264 481.978C396.264 482.013 396.273 482.047 396.291 482.077C396.308 482.107 396.334 482.132 396.364 482.149L397.292 482.719C397.355 482.759 397.429 482.781 397.504 482.781C397.579 482.781 397.652 482.759 397.715 482.719L398.675 482.165C398.706 482.148 398.731 482.124 398.749 482.094C398.767 482.064 398.776 482.029 398.776 481.994C398.776 481.96 398.767 481.925 398.749 481.895C398.731 481.865 398.706 481.84 398.675 481.824Z",
    fill: "#D3DAED"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M396.634 483.028L395.674 482.475C395.614 482.436 395.543 482.415 395.471 482.415C395.399 482.415 395.328 482.436 395.267 482.475L394.323 483.012C394.293 483.029 394.267 483.054 394.25 483.084C394.232 483.114 394.223 483.148 394.223 483.183C394.223 483.218 394.232 483.252 394.25 483.282C394.267 483.312 394.293 483.337 394.323 483.354L395.251 483.923C395.312 483.963 395.382 483.983 395.455 483.983C395.527 483.983 395.597 483.963 395.658 483.923L396.634 483.37C396.665 483.353 396.69 483.328 396.708 483.298C396.726 483.268 396.735 483.234 396.735 483.199C396.735 483.164 396.726 483.13 396.708 483.1C396.69 483.07 396.665 483.045 396.634 483.028Z",
    fill: "#D3DAED"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M394.407 484.248L393.447 483.679C393.386 483.639 393.316 483.619 393.244 483.619C393.171 483.619 393.101 483.639 393.04 483.679L392.112 484.216C392.082 484.233 392.056 484.257 392.039 484.287C392.021 484.317 392.012 484.352 392.012 484.387C392.012 484.422 392.021 484.456 392.039 484.486C392.056 484.516 392.082 484.541 392.112 484.557L393.056 485.127C393.118 485.163 393.188 485.182 393.26 485.182C393.331 485.182 393.401 485.163 393.463 485.127L394.423 484.574C394.45 484.555 394.47 484.529 394.484 484.5C394.498 484.471 394.505 484.439 394.503 484.407C394.501 484.374 394.492 484.343 394.475 484.315C394.458 484.288 394.435 484.265 394.407 484.248Z",
    fill: "#D3DAED"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M392.451 485.388L391.491 484.835C391.43 484.796 391.359 484.775 391.287 484.775C391.215 484.775 391.144 484.796 391.084 484.835L390.14 485.372C390.109 485.389 390.084 485.413 390.066 485.444C390.048 485.474 390.039 485.508 390.039 485.543C390.039 485.578 390.048 485.612 390.066 485.642C390.084 485.672 390.109 485.697 390.14 485.714L391.067 486.283C391.132 486.319 391.205 486.337 391.279 486.337C391.353 486.337 391.426 486.319 391.491 486.283L392.451 485.714C392.478 485.696 392.5 485.672 392.515 485.643C392.53 485.615 392.538 485.583 392.538 485.551C392.538 485.519 392.53 485.487 392.515 485.458C392.5 485.43 392.478 485.406 392.451 485.388Z",
    fill: "#D3DAED"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M390.549 486.706L389.588 486.137C389.525 486.105 389.455 486.089 389.385 486.089C389.314 486.089 389.245 486.105 389.181 486.137L388.237 486.69C388.207 486.707 388.182 486.732 388.164 486.762C388.146 486.792 388.137 486.826 388.137 486.861C388.137 486.896 388.146 486.93 388.164 486.96C388.182 486.99 388.207 487.015 388.237 487.032L389.165 487.602C389.226 487.641 389.296 487.662 389.369 487.662C389.441 487.662 389.511 487.641 389.572 487.602L390.549 487.048C390.579 487.031 390.604 487.007 390.622 486.977C390.64 486.946 390.649 486.912 390.649 486.877C390.649 486.842 390.64 486.808 390.622 486.778C390.604 486.748 390.579 486.723 390.549 486.706Z",
    fill: "#D3DAED"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M388.333 487.781L387.373 487.227C387.312 487.188 387.242 487.167 387.169 487.167C387.097 487.167 387.027 487.188 386.966 487.227L386.038 487.764C386.008 487.781 385.982 487.806 385.965 487.836C385.947 487.866 385.938 487.9 385.938 487.935C385.938 487.97 385.947 488.004 385.965 488.034C385.982 488.064 386.008 488.089 386.038 488.106L386.982 488.676C387.044 488.711 387.114 488.73 387.186 488.73C387.257 488.73 387.327 488.711 387.389 488.676L388.349 488.122C388.375 488.101 388.396 488.075 388.41 488.044C388.423 488.014 388.43 487.981 388.428 487.947C388.427 487.914 388.417 487.881 388.401 487.853C388.384 487.824 388.361 487.799 388.333 487.781Z",
    fill: "#D3DAED"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M386.257 488.968L385.296 488.399C385.233 488.367 385.164 488.351 385.093 488.351C385.022 488.351 384.953 488.367 384.889 488.399L383.962 488.952C383.935 488.972 383.913 488.997 383.898 489.027C383.883 489.057 383.875 489.09 383.875 489.123C383.875 489.156 383.883 489.189 383.898 489.219C383.913 489.249 383.935 489.274 383.962 489.294L384.906 489.863C384.966 489.903 385.037 489.924 385.109 489.924C385.181 489.924 385.252 489.903 385.313 489.863L386.273 489.31C386.303 489.292 386.327 489.266 386.343 489.235C386.36 489.204 386.367 489.169 386.366 489.134C386.364 489.1 386.353 489.066 386.334 489.036C386.315 489.007 386.288 488.984 386.257 488.968Z",
    fill: "#D3DAED"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M384.216 490.222L383.256 489.652C383.193 489.62 383.123 489.604 383.053 489.604C382.982 489.604 382.913 489.62 382.849 489.652L381.905 490.205C381.875 490.222 381.849 490.247 381.832 490.277C381.814 490.307 381.805 490.341 381.805 490.376C381.805 490.411 381.814 490.445 381.832 490.475C381.849 490.505 381.875 490.53 381.905 490.547L382.833 491.117C382.894 491.156 382.964 491.177 383.037 491.177C383.109 491.177 383.179 491.156 383.24 491.117L384.216 490.563C384.247 490.546 384.272 490.522 384.29 490.492C384.308 490.462 384.317 490.427 384.317 490.392C384.317 490.358 384.308 490.323 384.29 490.293C384.272 490.263 384.247 490.238 384.216 490.222Z",
    fill: "#D3DAED"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M381.99 491.589L381.03 491.019C380.969 490.98 380.898 490.959 380.826 490.959C380.754 490.959 380.683 490.98 380.623 491.019L379.679 491.556C379.648 491.573 379.623 491.598 379.605 491.628C379.587 491.658 379.578 491.692 379.578 491.727C379.578 491.762 379.587 491.796 379.605 491.826C379.623 491.856 379.648 491.881 379.679 491.898L380.607 492.468C380.671 492.503 380.744 492.522 380.818 492.522C380.892 492.522 380.965 492.503 381.03 492.468L381.99 491.914C382.017 491.897 382.039 491.872 382.054 491.844C382.069 491.816 382.077 491.784 382.077 491.752C382.077 491.719 382.069 491.688 382.054 491.659C382.039 491.631 382.017 491.607 381.99 491.589Z",
    fill: "#D3DAED"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M379.97 492.63L379.01 492.061C378.947 492.029 378.877 492.013 378.807 492.013C378.736 492.013 378.666 492.029 378.603 492.061L377.659 492.598C377.629 492.615 377.603 492.639 377.586 492.67C377.568 492.7 377.559 492.734 377.559 492.769C377.559 492.804 377.568 492.838 377.586 492.868C377.603 492.898 377.629 492.923 377.659 492.94L378.603 493.525C378.665 493.561 378.735 493.58 378.807 493.58C378.878 493.58 378.948 493.561 379.01 493.525L379.97 492.972C380.001 492.955 380.026 492.93 380.044 492.9C380.062 492.87 380.071 492.836 380.071 492.801C380.071 492.766 380.062 492.732 380.044 492.702C380.026 492.672 380.001 492.647 379.97 492.63Z",
    fill: "#D3DAED"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M403.017 481.824L402.057 481.254C401.994 481.223 401.924 481.206 401.854 481.206C401.783 481.206 401.713 481.223 401.65 481.254L400.706 481.791C400.676 481.808 400.65 481.833 400.633 481.863C400.615 481.893 400.605 481.927 400.605 481.962C400.605 481.997 400.615 482.031 400.633 482.061C400.65 482.091 400.676 482.116 400.706 482.133L401.634 482.719C401.697 482.75 401.767 482.767 401.837 482.767C401.908 482.767 401.978 482.75 402.041 482.719L403.001 482.165C403.032 482.15 403.059 482.127 403.078 482.097C403.097 482.068 403.108 482.034 403.11 481.999C403.112 481.964 403.104 481.93 403.088 481.899C403.071 481.868 403.047 481.842 403.017 481.824Z",
    fill: "#D3DAED"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M400.847 483.028L399.886 482.458C399.827 482.426 399.759 482.408 399.691 482.408C399.623 482.408 399.556 482.426 399.496 482.458L398.552 482.995C398.521 483.012 398.496 483.037 398.478 483.067C398.461 483.097 398.451 483.131 398.451 483.166C398.451 483.201 398.461 483.235 398.478 483.266C398.496 483.296 398.521 483.32 398.552 483.337L399.48 483.923C399.541 483.959 399.612 483.978 399.683 483.978C399.754 483.978 399.825 483.959 399.886 483.923L400.847 483.37C400.877 483.353 400.903 483.328 400.92 483.298C400.938 483.268 400.947 483.234 400.947 483.199C400.947 483.164 400.938 483.13 400.92 483.1C400.903 483.07 400.877 483.045 400.847 483.028Z",
    fill: "#D3DAED"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M398.769 484.2L397.808 483.63C397.745 483.599 397.675 483.583 397.605 483.583C397.534 483.583 397.465 483.599 397.401 483.63L396.474 484.168C396.443 484.184 396.418 484.209 396.4 484.239C396.382 484.269 396.373 484.304 396.373 484.338C396.373 484.373 396.382 484.408 396.4 484.438C396.418 484.468 396.443 484.492 396.474 484.509L397.418 485.095C397.48 485.131 397.55 485.15 397.621 485.15C397.693 485.15 397.763 485.131 397.825 485.095L398.785 484.542C398.815 484.524 398.839 484.498 398.855 484.467C398.872 484.436 398.879 484.401 398.878 484.366C398.876 484.331 398.865 484.297 398.846 484.268C398.827 484.239 398.8 484.215 398.769 484.2Z",
    fill: "#D3DAED"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M396.55 485.404L395.59 484.835C395.527 484.803 395.457 484.787 395.387 484.787C395.316 484.787 395.247 484.803 395.183 484.835L394.239 485.388C394.209 485.405 394.183 485.43 394.166 485.46C394.148 485.49 394.139 485.524 394.139 485.559C394.139 485.594 394.148 485.628 394.166 485.658C394.183 485.688 394.209 485.713 394.239 485.73L395.167 486.3C395.228 486.339 395.298 486.36 395.371 486.36C395.443 486.36 395.513 486.339 395.574 486.3L396.55 485.746C396.581 485.729 396.606 485.705 396.624 485.674C396.642 485.644 396.651 485.61 396.651 485.575C396.651 485.54 396.642 485.506 396.624 485.476C396.606 485.446 396.581 485.421 396.55 485.404Z",
    fill: "#D3DAED"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M394.407 486.707L393.447 486.137C393.385 486.101 393.315 486.083 393.243 486.083C393.172 486.083 393.102 486.101 393.04 486.137L388.157 488.953C388.127 488.969 388.101 488.994 388.084 489.024C388.066 489.054 388.057 489.089 388.057 489.123C388.057 489.158 388.066 489.193 388.084 489.223C388.101 489.253 388.127 489.277 388.157 489.294L389.085 489.88C389.148 489.912 389.218 489.928 389.289 489.928C389.359 489.928 389.429 489.912 389.492 489.88L394.374 487.048C394.407 487.035 394.435 487.012 394.456 486.984C394.476 486.956 394.489 486.922 394.492 486.887C394.496 486.852 394.49 486.817 394.474 486.785C394.459 486.753 394.436 486.726 394.407 486.707Z",
    fill: "#D3DAED"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M388.398 490.124L387.438 489.571C387.377 489.531 387.307 489.51 387.234 489.51C387.162 489.51 387.092 489.531 387.031 489.571L386.087 490.108C386.057 490.124 386.031 490.149 386.013 490.179C385.996 490.209 385.986 490.244 385.986 490.278C385.986 490.313 385.996 490.348 386.013 490.378C386.031 490.408 386.057 490.432 386.087 490.449L387.015 491.019C387.08 491.055 387.152 491.073 387.226 491.073C387.3 491.073 387.373 491.055 387.438 491.019L388.398 490.466C388.425 490.446 388.447 490.42 388.462 490.391C388.477 490.361 388.485 490.328 388.485 490.295C388.485 490.261 388.477 490.229 388.462 490.199C388.447 490.169 388.425 490.144 388.398 490.124Z",
    fill: "#D3DAED"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M386.349 491.377L385.388 490.824C385.328 490.785 385.257 490.764 385.185 490.764C385.113 490.764 385.042 490.785 384.982 490.824L384.054 491.361C384.023 491.378 383.998 491.403 383.98 491.433C383.962 491.463 383.953 491.497 383.953 491.532C383.953 491.567 383.962 491.601 383.98 491.631C383.998 491.661 384.023 491.686 384.054 491.703L384.998 492.273C385.06 492.308 385.13 492.327 385.201 492.327C385.273 492.327 385.343 492.308 385.405 492.273L386.365 491.719C386.391 491.698 386.412 491.672 386.425 491.641C386.439 491.611 386.445 491.577 386.444 491.544C386.442 491.511 386.433 491.478 386.416 491.449C386.4 491.42 386.377 491.396 386.349 491.377Z",
    fill: "#D3DAED"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M384.12 492.696L383.16 492.126C383.096 492.094 383.027 492.078 382.956 492.078C382.886 492.078 382.816 492.094 382.753 492.126L381.825 492.679C381.798 492.699 381.776 492.725 381.761 492.754C381.746 492.784 381.738 492.817 381.738 492.85C381.738 492.883 381.746 492.916 381.761 492.946C381.776 492.976 381.798 493.001 381.825 493.021L382.769 493.591C382.83 493.63 382.9 493.651 382.972 493.651C383.045 493.651 383.115 493.63 383.176 493.591L384.136 493.037C384.166 493.019 384.19 492.993 384.207 492.962C384.223 492.931 384.231 492.897 384.229 492.862C384.227 492.827 384.216 492.793 384.197 492.764C384.178 492.734 384.151 492.711 384.12 492.696Z",
    fill: "#D3DAED"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M382.093 493.786L381.133 493.233C381.075 493.193 381.007 493.171 380.937 493.171C380.867 493.171 380.799 493.193 380.742 493.233L379.798 493.77C379.767 493.786 379.742 493.811 379.724 493.841C379.707 493.871 379.697 493.906 379.697 493.941C379.697 493.975 379.707 494.01 379.724 494.04C379.742 494.07 379.767 494.094 379.798 494.111L380.726 494.681C380.788 494.717 380.858 494.736 380.929 494.736C381.001 494.736 381.071 494.717 381.133 494.681L382.093 494.111C382.12 494.094 382.142 494.069 382.157 494.041C382.172 494.013 382.18 493.981 382.18 493.949C382.18 493.916 382.172 493.885 382.157 493.856C382.142 493.828 382.12 493.804 382.093 493.786Z",
    fill: "#D3DAED"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_1591_524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.189 297.135L265.249 269.549C266.143 269.029 266.886 268.283 267.403 267.387C267.919 266.49 268.192 265.474 268.194 264.439V188.923C268.192 188.574 268.098 188.231 267.922 187.929C267.746 187.627 267.495 187.376 267.192 187.202C266.889 187.027 266.546 186.935 266.196 186.934C265.847 186.934 265.503 187.025 265.2 187.198L243.189 214.491V297.135Z",
    fill: "url(#paint352_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.189 296.858L264.972 269.419C265.859 268.909 266.595 268.174 267.107 267.288C267.618 266.402 267.887 265.397 267.885 264.374V189.346C267.888 188.997 267.798 188.653 267.624 188.349C267.451 188.046 267.199 187.794 266.896 187.62C266.593 187.446 266.249 187.356 265.899 187.359C265.549 187.362 265.207 187.458 264.907 187.637L243.189 214.735V296.858Z",
    fill: "url(#paint353_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.206 296.582L264.695 269.305C265.572 268.795 266.3 268.063 266.805 267.184C267.311 266.304 267.577 265.307 267.576 264.292V189.818C267.566 189.478 267.469 189.147 267.292 188.857C267.115 188.566 266.866 188.327 266.568 188.163C266.27 187.998 265.935 187.914 265.595 187.919C265.255 187.924 264.923 188.018 264.63 188.191L243.206 215.044V296.582Z",
    fill: "url(#paint354_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.206 296.305L264.419 269.175C265.29 268.672 266.013 267.948 266.516 267.077C267.019 266.205 267.283 265.217 267.283 264.211V190.258C267.272 189.92 267.174 189.592 266.998 189.303C266.822 189.015 266.574 188.778 266.279 188.614C265.984 188.45 265.652 188.365 265.314 188.368C264.977 188.371 264.646 188.461 264.353 188.63L243.206 215.223V296.305Z",
    fill: "url(#paint355_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.206 296.028L264.142 269.093C264.997 268.596 265.708 267.884 266.205 267.027C266.702 266.171 266.966 265.201 266.974 264.211V190.713C266.964 190.379 266.868 190.052 266.695 189.766C266.522 189.479 266.278 189.243 265.986 189.079C265.695 188.915 265.365 188.829 265.031 188.831C264.696 188.832 264.367 188.92 264.077 189.086L243.206 215.467V296.028Z",
    fill: "url(#paint356_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.222 295.752L263.865 268.931C264.717 268.431 265.423 267.718 265.914 266.862C266.405 266.005 266.664 265.035 266.664 264.048V191.153C266.662 190.819 266.571 190.492 266.402 190.205C266.233 189.917 265.991 189.679 265.701 189.514C265.411 189.349 265.083 189.263 264.749 189.265C264.415 189.267 264.088 189.357 263.8 189.525L243.222 215.728V295.752Z",
    fill: "url(#paint357_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.222 295.475L263.572 268.817C264.426 268.32 265.134 267.607 265.626 266.75C266.117 265.893 266.374 264.922 266.371 263.934V191.608C266.367 191.277 266.276 190.953 266.108 190.668C265.94 190.382 265.7 190.146 265.412 189.981C265.125 189.817 264.799 189.731 264.468 189.73C264.137 189.73 263.811 189.817 263.523 189.981L243.222 216.021V295.475Z",
    fill: "url(#paint358_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.222 295.133L263.296 268.621C264.135 268.135 264.832 267.437 265.317 266.598C265.802 265.758 266.059 264.806 266.062 263.837V192.048C266.059 191.72 265.971 191.398 265.805 191.114C265.64 190.83 265.404 190.595 265.119 190.43C264.835 190.266 264.513 190.178 264.184 190.177C263.856 190.175 263.533 190.259 263.247 190.42L243.222 216.216V295.133Z",
    fill: "url(#paint359_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.238 294.922L263.019 268.572C263.849 268.087 264.538 267.394 265.018 266.56C265.498 265.726 265.751 264.782 265.753 263.82V192.504C265.758 192.174 265.676 191.848 265.514 191.561C265.351 191.274 265.116 191.035 264.831 190.869C264.545 190.704 264.221 190.617 263.891 190.618C263.561 190.619 263.238 190.708 262.954 190.876L243.238 216.444V294.922Z",
    fill: "url(#paint360_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.238 294.645L262.742 268.459C263.565 267.976 264.247 267.286 264.721 266.458C265.195 265.63 265.444 264.693 265.444 263.739V192.943C265.451 192.616 265.371 192.293 265.211 192.008C265.052 191.722 264.82 191.484 264.538 191.318C264.256 191.152 263.935 191.065 263.608 191.064C263.281 191.064 262.959 191.151 262.677 191.316L243.238 216.672V294.645Z",
    fill: "url(#paint361_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.238 294.352L262.466 268.312C263.283 267.837 263.961 267.155 264.432 266.335C264.903 265.516 265.151 264.587 265.151 263.641V193.382C265.156 193.058 265.076 192.738 264.917 192.454C264.759 192.171 264.528 191.935 264.249 191.769C263.969 191.604 263.651 191.516 263.326 191.513C263.002 191.511 262.682 191.594 262.4 191.755L243.238 217.014V294.352Z",
    fill: "url(#paint362_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.255 294.075L262.173 268.214C262.985 267.743 263.66 267.067 264.128 266.253C264.597 265.438 264.843 264.515 264.842 263.576V193.838C264.854 193.515 264.779 193.194 264.625 192.909C264.47 192.624 264.242 192.386 263.965 192.22C263.687 192.053 263.369 191.965 263.045 191.963C262.722 191.962 262.403 192.047 262.124 192.211L243.255 217.128V294.075Z",
    fill: "url(#paint363_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.255 293.799L261.896 268.084C262.702 267.621 263.371 266.952 263.834 266.146C264.297 265.339 264.538 264.425 264.532 263.495V194.229C264.532 193.915 264.448 193.607 264.291 193.335C264.134 193.064 263.907 192.838 263.635 192.682C263.363 192.525 263.055 192.443 262.741 192.443C262.427 192.443 262.119 192.526 261.847 192.683L243.255 217.388V293.799Z",
    fill: "url(#paint364_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.255 293.506L261.57 267.954C262.365 267.491 263.025 266.829 263.485 266.032C263.944 265.236 264.188 264.333 264.191 263.413V194.733C264.193 194.42 264.113 194.111 263.957 193.839C263.802 193.567 263.577 193.341 263.306 193.184C263.035 193.027 262.727 192.944 262.413 192.945C262.1 192.945 261.792 193.029 261.522 193.187L243.206 217.6L243.255 293.506Z",
    fill: "url(#paint365_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.271 293.245L261.343 267.84C262.129 267.383 262.781 266.727 263.235 265.939C263.689 265.151 263.929 264.258 263.93 263.348V195.173C263.928 194.863 263.845 194.559 263.69 194.292C263.534 194.024 263.311 193.802 263.043 193.647C262.774 193.492 262.47 193.411 262.161 193.41C261.851 193.409 261.546 193.489 261.277 193.643L243.271 217.941V293.245Z",
    fill: "url(#paint366_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.271 292.969L261.033 267.726C261.811 267.27 262.455 266.618 262.904 265.836C263.352 265.054 263.588 264.168 263.589 263.267V195.612C263.587 195.306 263.506 195.006 263.352 194.742C263.198 194.477 262.977 194.258 262.711 194.106C262.445 193.954 262.144 193.875 261.839 193.877C261.533 193.878 261.232 193.96 260.968 194.115L243.238 218.185L243.271 292.969Z",
    fill: "url(#paint367_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.287 292.692L260.773 267.596C261.549 267.15 262.193 266.508 262.642 265.733C263.09 264.959 263.327 264.08 263.328 263.185V196.068C263.325 195.764 263.243 195.467 263.09 195.205C262.937 194.942 262.718 194.725 262.455 194.574C262.192 194.422 261.893 194.342 261.59 194.342C261.286 194.341 260.988 194.42 260.724 194.571L243.287 218.43V292.692Z",
    fill: "url(#paint368_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.287 292.415L260.496 267.466C261.263 267.021 261.9 266.382 262.343 265.614C262.786 264.846 263.019 263.975 263.019 263.088V196.507C263.02 196.206 262.941 195.91 262.791 195.649C262.641 195.388 262.424 195.171 262.163 195.021C261.902 194.87 261.606 194.792 261.304 194.793C261.003 194.794 260.707 194.874 260.447 195.026L243.287 218.641V292.415Z",
    fill: "url(#paint369_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.287 292.139L260.22 267.352C260.978 266.912 261.607 266.281 262.044 265.521C262.481 264.761 262.711 263.899 262.71 263.023V196.963C262.732 196.658 262.668 196.352 262.525 196.082C262.382 195.811 262.165 195.587 261.9 195.434C261.635 195.281 261.332 195.206 261.026 195.217C260.72 195.229 260.424 195.326 260.171 195.498L243.287 218.918V292.139Z",
    fill: "url(#paint370_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.303 291.878L259.992 267.27C260.748 266.842 261.376 266.219 261.81 265.467C262.245 264.714 262.471 263.859 262.466 262.99V197.484C262.482 197.182 262.415 196.882 262.271 196.617C262.127 196.352 261.913 196.132 261.651 195.981C261.389 195.831 261.091 195.757 260.789 195.766C260.488 195.776 260.195 195.869 259.943 196.035L243.352 219.243L243.303 291.878Z",
    fill: "url(#paint371_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.303 291.569L259.666 267.157C260.411 266.726 261.03 266.107 261.458 265.361C261.887 264.615 262.111 263.769 262.107 262.909V197.809C262.12 197.513 262.052 197.219 261.909 196.959C261.767 196.699 261.556 196.482 261.3 196.333C261.043 196.184 260.751 196.108 260.455 196.113C260.158 196.118 259.869 196.203 259.617 196.361L243.303 219.373V291.569Z",
    fill: "url(#paint372_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.303 291.292L259.406 266.994C260.138 266.564 260.745 265.95 261.167 265.214C261.59 264.478 261.813 263.644 261.815 262.795V198.297C261.819 198.006 261.746 197.719 261.602 197.466C261.458 197.213 261.248 197.004 260.996 196.859C260.743 196.714 260.456 196.64 260.165 196.644C259.874 196.648 259.589 196.73 259.341 196.882L243.32 219.666L243.303 291.292Z",
    fill: "url(#paint373_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.32 291.016L259.097 266.88C259.821 266.451 260.422 265.841 260.841 265.111C261.26 264.381 261.483 263.555 261.489 262.714V198.737C261.487 198.452 261.411 198.173 261.267 197.927C261.124 197.681 260.918 197.476 260.671 197.335C260.424 197.193 260.144 197.119 259.859 197.119C259.574 197.12 259.294 197.195 259.048 197.337L243.32 219.911V291.016Z",
    fill: "url(#paint374_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.32 290.739L258.82 266.75C259.55 266.328 260.155 265.72 260.572 264.988C260.99 264.256 261.205 263.426 261.196 262.583V199.111C261.193 198.829 261.116 198.552 260.973 198.308C260.831 198.064 260.627 197.862 260.382 197.721C260.138 197.579 259.86 197.504 259.578 197.503C259.295 197.501 259.017 197.573 258.771 197.712L243.32 220.073V290.739Z",
    fill: "url(#paint375_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.32 290.462L258.543 266.636C259.257 266.22 259.85 265.623 260.261 264.906C260.672 264.19 260.888 263.377 260.887 262.551V199.632C260.875 199.357 260.794 199.089 260.651 198.854C260.508 198.619 260.307 198.424 260.068 198.288C259.829 198.151 259.56 198.077 259.284 198.073C259.009 198.069 258.737 198.135 258.494 198.265L243.32 220.399V290.462Z",
    fill: "url(#paint376_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.336 290.251L258.267 266.571C258.971 266.162 259.555 265.576 259.96 264.87C260.366 264.165 260.579 263.365 260.578 262.551V200.088C260.563 199.817 260.482 199.555 260.341 199.324C260.199 199.093 260.003 198.9 259.768 198.765C259.534 198.629 259.269 198.554 258.999 198.546C258.728 198.538 258.459 198.598 258.218 198.721L243.336 220.643V290.251Z",
    fill: "url(#paint377_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.336 289.909L257.99 266.392C258.687 265.985 259.266 265.403 259.669 264.704C260.071 264.004 260.284 263.211 260.285 262.404V200.56C260.267 200.293 260.183 200.035 260.042 199.808C259.9 199.581 259.705 199.392 259.474 199.259C259.242 199.125 258.981 199.051 258.714 199.042C258.446 199.033 258.181 199.091 257.941 199.209L243.336 220.92V289.909Z",
    fill: "url(#paint378_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.352 289.632L257.778 266.261C258.472 265.865 259.049 265.291 259.449 264.599C259.849 263.908 260.059 263.122 260.057 262.323V200.967C260.035 200.703 259.95 200.449 259.809 200.226C259.667 200.003 259.473 199.818 259.244 199.687C259.015 199.556 258.758 199.482 258.494 199.472C258.23 199.463 257.968 199.518 257.73 199.632L243.434 221.147L243.352 289.632Z",
    fill: "url(#paint379_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.352 289.339L257.42 266.148C258.104 265.751 258.672 265.181 259.066 264.495C259.46 263.81 259.667 263.032 259.666 262.242V201.422C259.665 201.154 259.594 200.891 259.459 200.66C259.324 200.428 259.131 200.236 258.898 200.102C258.666 199.969 258.403 199.899 258.135 199.899C257.867 199.899 257.604 199.97 257.371 200.104L243.352 221.392V289.339Z",
    fill: "url(#paint380_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.352 289.063L257.144 266.034C257.821 265.639 258.383 265.073 258.774 264.394C259.166 263.714 259.372 262.944 259.373 262.16V201.862C259.373 201.596 259.302 201.334 259.168 201.104C259.034 200.874 258.842 200.684 258.611 200.552C258.38 200.42 258.118 200.351 257.852 200.352C257.586 200.354 257.324 200.425 257.095 200.56L243.352 221.717V289.063Z",
    fill: "url(#paint381_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.368 288.786L256.802 265.903C257.47 265.514 258.025 264.955 258.411 264.284C258.796 263.613 258.999 262.853 258.999 262.079V202.366C259 202.103 258.931 201.844 258.8 201.616C258.669 201.387 258.48 201.198 258.253 201.066C258.025 200.933 257.766 200.864 257.503 200.864C257.24 200.863 256.981 200.933 256.753 201.064L243.368 221.896V288.786Z",
    fill: "url(#paint382_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.368 288.509L256.59 265.724C257.248 265.337 257.793 264.785 258.173 264.123C258.552 263.461 258.753 262.712 258.755 261.949V202.757C258.757 202.497 258.69 202.242 258.56 202.017C258.431 201.792 258.244 201.605 258.019 201.476C257.794 201.347 257.538 201.28 257.279 201.282C257.019 201.284 256.765 201.355 256.541 201.487L243.368 222.124V288.509Z",
    fill: "url(#paint383_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.368 288.233L256.297 265.659C256.951 265.282 257.494 264.738 257.872 264.084C258.249 263.43 258.447 262.688 258.446 261.932V203.213C258.449 202.956 258.384 202.703 258.258 202.479C258.131 202.256 257.948 202.07 257.726 201.941C257.504 201.812 257.252 201.744 256.995 201.744C256.738 201.745 256.486 201.813 256.265 201.943L243.368 222.368V288.233Z",
    fill: "url(#paint384_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.385 287.956L256.021 265.545C256.668 265.17 257.206 264.631 257.58 263.983C257.954 263.334 258.151 262.599 258.153 261.851V203.652C258.152 203.399 258.084 203.151 257.958 202.932C257.831 202.713 257.649 202.531 257.43 202.404C257.211 202.278 256.963 202.21 256.71 202.209C256.457 202.208 256.208 202.274 255.988 202.399L243.385 222.628V287.956Z",
    fill: "url(#paint385_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.385 287.679L255.744 265.415C256.373 265.039 256.892 264.504 257.249 263.864C257.606 263.225 257.788 262.502 257.778 261.77V204.091C257.775 203.842 257.706 203.597 257.579 203.382C257.452 203.167 257.271 202.989 257.054 202.866C256.837 202.742 256.591 202.678 256.341 202.679C256.092 202.68 255.846 202.746 255.63 202.871L243.385 222.873V287.679Z",
    fill: "url(#paint386_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.385 287.403L255.467 265.301C256.098 264.933 256.622 264.405 256.984 263.771C257.347 263.137 257.537 262.419 257.534 261.688V204.547C257.537 204.298 257.474 204.053 257.351 203.837C257.228 203.62 257.05 203.441 256.834 203.317C256.619 203.192 256.374 203.128 256.125 203.129C255.876 203.131 255.632 203.199 255.418 203.326L243.385 223.117V287.403Z",
    fill: "url(#paint387_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.401 287.126L255.207 265.171C255.832 264.81 256.351 264.29 256.711 263.665C257.071 263.039 257.26 262.329 257.258 261.607V204.986C257.256 204.741 257.191 204.501 257.067 204.289C256.944 204.078 256.767 203.902 256.554 203.78C256.342 203.658 256.101 203.594 255.856 203.595C255.611 203.595 255.37 203.66 255.158 203.782L243.352 223.312L243.401 287.126Z",
    fill: "url(#paint388_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.401 286.849L254.914 265.057C255.528 264.699 256.038 264.185 256.392 263.569C256.746 262.952 256.932 262.253 256.932 261.542V205.442C256.932 205.2 256.869 204.962 256.749 204.752C256.628 204.542 256.454 204.367 256.245 204.245C256.036 204.123 255.798 204.058 255.556 204.057C255.314 204.056 255.076 204.118 254.865 204.238L243.401 223.605V286.849Z",
    fill: "url(#paint389_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.401 286.556L254.621 264.927C255.23 264.576 255.735 264.07 256.086 263.462C256.438 262.853 256.623 262.163 256.623 261.46V205.882C256.624 205.643 256.562 205.409 256.443 205.202C256.324 204.995 256.153 204.823 255.946 204.704C255.74 204.585 255.505 204.523 255.267 204.524C255.028 204.525 254.794 204.589 254.588 204.71L243.401 223.849V286.556Z",
    fill: "url(#paint390_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.417 286.28L254.344 264.813C254.946 264.464 255.446 263.963 255.794 263.36C256.143 262.758 256.327 262.075 256.33 261.379V206.321C256.327 206.086 256.262 205.856 256.143 205.654C256.024 205.452 255.854 205.284 255.65 205.168C255.447 205.051 255.216 204.989 254.981 204.989C254.747 204.989 254.516 205.05 254.312 205.165L243.417 224.093V286.28Z",
    fill: "url(#paint391_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.417 286.003L254.068 264.699C254.661 264.351 255.153 263.854 255.496 263.258C255.838 262.661 256.019 261.985 256.021 261.298V206.777C256.021 206.542 255.959 206.312 255.842 206.11C255.725 205.907 255.556 205.738 255.353 205.621C255.15 205.504 254.92 205.442 254.686 205.442C254.452 205.442 254.222 205.504 254.019 205.621L243.417 224.354V286.003Z",
    fill: "url(#paint392_linear_1591_524)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.434 285.726L253.791 264.569C254.377 264.227 254.862 263.737 255.199 263.149C255.536 262.561 255.713 261.894 255.711 261.216V207.249C255.712 207.018 255.652 206.791 255.537 206.592C255.421 206.392 255.255 206.227 255.054 206.113C254.854 205.998 254.627 205.939 254.397 205.942C254.166 205.944 253.94 206.008 253.742 206.126L243.434 224.63V285.726Z",
    fill: "url(#paint393_linear_1591_524)",
    fillOpacity: 0.1
  }))), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M154.969 260.142L256.232 201.812C256.519 201.648 256.845 201.562 257.176 201.562C257.507 201.562 257.833 201.648 258.12 201.813C258.408 201.977 258.648 202.214 258.816 202.499C258.984 202.784 259.075 203.109 259.08 203.44V275.44C259.087 276.429 258.832 277.402 258.34 278.26C257.849 279.118 257.138 279.829 256.28 280.322L155.034 339.075C154.746 339.243 154.419 339.333 154.085 339.335C153.752 339.337 153.423 339.251 153.133 339.086C152.843 338.921 152.602 338.683 152.432 338.396C152.263 338.108 152.173 337.781 152.17 337.447V265.008C152.172 264.023 152.431 263.056 152.922 262.202C153.413 261.349 154.119 260.638 154.969 260.142Z",
    fill: "#110B2B"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M154.611 339.075V266.635C154.61 265.648 154.868 264.677 155.359 263.82C155.85 262.964 156.558 262.251 157.41 261.753L258.673 203.423C258.79 203.353 258.916 203.298 259.047 203.261C259.018 202.946 258.91 202.644 258.734 202.382C258.558 202.12 258.319 201.907 258.039 201.761C257.759 201.615 257.446 201.542 257.131 201.548C256.815 201.554 256.506 201.639 256.232 201.796L154.969 260.142C154.116 260.64 153.409 261.352 152.918 262.209C152.427 263.066 152.169 264.036 152.17 265.024V337.447C152.171 337.745 152.242 338.038 152.377 338.304C152.513 338.569 152.71 338.798 152.951 338.972C153.192 339.147 153.471 339.262 153.766 339.308C154.06 339.354 154.361 339.33 154.644 339.238C154.625 339.185 154.614 339.13 154.611 339.075Z",
    fill: "url(#paint394_linear_1591_524)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M157.197 285.921L252.731 231.465V233.597L157.197 288.036V285.921ZM157.197 277.913L175.555 267.465V264.21L157.23 274.642L157.197 277.913ZM157.393 297.329L252.894 242.874V240.742L157.393 295.132V297.329ZM157.588 306.606L253.105 252.167V250.034L157.555 304.474L157.588 306.606ZM157.783 315.883L253.301 261.443V259.311L157.751 313.767L157.783 315.883ZM157.783 325.29L212.011 294.367V292.235L157.751 323.158L157.783 325.29Z",
    fill: "#5A3CFF"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M233.029 535.464V540.883C233.026 541.542 232.852 542.188 232.524 542.759C232.196 543.33 231.725 543.805 231.157 544.138L230.425 544.659C228.863 545.568 227.094 546.06 225.287 546.089C223.48 546.117 221.696 545.681 220.107 544.822L210.586 539.63C210.331 539.49 210.119 539.283 209.972 539.033C209.824 538.782 209.746 538.497 209.746 538.206C209.746 537.916 209.824 537.63 209.972 537.38C210.119 537.129 210.331 536.923 210.586 536.782C212.392 535.741 214.557 534.162 216.526 534.406C217.435 534.569 218.354 534.666 219.276 534.699L223.703 535.301L233.029 535.464Z",
    fill: "black"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M210.583 538.393L220.153 543.569C221.741 544.43 223.524 544.87 225.331 544.844C227.138 544.818 228.908 544.329 230.471 543.422L231.204 542.885C231.774 542.554 232.246 542.08 232.575 541.508C232.903 540.937 233.076 540.289 233.075 539.63V540.884C233.073 541.542 232.899 542.188 232.571 542.759C232.242 543.33 231.771 543.805 231.204 544.138L230.471 544.659C228.909 545.568 227.14 546.06 225.333 546.089C223.527 546.117 221.743 545.681 220.153 544.822L210.583 539.63C210.232 539.437 209.965 539.12 209.833 538.742C209.701 538.364 209.713 537.95 209.867 537.58C210.006 537.925 210.259 538.212 210.583 538.393Z",
    fill: "#363650"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M217.596 537.857L216.473 537.303L217.807 534.602C218.255 534.658 218.706 534.691 219.158 534.699L217.596 537.857Z",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M219.861 538.394L218.738 537.857L220.236 534.846L221.538 535.025L219.861 538.394Z",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M217.513 546.352V551.771C217.511 552.43 217.337 553.076 217.008 553.647C216.68 554.218 216.209 554.693 215.642 555.026L214.909 555.547C213.344 556.456 211.572 556.948 209.763 556.977C207.954 557.005 206.167 556.569 204.575 555.71L195.021 550.518C194.767 550.378 194.555 550.171 194.407 549.921C194.26 549.67 194.182 549.385 194.182 549.094C194.182 548.804 194.26 548.518 194.407 548.268C194.555 548.017 194.767 547.811 195.021 547.67C196.828 546.629 198.992 545.05 200.945 545.31C201.861 545.459 202.785 545.551 203.712 545.587L208.139 546.189L217.513 546.352Z",
    fill: "black"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M195.021 549.281L204.574 554.457C206.164 555.323 207.95 555.764 209.761 555.739C211.571 555.713 213.344 555.221 214.909 554.31L215.641 553.773C216.212 553.444 216.686 552.969 217.015 552.397C217.343 551.826 217.515 551.178 217.513 550.518V551.755C217.51 552.414 217.336 553.06 217.008 553.631C216.68 554.201 216.209 554.677 215.641 555.01L214.909 555.531C213.344 556.44 211.572 556.932 209.763 556.96C207.953 556.989 206.167 556.553 204.574 555.694L195.021 550.502C194.67 550.308 194.403 549.992 194.271 549.614C194.139 549.235 194.151 548.821 194.305 548.451C194.44 548.803 194.693 549.096 195.021 549.281Z",
    fill: "#363650"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M228.37 541.242C229.019 541.229 229.659 541.082 230.25 540.811C230.84 540.54 231.369 540.151 231.802 539.667C232.236 539.183 232.565 538.615 232.77 537.998C232.975 537.382 233.05 536.73 232.992 536.083L231.364 503.533L233.529 468.086C233.529 467.409 233.395 466.739 233.136 466.114C232.876 465.489 232.496 464.922 232.017 464.444C231.538 463.966 230.969 463.587 230.343 463.33C229.717 463.072 229.047 462.941 228.37 462.943C225.522 462.943 219.988 465.238 219.988 468.086L223.243 536.115C223.248 537.473 223.789 538.775 224.75 539.735C225.71 540.696 227.012 541.237 228.37 541.242Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M212.335 552.276C213.7 552.272 215.008 551.726 215.972 550.759C216.936 549.792 217.478 548.482 217.478 547.117L216.811 512.289L220.716 479.088C220.716 476.24 215.167 473.929 212.335 473.929C211.657 473.929 210.987 474.062 210.361 474.321C209.735 474.581 209.166 474.961 208.687 475.44C208.208 475.919 207.828 476.488 207.568 477.113C207.309 477.739 207.176 478.41 207.176 479.088V547.117C207.176 548.485 207.719 549.797 208.687 550.765C209.654 551.732 210.967 552.276 212.335 552.276Z",
    fill: "white"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M231.899 462.211L234.112 478.6C234.11 479.616 233.841 480.613 233.333 481.493C232.824 482.372 232.094 483.103 231.215 483.612L217.789 491.148C216.969 491.634 216.035 491.895 215.082 491.903C214.129 491.91 213.191 491.665 212.363 491.192C211.536 490.719 210.849 490.034 210.372 489.209C209.896 488.383 209.647 487.446 209.651 486.493V453.243C209.651 451.177 205.338 452.592 207.128 451.616L225.975 440.728C229.62 438.612 231.899 458.061 231.899 462.211Z",
    fill: "url(#paint395_linear_1591_524)"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.717 462.764C227.438 463.032 227.215 463.353 227.059 463.707C226.904 464.062 226.821 464.443 226.813 464.83C226.806 465.217 226.874 465.602 227.015 465.962C227.157 466.322 227.367 466.651 227.636 466.93C227.912 467.211 228.241 467.435 228.604 467.589C228.967 467.742 229.357 467.823 229.751 467.825C230.517 467.826 231.252 467.528 231.802 466.995L235.057 463.854C235.057 462.976 234.927 462.227 234.894 461.95C234.683 459.948 234.634 457.93 234.569 455.928C234.164 456.467 233.718 456.973 233.234 457.442L227.717 462.764Z",
    fill: "#231F20"
  }))), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M220.46 431.679C221.238 431.675 221.983 431.363 222.532 430.811C223.081 430.259 223.389 429.512 223.389 428.734V417.195C223.419 416.79 223.366 416.384 223.232 416.002C223.098 415.619 222.886 415.269 222.611 414.972C222.335 414.675 222.001 414.438 221.629 414.276C221.258 414.114 220.857 414.03 220.452 414.03C220.046 414.03 219.645 414.114 219.274 414.276C218.902 414.438 218.568 414.675 218.293 414.972C218.017 415.269 217.805 415.619 217.672 416.002C217.538 416.384 217.484 416.79 217.514 417.195V428.75C217.518 429.528 217.831 430.273 218.383 430.822C218.934 431.371 219.681 431.679 220.46 431.679Z",
    fill: "#F2B1B5"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M223.096 428.163H218.213C215.658 428.163 213.207 427.148 211.4 425.341C209.594 423.535 208.579 421.084 208.579 418.529V408.568H223.096V428.098V428.163Z",
    fill: "#F2B1B5"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M209.67 408.552V418.822C209.67 421.321 210.663 423.718 212.43 425.485C214.197 427.252 216.594 428.245 219.093 428.245H218.019C215.52 428.245 213.123 427.252 211.356 425.485C209.588 423.718 208.596 421.321 208.596 418.822V408.634L209.67 408.552Z",
    fill: "#F5C5C8"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M205.294 404.679C205.447 404.299 205.675 403.953 205.964 403.664C206.254 403.374 206.6 403.146 206.98 402.994C207.36 402.842 207.768 402.769 208.177 402.778C208.587 402.788 208.99 402.881 209.363 403.052C210.144 403.459 210.697 403.67 211.462 403.198C212.471 402.58 212.732 402.189 214.099 402.384C214.652 402.384 215.385 402.938 215.905 402.921C217.012 402.921 217.728 402.026 219.03 402.417C219.714 402.702 220.466 402.781 221.195 402.645C221.887 402.516 222.602 402.578 223.262 402.824C224.58 403.361 224.499 404.337 225.264 405.232C226.028 406.128 226.81 405.493 227.558 406.193C227.879 406.501 228.098 406.9 228.185 407.337C228.272 407.773 228.224 408.226 228.047 408.634C227.868 409.008 227.575 409.415 227.737 409.806C227.9 410.196 228.144 410.213 228.356 410.424C229.104 411.189 228.502 412.459 227.916 413.354C227.785 413.521 227.711 413.727 227.705 413.94C227.749 414.211 227.887 414.459 228.095 414.639C228.472 415.172 228.644 415.823 228.578 416.472C228.512 417.121 228.213 417.725 227.737 418.171C227.282 418.562 226.647 418.871 226.566 419.473C226.548 419.806 226.604 420.14 226.728 420.45C226.877 421.078 226.814 421.737 226.549 422.326C226.284 422.914 225.832 423.399 225.264 423.704C223.929 424.372 225.15 426.78 223.099 426.959C221.471 427.122 220.023 425.12 219.681 423.704C219.681 423.9 218.64 423.346 218.558 423.232C218.312 422.829 218.147 422.381 218.07 421.914C217.775 421.069 217.6 420.187 217.549 419.294C217.549 418.952 217.549 415.193 217.24 415.176C216.528 415.203 215.818 415.103 215.141 414.883C213.513 414.265 214.229 413.256 213.627 412.133C213.334 411.596 212.651 411.482 212.325 410.929C212.049 410.287 211.986 409.574 212.146 408.894C210.67 409.334 209.098 409.334 207.622 408.894C206.515 408.422 204.952 407.625 204.92 406.274C204.92 405.721 205.048 405.175 205.294 404.679Z",
    fill: "black"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M205.294 404.679C205.566 404.017 206.057 403.468 206.685 403.124C207.313 402.781 208.04 402.663 208.745 402.791C208.261 402.928 207.813 403.167 207.431 403.493C207.049 403.819 206.742 404.224 206.531 404.679C206.287 405.187 206.159 405.743 206.157 406.307C206.157 407.658 207.784 408.455 208.859 408.927C209.263 409.095 209.692 409.199 210.128 409.236C209.28 409.333 208.421 409.227 207.622 408.927C206.515 408.455 204.953 407.658 204.92 406.307C204.915 405.742 205.043 405.185 205.294 404.679Z",
    fill: "#EF9EA3"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M213.949 416.934C213.949 417.356 214.074 417.768 214.309 418.119C214.543 418.469 214.876 418.742 215.265 418.904C215.655 419.065 216.084 419.107 216.497 419.025C216.911 418.943 217.291 418.74 217.589 418.442C217.887 418.143 218.09 417.764 218.172 417.35C218.255 416.936 218.212 416.508 218.051 416.118C217.89 415.729 217.616 415.396 217.266 415.161C216.915 414.927 216.503 414.802 216.081 414.802C215.516 414.802 214.973 415.027 214.574 415.426C214.174 415.826 213.949 416.369 213.949 416.934Z",
    fill: "#F2B1B5"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M202.09 548.744L200.967 548.191L202.301 545.489C202.743 545.554 203.189 545.587 203.636 545.587L202.09 548.744Z",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M204.342 549.298L203.219 548.744L204.716 545.733L206.002 545.912L204.342 549.298Z",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M213.335 444.748H213.254L198.46 444.26C195.989 444.175 193.583 443.451 191.475 442.159C189.367 440.867 187.63 439.051 186.433 436.887L175.513 417.194C175.162 416.517 175.09 415.729 175.312 414.999C175.533 414.269 176.031 413.654 176.699 413.285C177.366 412.916 178.152 412.822 178.888 413.024C179.624 413.225 180.252 413.705 180.639 414.363L191.56 434.12C192.267 435.396 193.292 436.466 194.535 437.227C195.779 437.989 197.198 438.416 198.655 438.466L213.433 438.954C214.21 438.967 214.95 439.288 215.49 439.847C216.03 440.405 216.327 441.155 216.314 441.932C216.301 442.709 215.98 443.449 215.421 443.989C214.863 444.53 214.112 444.826 213.335 444.813V444.748Z",
    fill: "#F2B1B5"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M229.754 467.777C230.519 467.777 231.254 467.48 231.804 466.947L237.305 461.625C239.319 459.684 240.896 457.336 241.932 454.738C242.968 452.141 243.44 449.352 243.315 446.558C243.19 443.764 242.472 441.028 241.209 438.533C239.945 436.038 238.165 433.84 235.987 432.086L229.884 427.204C229.272 426.772 228.52 426.59 227.779 426.693C227.038 426.796 226.364 427.178 225.894 427.76C225.424 428.341 225.193 429.08 225.248 429.827C225.303 430.573 225.639 431.27 226.189 431.777L232.292 436.659C233.822 437.89 235.071 439.433 235.959 441.184C236.846 442.936 237.35 444.856 237.438 446.817C237.525 448.778 237.195 450.736 236.468 452.559C235.74 454.383 234.633 456.031 233.22 457.394L227.719 462.764C227.44 463.032 227.217 463.353 227.062 463.708C226.907 464.062 226.823 464.444 226.815 464.831C226.808 465.218 226.876 465.602 227.018 465.963C227.159 466.323 227.369 466.652 227.638 466.931C228.204 467.481 228.964 467.785 229.754 467.777Z",
    fill: "url(#paint396_linear_1591_524)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M233.707 435.91L232.682 451.778C233.024 455.147 232.91 458.532 233.251 461.901C233.447 463.854 234.521 476.321 234.13 478.176C233.87 479.381 230.534 482.033 226.074 484.361C225.667 484.572 225.261 474.221 224.821 474.417C224.382 474.612 224.04 485.353 223.633 485.533C217.969 488.071 211.215 489.699 206.642 487.502L207.179 468.118L206.235 456.026C205.698 447.791 204.071 436.724 212.208 431.646L213.266 431.028L221.94 426.292C222.947 425.717 224.085 425.414 225.244 425.414C226.403 425.414 227.542 425.717 228.548 426.292C230.219 427.255 231.587 428.666 232.498 430.366C233.41 432.065 233.829 433.986 233.707 435.91Z",
    fill: "url(#paint397_linear_1591_524)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M213.236 445.073L198.442 444.585C195.921 444.492 193.466 443.75 191.316 442.429C189.166 441.109 187.394 439.256 186.171 437.05L177.496 421.247C177.077 420.491 176.976 419.601 177.214 418.77C177.452 417.94 178.01 417.239 178.766 416.82C179.521 416.401 180.412 416.3 181.242 416.538C182.072 416.776 182.774 417.334 183.192 418.089L191.867 433.909C192.549 435.131 193.535 436.157 194.73 436.886C195.924 437.616 197.287 438.026 198.686 438.075L213.48 438.563C214.343 438.578 215.165 438.936 215.765 439.557C216.365 440.178 216.693 441.012 216.678 441.875C216.663 442.738 216.305 443.56 215.684 444.16C215.063 444.76 214.229 445.088 213.366 445.073H213.236Z",
    fill: "url(#paint398_linear_1591_524)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M180.997 416.039C180.863 416.116 180.704 416.137 180.554 416.098C180.405 416.058 180.277 415.961 180.199 415.828L176.602 409.545C176.565 409.48 176.54 409.408 176.53 409.334C176.52 409.259 176.526 409.183 176.545 409.111C176.565 409.038 176.599 408.97 176.645 408.911C176.691 408.851 176.748 408.801 176.814 408.764C176.948 408.687 177.107 408.666 177.256 408.706C177.406 408.745 177.533 408.843 177.611 408.976L181.289 415.242C181.325 415.313 181.345 415.391 181.349 415.47C181.354 415.549 181.342 415.629 181.314 415.703C181.287 415.778 181.244 415.846 181.19 415.904C181.135 415.962 181.069 416.008 180.997 416.039Z",
    fill: "#F2B1B5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1591_524",
    x: 226.283,
    y: 250.026,
    width: 272.643,
    height: 170.729,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_1591_524"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1591_524",
    x: 497.055,
    y: 222.128,
    width: 40.7109,
    height: 27.6908,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1591_524"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1591_524",
    x: 521.131,
    y: 208.131,
    width: 40.7109,
    height: 27.7072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1591_524"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1591_524",
    x: 545.529,
    y: 194.525,
    width: 40.7266,
    height: 27.6908,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1591_524"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1591_524",
    x: 386.131,
    y: 14.528,
    width: 71.6953,
    height: 143.452,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_1591_524"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1591_524",
    x: 591.309,
    y: 310.588,
    width: 143.814,
    height: 126.056,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_1591_524"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_1591_524",
    x: 306.844,
    y: 154.759,
    width: 149.539,
    height: 184.077,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_1591_524"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_1591_524",
    x: 315.193,
    y: 453.393,
    width: 137.16,
    height: 120.456,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_1591_524"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_1591_524",
    x: 228.189,
    y: 171.934,
    width: 55.0039,
    height: 140.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_1591_524"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1591_524",
    x1: 734.2,
    y1: 382.083,
    x2: 538.651,
    y2: 115.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1591_524",
    x1: 441.289,
    y1: 191.089,
    x2: 241.287,
    y2: 191.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99A7D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_1591_524",
    x1: 564.442,
    y1: 241.843,
    x2: 539.911,
    y2: 208.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_1591_524",
    x1: 588.518,
    y1: 227.86,
    x2: 563.958,
    y2: 194.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_1591_524",
    x1: 612.95,
    y1: 214.24,
    x2: 588.423,
    y2: 180.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint169_radial_1591_524",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(604.5 188.749) scale(24.7867 12.8891)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C629E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#7A7FB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A3A6C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C4C6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#DEDFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F0F1F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FBFCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint170_radial_1591_524",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.8341 584.531) rotate(180) scale(16.2098 8.7533)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#48486A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#505070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#8D8DA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#BEBECA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E2E2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F7F7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint171_radial_1591_524",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.839 574.011) rotate(180) scale(17.3002 9.34214)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#48486A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#505070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#8D8DA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#BEBECA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E2E2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F7F7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint172_radial_1591_524",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(122.049 562.032) rotate(180) scale(16.2098 8.75329)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#48486A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#505070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#8D8DA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#BEBECA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E2E2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F7F7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_1591_524",
    x1: 416.01,
    y1: 33.4185,
    x2: 504.649,
    y2: 59.1919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_1591_524",
    x1: 488.015,
    y1: 75.3749,
    x2: 407.52,
    y2: 75.3749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99A7D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_1591_524",
    x1: 190.781,
    y1: 380.073,
    x2: 155.562,
    y2: 380.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3DAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99A7D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_1591_524",
    x1: 837.518,
    y1: 405.486,
    x2: 697.85,
    y2: 274.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_1591_524",
    x1: 593.98,
    y1: 349.699,
    x2: 732.401,
    y2: 349.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99A7D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_1591_524",
    x1: 675.199,
    y1: 330.63,
    x2: 707.602,
    y2: 333.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_1591_524",
    x1: 680.586,
    y1: 315.769,
    x2: 710.013,
    y2: 316.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_1591_524",
    x1: 653.494,
    y1: 326.511,
    x2: 721.964,
    y2: 287.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint294_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint296_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint297_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint303_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint304_linear_1591_524",
    x1: 564.683,
    y1: 297.918,
    x2: 364.502,
    y2: 175.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint305_linear_1591_524",
    x1: 335.023,
    y1: 249.809,
    x2: 441.901,
    y2: 249.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99A7D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE9EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint306_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint307_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint308_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint309_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint310_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint312_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint313_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint314_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint315_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint316_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint317_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint318_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint319_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint320_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint321_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint322_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint323_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint324_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint325_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint326_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint327_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint328_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint329_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint330_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint331_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint332_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint333_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint334_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint335_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint336_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint337_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint338_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint339_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint340_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint341_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint342_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint343_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint344_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint345_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint346_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint347_linear_1591_524",
    x1: 547.884,
    y1: 543.633,
    x2: 416.361,
    y2: 420.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint348_linear_1591_524",
    x1: 318.596,
    y1: 491.035,
    x2: 448.974,
    y2: 491.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99A7D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint349_linear_1591_524",
    x1: 416.08,
    y1: 489.945,
    x2: 440.325,
    y2: 492.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint350_linear_1591_524",
    x1: 394.117,
    y1: 472.124,
    x2: 366.645,
    y2: 472.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBE9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99A7D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint351_linear_1591_524",
    x1: 412.243,
    y1: 488.887,
    x2: 367.39,
    y2: 488.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99A7D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint352_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint353_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint354_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint355_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint356_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint357_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint358_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint359_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint360_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint361_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint362_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint363_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint364_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint365_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint366_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint367_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint368_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint369_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint370_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint371_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint372_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint373_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint374_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint375_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint376_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint377_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint378_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint379_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint380_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint381_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint382_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint383_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint384_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint385_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint386_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint387_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint388_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint389_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint390_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint391_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint392_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint393_linear_1591_524",
    x1: 136.531,
    y1: 365.115,
    x2: 265.103,
    y2: 187.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A3CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint394_linear_1591_524",
    x1: 152.17,
    y1: 270.444,
    x2: 259.047,
    y2: 270.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99A7D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE9EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint395_linear_1591_524",
    x1: 206.693,
    y1: 440.568,
    x2: 235.157,
    y2: 441.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint396_linear_1591_524",
    x1: 177.088,
    y1: 416.412,
    x2: 245.801,
    y2: 418.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint397_linear_1591_524",
    x1: 177.088,
    y1: 416.412,
    x2: 245.801,
    y2: 418.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint398_linear_1591_524",
    x1: 177.088,
    y1: 416.412,
    x2: 245.801,
    y2: 418.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0578B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackendImage);
export default __webpack_public_path__ + "static/media/backend_image.c7db39d48db2ee33910505baf44a6728.svg";
export { ForwardRef as ReactComponent };